import Vue from 'vue'
import axios from 'axios'
import { Loading } from 'element-ui'
import { tfMessage } from '@/common/js/message-tf.js'
import path from './port.js'
import tool from './tool'
import router from '../../router'
import i18n from '@/locale/i18n'
import API from './api-config'
import { describe } from './constant'
import attenQuery from '@/frontend/attendanceNew/query.js'
import statisticAnalysis from '@/frontend/statistic_analysis/query.js' // 数据分析
import { deleteCodeLiteCookie, getEnv } from '@jcy/shared'
const _this = new Vue()
/**
 * 打包时修改 API.config 即可
 */
// 先保留
// const URLConfig = API.config(process.env.HOST_ENV)
const URLConfig = API.config()
const baseURL = URLConfig.baseURL
const wsURL = URLConfig.wsURL
const cloudURL = URLConfig.cloudURL
const fileURL = URLConfig.fileURL
const integrationUrl = URLConfig.integrationUrl

const options = {
  lock: true,
  text: 'Loading',
  background: 'rgba(0, 0, 0, 0.4)'
}
// 请求和接收拦截处理
axios.interceptors.request.use(function (config) {
  tool.handleRosterAttenAuth(config)
  return config
})
axios.interceptors.response.use(function (response) {
  tool.hanldeResponseUnzip(response)
  return response
})
let overdueNum = 0
/****
 * @params
 *  params // 传递的数据
 *  url  // 接口地址
 *  mask // 遮罩层，不用遮罩层不用传或者false，若使用字符串用于文字显示，如 '保存中...'
 */
function ajaxGet(url, params, mask, urlType, delayTime) {
  // urlType (1-默认，2-接口集成接口)
  let loadingInstance = ''
  if (mask && Loading) {
    loadingInstance = Loading.service(options)
  }
  let promise = new Promise((resolve, reject) => {
    let processTime = new Date().getTime()
    let requestHeader = JSON.parse(localStorage.getItem('requestHeader'))
    requestHeader.SIGN = tool.Encrypt()
    tool.encryptionTnterface(params, url) // 处理接口加密
    axios({
      method: 'get',
      url: url,
      baseURL: urlType === 2 ? integrationUrl : baseURL,
      params: params,
      headers: requestHeader
    })
      .then(res => {
        if (loadingInstance) {
          const currentTime = new Date().getTime()
          _this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭

            if (currentTime - processTime < delayTime && delayTime) {
              setTimeout(() => {
                loadingInstance.close()
              }, delayTime - (currentTime - processTime))
            } else {
              loadingInstance.close()
            }
          })
        }
        if (res.data) {
          if (
            res.data.response.code === 'common.sucess' ||
            res.data.response.code === 'common.success' ||
            (res.data.response.code + '' === '1001' &&
              (url === 'layoutField/findList' || url === 'projectLayout/getAllLayoutBack'))
          ) {
            const isbizflowDelete = url === 'bizflow/getBizflow' && res.data.data.delete === 1
            // 2022-07-11 处理某些接口需要压缩传参功能
            res.data.data = tool.judgeZipOrUnzip(res.data.data, url, 1)
            if (isbizflowDelete) {
              res.data.data.delete = 1
            }

            if (url === 'layout/getRosterSetting') {
              // 花名册-教育经历/工作经历分栏里的日期组件改为年月格式
              res.data.data = tool.handleSetStaffDatetime(res.data.data, params)
            }

            if (res.data.hasOwnProperty('identifier')) {
              resolve(res.data)
            } else {
              // 获取自定义详情处理数据
              if (url === 'moduleOperation/findDataDetail') {
                tool.handleCustomDetailData(res.data.data)
              }
              // 获取子表单
              if (url === 'moduleOperation/findDetailByName') {
                tool.handleCustomSubformDetails(res.data.data)
              }
              // 2022-05-23 后台步修改，前端处理 绩效考核，okr和目标管理相关
              if (url === 'module/findPcAllModuleList') {
                tool.formatTokrNav(res.data.data)
              }
              resolve(res.data.data)
            }
          } else if (res.data.response.code === '1212') {
            deleteCodeLiteCookie(getEnv().env)
            // token过期，需要退出到登录页
            if (overdueNum === 0 && router.currentRoute.name !== 'login') {
              overdueNum = 1
              tfMessage.error(i18n.t('utils.logOutOfDate'))
              router.push({ path: '/' })
              setTimeout(() => {
                overdueNum = 0
              }, 1000)
            } else {
              tfMessage.error(res.data.response.describe)
            }
          } else {
            tfMessage.error(res.data.response.describe)
          }
        } else {
          // tfMessage.error(res.data.response.describe)
        }
      })
      .catch(err => {
        if (loadingInstance) {
          _this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
        }
        tfMessage.error(i18n.t('utils.networkExceptionTryAgain'))
        reject(err)
      })
  })
  return promise
}
/****
 * @params
 *  data //传递的数据
 *  url  //接口地址
 *  mask //遮罩层，不用遮罩层不用传或者false，若使用字符串用于文字显示，如 '保存中...'
 */
function ajaxPost(url, data, mask, urlType, customHeaders) {
  // urlType (1-默认，2-接口集成接口, 3：文件上传限制)
  let loadingInstance = ''
  if (mask && Loading) {
    // if (mask) {
    //   options.text = mask
    // }
    loadingInstance = Loading.service(options)
  }
  data = tool.formatDataTrim(data)
  if (url === 'salarySocialInsuranceAccumulationFund/selectEmployeeList') {
    data = { data: tool.jsonEncrypt(JSON.stringify(data)) }
  } else {
    tool.encryptionTnterface(data, url) // 处理接口加密
  }
  let promise = new Promise((resolve, reject) => {
    let requestHeader = JSON.parse(localStorage.getItem('requestHeader'))
    requestHeader.SIGN = tool.Encrypt()
    // 文件限制
    if (urlType === 3) {
      const exceed = tool.fileRestrict(data)
      if (exceed && exceed.data === 1) {
        tfMessage.error(exceed.params)
        loadingInstance.close()
        return
      } else if (exceed && exceed.data === 2) {
        data = exceed.params
        let exit = false
        // 输出所有的 key
        for (const key of exceed.params.keys()) {
          if (key.includes('file')) {
            exit = true
          }
        }
        if (!exit) {
          loadingInstance.close()
          return
        }
      }
    }
    if (
      url === 'moduleOperation/saveData' ||
      url === 'moduleOperation/completeData' ||
      url === 'moduleOperation/updateData' ||
      url === 'moduleOperation/updateCompleteData' ||
      url === 'submit/dealFormula' ||
      url === 'projectTaskController/updateTask' ||
      url === 'projectTaskController/updateSub' ||
      url === 'personelTask/save'
    ) {
      // 自定义新增编辑处理子表单问题
      data.data = tool.formatCutomSubform(data.data, url, data.layout_data)
    } else if (url === 'personelTask/update' || url === 'personelSubTask/update') {
      data.customLayout = tool.formatCutomSubform(data.customLayout, url, data.layout_data)
    }
    if (url === 'submit/dealFormula') {
      // 处理子表单数据量过大不触发公式计算
      let isMaxSubformCount = false
      for (const i in data.data) {
        if (i.includes('subform') && data.data[i] && data.data[i].length > 100) {
          isMaxSubformCount = true
        }
      }
      if (isMaxSubformCount) {
        return false
      }
    }
    // 2022-07-11 处理某些接口需要压缩传参功能
    data = tool.judgeZipOrUnzip(data, url, 0)
    // 2024-03-12 处理任务
    if (url === 'standalonetask/updateTask') {
      if (data && data.data) {
        if (data.data.parent_task_id) {
          data.data.parent_task_id = parseInt(data.data.parent_task_id)
        } else {
          delete data.data.parent_task_id
        }
      }
    }
    // 2024-04-10 接口集成 module/findApplications 如果是ip地址需改成 http
    const integrationUrlNew = integrationUrl
    // if (urlType === 2 && url === 'module/findApplications') {
    //   // IP 地址的正则表达式
    //   const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/
    //   if (ipRegex.test(location.hostname)) {
    //     let intergrationArr = integrationUrl.split('://')[1].split('8888/')
    //     integrationUrlNew = 'http://' + intergrationArr[0] + '8889/' + intergrationArr[1]
    //   }
    // }
    axios({
      method: 'post',
      url: url,
      baseURL: urlType === 2 ? integrationUrlNew : baseURL,
      data: data,
      headers: Object.assign({}, requestHeader, customHeaders)
    })
      .then(res => {
        if (loadingInstance) {
          _this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
        }
        if (res.data) {
          if (
            res.data.response.code === 'common.sucess' ||
            res.data.response.code === 'common.success'
          ) {
            if (tool.judgeResponRespon(url)) {
              // 判断返回的数据在response中
              resolve(res.data.response)
            } else {
              if (url === 'user/findUsersByCompany') {
                // 处理将“离职人员”改成“停用人员”
                res.data.data = tool.handleStopMember(res.data.data, data)
              }
              if (url === 'employee/getRosterDetail') {
                // 处理将花名册部门全称赋值给reference_department_id
                tool.formatStaffFullDepName(res.data.data)
              }
              resolve(res.data.data)
            }
          } else if (res.data.response.code + '' === '1212') {
            if (overdueNum === 0 && router.currentRoute.name !== 'login') {
              overdueNum = 1
              tfMessage.error(i18n.t('utils.logOutOfDate'))
              router.push({ path: '/' })
              setTimeout(() => {
                overdueNum = 0
              }, 1000)
            }
          } else {
            const arr = [
              'achievementManage/launchAssessment',
              'moduleOperation/findRelationDataList',
              'fieldRelyon/findSubRelationDataList',
              'objective/saveLayout',
              'objective/saveKR',
              'objective/save',
              'achievementTemplate/saveAchievsysTemplateType',
              'achievementTemplate/saveIndustry',
              'achievementTemplate/saveStation',
              'attendanceOutworker/caclTime',
              'attendancePatchCard/batchSave',
              'roster/updateEmid',
              '/personnel/matrix/mapping/importMappingMatrix'
            ]
            const desc = describe[url] ? describe[url][res.data.response.describe] : ''

            const reutrnRes = ['attendanceOvertime/caclTime']
            if (reutrnRes.includes(url)) {
              // 返回response
              resolve(res.data.response)
            } else if (arr.includes(url)) {
              reject(res.data.response)
            } else if (url === '/applicationCenter/uploadTemplate') {
              tfMessage({
                message: res.data.response.describe,
                type: 'error',
                showClose: true,
                duration: 0
              })
            } else if (url.includes('department/del') && url !== 'department/delDutiesType') {
              tfMessage.error('删除失败')
            } else if (desc) {
              tfMessage.error(desc)
            } else {
              if (url === 'employee/saveBeanData' && res.data.response.describe === '-3') {
                reject(res.data.response)
              } else {
                if (url === 'attendanceHoliday/saveLeaveType') {
                  tfMessage.error(`已被假期方案【${res.data.response.describe}】引用`)
                } else {
                  tfMessage.error(res.data.response.describe)
                }
              }
            }
            if (res.data.response.code === 'common.fail') {
              // 业务失败时需 reject，否则调用方 await 永不结束（finally 无法执行）
              reject(res.data.response)
            }
          }
        } else {
        }
      })
      .catch(err => {
        reject(err)
        if (loadingInstance) {
          _this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
        }
        tfMessage.error(i18n.t('utils.networkExceptionTryAgain'))
        throw err
      })
  })
  return promise
}

function ajaxPost2(url, data, mask, urlType) {
  // urlType (1-默认，2-接口集成接口)
  let loadingInstance = ''
  if (mask && Loading) {
    // if (mask) {
    //   options.text = mask
    // }
    loadingInstance = Loading.service(options)
  }
  const promise = new Promise((resolve, reject) => {
    // 文件限制
    if (urlType === 3) {
      const exceed = tool.fileRestrict(data)
      if (exceed && exceed.data === 1) {
        tfMessage.error(exceed.params)
        loadingInstance.close()
        return
      } else if (exceed && exceed.data === 2) {
        data = exceed.params
        let exit = false
        // 输出所有的 key
        for (const key of exceed.params.keys()) {
          if (key.includes('file')) {
            exit = true
          }
        }
        if (!exit) {
          loadingInstance.close()
          return
        }
      }
    }
    let requestHeader = JSON.parse(localStorage.getItem('requestHeader'))
    requestHeader.SIGN = tool.Encrypt()
    tool.encryptionTnterface(data, url) // 处理接口加密
    axios({
      method: 'post',
      url,
      baseURL: cloudURL,
      data,
      headers: requestHeader
    })
      .then(res => {
        if (loadingInstance) {
          _this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
        }
        if (
          res.data.response.code === 'common.sucess' ||
          res.data.response.code === 'common.success'
        ) {
          resolve(res.data.data)
        } else if (res.data.response.code + '' === '1212') {
          if (overdueNum === 0 && router.currentRoute.name !== 'login') {
            overdueNum = 1
            tfMessage.error(i18n.t('utils.logOutOfDate'))
            router.push({ path: '/' })
            setTimeout(() => {
              overdueNum = 0
            }, 1000)
          }
        } else {
          tfMessage.error(res.data.response.describe)
          // reject(res.data.response)
        }
      })
      .catch(err => {
        reject(err)
        if (loadingInstance) {
          _this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
        }
        tfMessage.error(i18n.t('utils.networkExceptionTryAgain'))
      })
  })
  return promise
}

function ajaxGetRequest(params, url, responseStr) {
  let requestHeader = {}
  if (localStorage.getItem('requestHeader')) {
    requestHeader = JSON.parse(localStorage.getItem('requestHeader'))
  }
  requestHeader.SIGN = tool.Encrypt()
  tool.encryptionTnterface(params, url) // 处理接口加密
  return axios({
    method: 'get',
    url,
    baseURL,
    params,
    headers: requestHeader,
    // eslint-disable-next-line
    responseType: responseStr ? responseStr : 'json'
  })
}
function ajaxPostRequest(data, url) {
  if (!localStorage.getItem('requestHeader')) return Promise.reject('no requestHeader')
  let requestHeader = JSON.parse(localStorage.getItem('requestHeader'))
  requestHeader.SIGN = tool.Encrypt()
  tool.encryptionTnterface(data, url) // 处理接口加密
  return axios({
    method: 'post',
    url,
    baseURL,
    data,
    headers: requestHeader
  })
}
// 下载请求
function downLoadRequest(method, url, data, filename, isZip) {
  let loadingInstance = Loading.service(options)
  let promise = new Promise((resolve, reject) => {
    let requestHeader = JSON.parse(localStorage.getItem('requestHeader'))
    requestHeader.SIGN = tool.Encrypt()
    const axiosOption = {
      method,
      responseType: 'blob',
      url,
      baseURL,
      headers: requestHeader
    }
    if (method && method.toLowerCase() === 'get') {
      axiosOption.params = data
    } else if (method && method.toLowerCase() === 'post') {
      axiosOption.data = data
    } else {
      return
    }
    axios(axiosOption)
      .then(res => {
        _this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close()
        })
        tool.downLoadFile(res, filename, isZip)
        resolve(res)
      })
      .catch(err => {
        reject(err)
        _this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close()
        })
        tfMessage.error(i18n.t('utils.networkExceptionTryAgain'))
      })
  })
  return promise
}

// 具体接口
const HTTPServer = {
  commonUpload: function (params, mask) {
    return ajaxPost(path.commonUpload, params, mask, 3)
  },
  centerUploadImage: function (params, mask) {
    return ajaxPost2(path.centerUploadImage, params, mask, 3)
  },
  customUpload: function (params, mask) {
    return ajaxPost(path.customUpload, params, mask, 3)
  },
  getAccidentCarInfo: function (params, mask) {
    return ajaxPost(path.getAccidentCarInfo, params, mask)
  },
  queryDepartment: function (params, mask) {
    return ajaxGet(path.queryDepartment, params, mask)
  },
  getReferenceFields: function (params, mask) {
    return ajaxGet(path.getReferenceFields, params, mask)
  },
  /* *** 页签管理 START************************** */

  /* *** 页签管理 END  ************************** */
  tabFindList: function (params, mask) {
    return ajaxGet(path.tabFindList, params, mask)
  },
  tabFindModuleList: function (params, mask) {
    return ajaxGet(path.tabFindModuleList, params, mask)
  },
  tabFindFieldsList: function (params, mask) {
    return ajaxGet(path.tabFindFieldsList, params, mask)
  },
  tabFindDetail: function (params, mask) {
    return ajaxGet(path.tabFindDetail, params, mask)
  },
  tabStick: function (params, mask) {
    return ajaxPost(path.tabStick, params, mask)
  },
  tabSave: function (params, mask) {
    return ajaxPost(path.tabSave, params, mask)
  },
  tabUpdate: function (params, mask) {
    return ajaxPost(path.tabUpdate, params, mask)
  },
  tabDel: function (params, mask) {
    return ajaxPost(path.tabDel, params, mask)
  },
  /* *** 简历分析 START************************** */
  recruitmentWebsiteFindAll: function (params, mask) {
    return ajaxGet(path.recruitmentWebsiteFindAll, params, mask)
  },
  recruitmentWebsiteUpdateStatus: function (params, mask) {
    return ajaxPost(path.recruitmentWebsiteUpdateStatus, params, mask)
  },
  recruitmentWebsiteGetLayout: function (params, mask) {
    return ajaxGet(path.recruitmentWebsiteGetLayout, params, mask)
  },
  getDataListFieldsForRecruitmentWebsite: function (params, mask) {
    return ajaxGet(path.getDataListFieldsForRecruitmentWebsite, params, mask)
  },
  recruitmentWebsiteDownload: function (params, mask) {
    return ajaxGet(path.recruitmentWebsiteDownload, params, mask)
  },
  recruitmentWebsiteSave: function (params, mask) {
    return ajaxPost(path.recruitmentWebsiteSave, params, mask)
  },
  recruitmentWebsiteUpdate: function (params, mask) {
    return ajaxPost(path.recruitmentWebsiteUpdate, params, mask)
  },
  getRecognitionFieldForRecruitmentWebsite: function (params, mask) {
    return ajaxGet(path.getRecognitionFieldForRecruitmentWebsite, params, mask)
  },
  findIntegrationApplications: function (params, mask) {
    return ajaxPost(path.findIntegrationApplications, params, mask, 2)
  },
  findIntegrationModules: function (params, mask) {
    return ajaxPost(path.findIntegrationModules, params, mask, 2)
  },
  getIntegrationParamDetail: function (params, mask) {
    return ajaxGet(path.getIntegrationParamDetail, params, mask, 2)
  },
  thirdpartyGetToken: function (params, mask) {
    return ajaxGet(path.thirdpartyGetToken, params, mask, 2)
  },
  thirdpartyRestToken: function (params, mask) {
    return ajaxGet(path.thirdpartyRestToken, params, mask, 2)
  },
  thirdpartySaveUser: function (params, mask) {
    return ajaxPost(path.thirdpartySaveUser, params, mask, 2)
  },
  thirdpartyDelUser: function (params, mask) {
    return ajaxPost(path.thirdpartyDelUser, params, mask, 2)
  },
  thirdpartyFindUsersList: function (params, mask) {
    return ajaxGet(path.thirdpartyFindUsersList, params, mask, 2)
  },
  thirdpartySaveSetting: function (params, mask) {
    return ajaxPost(path.thirdpartySaveSetting, params, mask, 2)
  },
  thirdpartyDelSetting: function (params, mask) {
    return ajaxPost(path.thirdpartyDelSetting, params, mask, 2)
  },
  thirdpartyFindSettingDetail: function (params, mask) {
    return ajaxGet(path.thirdpartyFindSettingDetail, params, mask, 2)
  },
  thirdpartyFindSettingList: function (params, mask) {
    return ajaxGet(path.thirdpartyFindSettingList, params, mask, 2)
  },
  thirdpartySaveDb: function (params, mask) {
    return ajaxPost(path.thirdpartySaveDb, params, mask, 2)
  },
  thirdpartyTestDb: function (params, mask) {
    return ajaxPost(path.thirdpartyTestDb, params, mask, 2)
  },
  thirdpartyFindTableList: function (params, mask) {
    return ajaxGet(path.thirdpartyFindTableList, params, mask, 2)
  },
  thirdpartyFindDbList: function (params, mask) {
    return ajaxGet(path.thirdpartyFindDbList, params, mask, 2)
  },
  thirdpartyUpdateSort: function (params, mask) {
    return ajaxPost(path.thirdpartyUpdateSort, params, mask, 2)
  },
  refreshApiSecret: function (params, mask) {
    return ajaxGet(path.refreshApiSecret, params, mask, 2)
  },
  thirdpartySchemaList: function (params, mask) {
    return ajaxGet(path.thirdpartySchemaList, params, mask, 2)
  },
  findThirdTableListNew: function (params, mask) {
    return ajaxGet(path.findThirdTableListNew, params, mask, 2)
  },
  findThirdTableColumnList: function (params, mask) {
    return ajaxGet(path.findThirdTableColumnList, params, mask, 2)
  },
  aliapicloudList: function (params, mask) {
    return ajaxGet(path.aliapicloudList, params, mask)
  },
  settingAliapicloudCode: function (params, mask) {
    return ajaxPost(path.settingAliapicloudCode, params, mask)
  },
  getInstallPlugCodes: function (params, mask) {
    return ajaxGet(path.getInstallPlugCodes, params, mask)
  },
  getPlugCodes: function (params, mask) {
    return ajaxGet(path.getPlugCodes, params, mask)
  },
  findSSOList: function (params, mask) {
    return ajaxGet(path.findSSOList, params, mask)
  },
  delPlug: function (params, mask) {
    return ajaxGet(path.delPlug, params, mask)
  },
  delSSOInfo: function (params, mask) {
    return ajaxGet(path.delSSOInfo, params, mask)
  },
  installPlug: function (params, mask) {
    return ajaxPost(path.installPlug, params, mask)
  },
  saveSSOInfo: function (params, mask) {
    return ajaxPost(path.saveSSOInfo, params, mask)
  },
  saveSSOUserInfo: function (params, mask) {
    return ajaxPost(path.saveSSOUserInfo, params, mask)
  },
  checkSSOAuth: function (params, mask) {
    return ajaxGet(path.checkSSOAuth, params, mask)
  },
  getUserSSOInfo: function (params, mask) {
    return ajaxGet(path.getUserSSOInfo, params, mask)
  },
  getSSODetail: function (params, mask) {
    return ajaxGet(path.getSSODetail, params, mask)
  },
  getCardPlug: function (params, mask) {
    return ajaxGet(path.getCardPlug, params, mask)
  },
  saveCardPlug: function (params, mask) {
    return ajaxPost(path.saveCardPlug, params, mask)
  },
  /* *** 简历分析 END************************** */

  /* *** 自动化匹配 START************************** */
  automatchFindModuleList: function (params, mask) {
    return ajaxGet(path.automatchFindModuleList, params, mask)
  },
  automatchFindList: function (params, mask) {
    return ajaxGet(path.automatchFindList, params, mask)
  },
  automatchFindFieldsList: function (params, mask) {
    return ajaxGet(path.automatchFindFieldsList, params, mask)
  },
  automatchFindDetail: function (params, mask) {
    return ajaxGet(path.automatchFindDetail, params, mask)
  },
  automatchSave: function (params, mask) {
    return ajaxPost(path.automatchSave, params, mask)
  },
  automatchUpdate: function (params, mask) {
    return ajaxPost(path.automatchUpdate, params, mask)
  },
  automatchDel: function (params, mask) {
    return ajaxPost(path.automatchDel, params, mask)
  },
  /* *** 自动化匹配 END************************** */

  /* *** 聚合表 START************************** */
  getAllApplications: function (params, mask) {
    return ajaxGet(path.getAllApplications, params, mask)
  },
  getDataListFieldsForJuhe: function (params, mask) {
    return ajaxGet(path.getDataListFieldsForJuhe, params, mask)
  },
  getNumicFieldsForJuhe: function (params, mask) {
    return ajaxGet(path.getNumicFieldsForJuhe, params, mask)
  },
  getJuheList: function (params, mask) {
    return ajaxGet(path.getJuheList, params, mask)
  },
  saveJuhe: function (params, mask) {
    return ajaxPost(path.saveJuhe, params, mask)
  },
  aggregationLinkageSave: function (params, mask) {
    return ajaxPost(path.aggregationLinkageSave, params, mask)
  },
  aggregationLinkageEdit: function (params, mask) {
    return ajaxPost(path.aggregationLinkageEdit, params, mask)
  },
  aggregationLinkageDel: function (params, mask) {
    return ajaxPost(path.aggregationLinkageDel, params, mask)
  },
  gotoRun: function (params, mask) {
    return ajaxPost(path.gotoRun, params, mask)
  },
  delJuhe: function (params, mask) {
    return ajaxPost(path.delJuhe, params, mask)
  },
  updateJuhe: function (params, mask) {
    return ajaxPost(path.updateJuhe, params, mask)
  },
  getJuheById: function (params, mask) {
    return ajaxGet(path.getJuheById, params, mask)
  },
  getLinkageList: function (params, mask) {
    return ajaxGet(path.getLinkageList, params, mask)
  },
  getFieldsForLinkage: function (params, mask) {
    return ajaxGet(path.getFieldsForLinkage, params, mask)
  },
  getLinkageDetail: function (params, mask) {
    return ajaxGet(path.getLinkageDetail, params, mask)
  },
  getLinkageFieldsForCustom: function (params, mask) {
    return ajaxGet(path.getLinkageFieldsForCustom, params, mask)
  },
  findAggregationDataLinkageList: function (params, mask) {
    return ajaxPost(path.findAggregationDataLinkageList, params, mask)
  },
  /* *** 聚合表 END*************************** */

  /* *** 工作台 START************************** */
  queryTimeWorkbenchWebList: function (params, mask) {
    return ajaxGet(path.queryTimeWorkbenchWebList, params, mask)
  },
  queryListByFilterAuth: function (params, mask) {
    return ajaxGet(path.queryListByFilterAuth, params, mask)
  },
  queryWorkflowListBy: function (params, mask) {
    return ajaxGet(path.queryWorkflowListBy, params, mask)
  },
  moveTimeWorkbench: function (params, mask) {
    return ajaxPost(path.moveTimeWorkbench, params, mask)
  },
  sortTimeWorkbench: function (params, mask) {
    return ajaxPost(path.sortTimeWorkbench, params, mask)
  },
  queryFlowWorkbenchWebList: function (params, mask) {
    return ajaxGet(path.queryFlowWorkbenchWebList, params, mask)
  },
  moveFlowWorkbench: function (params, mask) {
    return ajaxPost(path.moveFlowWorkbench, params, mask)
  },
  getCardTaskSize: function (params, mask) {
    return ajaxGet(path.getCardTaskSize, params, mask)
  },
  getCardTaskData: function (params, mask) {
    return ajaxPost(path.getCardTaskData, params, mask)
  },
  getCardTaskDepartmentUsers: function (params, mask) {
    return ajaxGet(path.getCardTaskDepartmentUsers, params, mask)
  },
  /* *** 工作台 END************************** */

  /* *** 考勤 START************************** */
  findWebList: function (params, mask) {
    return ajaxGet(path.findWebList, params, mask)
  },
  attendanceClassSave: function (params, mask) {
    return ajaxPost(path.attendanceClassSave, params, mask)
  },
  attendanceClassUpdate: function (params, mask) {
    return ajaxPost(path.attendanceClassUpdate, params, mask)
  },
  attendanceClassDel: function (params, mask) {
    return ajaxPost(path.attendanceClassDel, params, mask)
  },
  attendanceWaySave: function (params, mask) {
    return ajaxPost(path.attendanceWaySave, params, mask)
  },
  attendanceWayUpdate: function (params, mask) {
    return ajaxPost(path.attendanceWayUpdate, params, mask)
  },
  attendanceWayDel: function (params, mask) {
    return ajaxPost(path.attendanceWayDel, params, mask)
  },
  attendanceClassFindDetail: function (params, mask) {
    return ajaxGet(path.attendanceClassFindDetail, params, mask)
  },
  attendanceWayFindWebList: function (params, mask) {
    return ajaxGet(path.attendanceWayFindWebList, params, mask)
  },
  attendanceWayFindDetail: function (params, mask) {
    return ajaxGet(path.attendanceWayFindDetail, params, mask)
  },
  attendanceGroupList: function (params, mask) {
    return ajaxGet(path.attendanceGroupList, params, mask)
  },
  attendanceGroupDetail: function (params, mask) {
    return ajaxGet(path.attendanceGroupDetail, params, mask)
  },
  attendanceGroupSave: function (params, mask) {
    return ajaxPost(path.attendanceGroupSave, params, mask)
  },
  attendanceGroupDel: function (params, mask) {
    return ajaxPost(path.attendanceGroupDel, params, mask)
  },
  attendanceGroupUpdate: function (params, mask) {
    return ajaxPost(path.attendanceGroupUpdate, params, mask)
  },
  attendanceManagementSave: function (params, mask) {
    return ajaxPost(path.attendanceManagementSave, params, mask)
  },
  scheduleFindDetailById: function (params, mask) {
    return ajaxGet(path.scheduleFindDetailById, params, mask)
  },
  attendanceManagementUpdate: function (params, mask) {
    return ajaxPost(path.attendanceManagementUpdate, params, mask)
  },
  attendanceManagementDetail: function (params, mask) {
    return ajaxGet(path.attendanceManagementDetail, params, mask)
  },
  attendanceManagementDataExport: function (params, mask) {
    return ajaxGet(path.attendanceManagementDataExport, params, mask)
  },
  attendanceManagementDataImport: function (params, mask) {
    return ajaxGet(path.attendanceManagementDataImport, params, mask)
  },
  attendanceCycleSave: function (params, mask) {
    return ajaxPost(path.attendanceCycleSave, params, mask)
  },
  attendanceCycleFindDetail: function (params, mask) {
    return ajaxGet(path.attendanceCycleFindDetail, params, mask)
  },
  attendanceScheduleQueryList: function (params, mask) {
    return ajaxGet(path.attendanceScheduleQueryList, params, mask)
  },
  attendanceCycleUpdate: function (params, mask) {
    return ajaxPost(path.attendanceCycleUpdate, params, mask)
  },
  attendanceCycleDel: function (params, mask) {
    return ajaxPost(path.attendanceCycleDel, params, mask)
  },
  otherSetFindDetail: function (params, mask) {
    return ajaxGet(path.otherSetFindDetail, params, mask)
  },
  attendanceSettingSaveAdmin: function (params, mask) {
    return ajaxPost(path.attendanceSettingSaveAdmin, params, mask)
  },
  attendanceSettingSaveRemind: function (params, mask) {
    return ajaxPost(path.attendanceSettingSaveRemind, params, mask)
  },
  attendanceSettingSaveCount: function (params, mask) {
    return ajaxPost(path.attendanceSettingSaveCount, params, mask)
  },
  attendanceSettingSaveLate: function (params, mask) {
    return ajaxPost(path.attendanceSettingSaveLate, params, mask)
  },
  attendanceSettingSaveHommization: function (params, mask) {
    return ajaxPost(path.attendanceSettingSaveHommization, params, mask)
  },
  attendanceSettingSaveAbsenteeism: function (params, mask) {
    return ajaxPost(path.attendanceSettingSaveAbsenteeism, params, mask)
  },
  attendanceRelevanceApproveSave: function (params, mask) {
    return ajaxPost(path.attendanceRelevanceApproveSave, params, mask)
  },
  attendanceRelevanceApproveUpdate: function (params, mask) {
    return ajaxPost(path.attendanceRelevanceApproveUpdate, params, mask)
  },
  attendanceRelevanceApproveDel: function (params, mask) {
    return ajaxPost(path.attendanceRelevanceApproveDel, params, mask)
  },
  attendanceRelevanceApproveFindDetail: function (params, mask) {
    return ajaxGet(path.attendanceRelevanceApproveFindDetail, params, mask)
  },
  attendanceRelevanceApproveFindList: function (params, mask) {
    return ajaxGet(path.attendanceRelevanceApproveFindList, params, mask)
  },
  attendanceRelevanceApproveFindApproveList: function (params, mask) {
    return ajaxGet(path.attendanceRelevanceApproveFindApproveList, params, mask)
  },
  originaldataList: function (params, mask) {
    return ajaxPost(path.originaldataList, params, mask)
  },
  monthDataColumnList: function (params, mask) {
    return ajaxGet(path.monthDataColumnList, params, mask)
  },
  monthdataList: function (params, mask) {
    return ajaxPost(path.monthdataList, params, mask)
  },
  daydataList: function (params, mask) {
    return ajaxPost(path.daydataList, params, mask)
  },
  originaldataListNew: function (params, mask) {
    return ajaxPost(path.originaldataListNew, params, mask)
  },
  monthdataListNew: function (params, mask) {
    return ajaxPost(path.monthdataListNew, params, mask)
  },
  daydataListNew: function (params, mask) {
    return ajaxPost(path.daydataListNew, params, mask)
  },
  attendanceReportUpdate: function (params, mask) {
    return ajaxPost(path.attendanceReportUpdate, params, mask)
  },
  attendanceReportBatchUpdate: function (params, mask) {
    return ajaxPost(path.attendanceReportBatchUpdate, params, mask)
  },
  findPluginList: function (params, mask) {
    return ajaxGet(path.findPluginList, params, mask)
  },
  getAbnormalDataByAuth: function (params, mask) {
    return ajaxPost(path.getAbnormalDataByAuth, params, mask)
  },
  originaldataTemplateExport: function (params, mask) {
    return ajaxPost(path.originaldataTemplateExport, params, mask)
  },
  originaldataImport: function (params, mask) {
    return ajaxPost(path.originaldataImport, params, mask)
  },
  openOrClose: function (params, mask) {
    return ajaxPost(path.openOrClose, params, mask)
  },
  saveOvertimeRemind: function (params, mask) {
    return ajaxPost(path.saveOvertimeRemind, params, mask)
  },
  getApprovePassRecord: function (params, mask) {
    return ajaxPost(path.getApprovePassRecord, params, mask)
  },
  deletePassRecord: function (params, mask) {
    return ajaxPost(path.deletePassRecord, params, mask)
  },

  attendanceMachineSettingList: function (params, mask) {
    return ajaxGet(path.attendanceMachineSettingList, params, mask)
  },
  attendanceMachineSettingsave: function (params, mask) {
    return ajaxPost(path.attendanceMachineSettingsave, params, mask)
  },
  attendanceMachineSettingDel: function (params, mask) {
    return ajaxGet(path.attendanceMachineSettingDel, params, mask)
  },
  attendanceMachineSettingExist: function (params, mask) {
    return ajaxGet(path.attendanceMachineSettingExist, params, mask)
  },
  attendanceMachineSettingPushAddress: function (params, mask) {
    return ajaxGet(path.attendanceMachineSettingPushAddress, params, mask)
  },
  attendanceMachineSettingSynchronization: function (params, mask) {
    return ajaxPost(path.attendanceMachineSettingSynchronization, params, mask)
  },
  attendanceMachineEmployeeRelationList: function (params, mask) {
    return ajaxGet(path.attendanceMachineEmployeeRelationList, params, mask)
  },
  attendanceMachineEmployeeRelationSave: function (params, mask) {
    return ajaxPost(path.attendanceMachineEmployeeRelationSave, params, mask)
  },
  attendanceMachineEmployeeRelationDel: function (params, mask) {
    return ajaxGet(path.attendanceMachineEmployeeRelationDel, params, mask)
  },
  attendanceMachineSettingCheckConn: function (params, mask) {
    return ajaxPost(path.attendanceMachineSettingCheckConn, params, mask)
  },
  updateAttendanceApproveRule: function (params, mask) {
    return ajaxPost(path.updateAttendanceApproveRule, params, mask)
  },
  attendanceHolidayList: function (params, mask) {
    return ajaxPost(path.attendanceHolidayList, params, mask)
  },
  attendanceHolidayLogList: function (params, mask) {
    return ajaxGet(path.attendanceHolidayLogList, params, mask)
  },
  attendanceHolidayDetail: function (params, mask) {
    return ajaxGet(path.attendanceHolidayDetail, params, mask)
  },
  updateAttendanceHoliday: function (params, mask) {
    return ajaxPost(path.updateAttendanceHoliday, params, mask)
  },
  attendanceHolidayTemplateExport: function (params, mask) {
    return ajaxGet(path.attendanceHolidayTemplateExport, params, mask)
  },
  holidayBalanceImport: function (params, mask) {
    return ajaxPost(path.holidayBalanceImport, params, mask)
  },
  getMapConfig: function (params, mask) {
    return ajaxGet(path.getMapConfig, params, mask)
  },
  saveOverTimeRule: function (params, mask) {
    return ajaxPost(path.saveOverTimeRule, params, mask)
  },
  updateOverTimeRule: function (params, mask) {
    return ajaxPost(path.updateOverTimeRule, params, mask)
  },
  deleteOverTimeRule: function (params, mask) {
    return ajaxPost(path.deleteOverTimeRule, params, mask)
  },
  queryOverTimeRuleList: function (params, mask) {
    return ajaxGet(path.queryOverTimeRuleList, params, mask)
  },
  getAttendanceConfirmSetting: function (params, mask) {
    return ajaxGet(path.getAttendanceConfirmSetting, params, mask)
  },
  saveAttendanceConfirmSetting: function (params, mask) {
    return ajaxPost(path.saveAttendanceConfirmSetting, params, mask)
  },
  getAttendanceConfirmMonthReport: function (params, mask) {
    return ajaxPost(path.getAttendanceConfirmMonthReport, params, mask)
  },
  getAttendanceConfirmMonthReportDetailList: function (params, mask) {
    return ajaxPost(path.getAttendanceConfirmMonthReportDetailList, params, mask)
  },
  attendanceConfirmSendOrRecallAll: function (params, mask) {
    return ajaxPost(path.attendanceConfirmSendOrRecallAll, params, mask)
  },
  attendanceConfirmSendOrRecall: function (params, mask) {
    return ajaxPost(path.attendanceConfirmSendOrRecall, params, mask)
  },
  confirmAttendanceConfirm: function (params, mask) {
    return ajaxPost(path.confirmAttendanceConfirm, params, mask)
  },
  getAttendanceConfirmMonthReportDetail: function (params, mask) {
    return ajaxGet(path.getAttendanceConfirmMonthReportDetail, params, mask)
  },
  getAttendanceConfirmReportInfo: function (params, mask) {
    return ajaxGet(path.getAttendanceConfirmReportInfo, params, mask)
  },
  attendanceURGE: function (params, mask) {
    return ajaxPost(path.attendanceURGE, params, mask)
  },
  attendanceModifyRecordList: function (params, mask) {
    return ajaxPost(path.attendanceModifyRecordList, params, mask)
  },
  attendanceModifyRecordDel: function (params, mask) {
    return ajaxPost(path.attendanceModifyRecordDel, params, mask)
  },
  /* *** 考勤 END************************** */
  /** 登录注册 */
  login: function (params, mask) {
    return ajaxPost(path.login, params, mask)
  },
  personalInfo: function (params, mask) {
    return ajaxPost(path.personalInfo, params, mask)
  },
  sendSmsCode: function (params, mask) {
    return ajaxPost(path.sendSmsCode, params, mask)
  },
  verifySmsCode: function (params, mask) {
    return ajaxPost(path.verifySmsCode, params, mask)
  },
  modifyPwd: function (params, mask) {
    return ajaxPost(path.modifyPwd, params, mask)
  },
  editPassWord: function (params, mask) {
    return ajaxPost(path.editPassWord, params, mask)
  },
  getCompanySet: function (params, mask) {
    return ajaxGet(path.getCompanySet, params, mask)
  },
  getCompanySetResetPwd: function (params, mask) {
    return ajaxGet(path.getCompanySetResetPwd, params, mask)
  },
  queryInfo: function (params, mask) {
    return ajaxGet(path.queryInfo, params, mask)
  },
  userRegister: function (params, mask) {
    return ajaxPost(path.userRegister, params, mask)
  },
  queryCode: function (params, mask) {
    return ajaxGet(path.queryCode, params, mask)
  },
  scanCodeLogin: function (params, mask) {
    return ajaxGet(path.scanCodeLogin, params, mask)
  },
  companyList: function (params, mask) {
    return ajaxGet(path.companyList, params, mask)
  },
  companyLogin: function (params, mask) {
    return ajaxPost(path.companyLogin, params, mask)
  },
  signOutAccount: function (params, mask) {
    return ajaxGet(path.signOutAccount, params, mask)
  },
  editCompanyDomainAddress: function (params, mask) {
    return ajaxPost(path.editCompanyDomainAddress, params, mask)
  },
  getCompanyDomainAddress: function (params, mask) {
    return ajaxGet(path.getCompanyDomainAddress, params, mask)
  },
  editCompanyImAddress: function (params, mask) {
    return ajaxPost(path.editCompanyImAddress, params, mask)
  },
  getReleaseNotice: function (params, mask) {
    return ajaxGet(path.getReleaseNotice, params, mask)
  },
  getCompanyDataInfo: function (params, mask) {
    return ajaxGet(path.getCompanyDataInfo, params, mask)
  },
  getUserLanguages: function (params, mask) {
    return ajaxGet(path.getUserLanguages, params, mask)
  },
  getUserSetting: function (params, mask) {
    return ajaxGet(path.getUserSetting, params, mask)
  },
  userSetting: function (params, mask) {
    return ajaxPost(path.userSetting, params, mask)
  },
  openUserSet: function (params, mask) {
    return ajaxPost(path.openUserSet, params, mask)
  },
  queryWechatAccount: function (params, mask) {
    return ajaxGet(path.queryWechatAccount, params, mask)
  },
  saveWechatAccount: function (params, mask) {
    return ajaxPost(path.saveWechatAccount, params, mask)
  },
  updateWechatMenuEnableById: function (params, mask) {
    return ajaxPost(path.updateWechatMenuEnableById, params, mask)
  },
  getTemplatebind: function (params, mask) {
    return ajaxGet(path.getTemplatebind, params, mask)
  },
  saveTemplatebind: function (params, mask) {
    return ajaxPost(path.saveTemplatebind, params, mask)
  },
  uploadWxJs: function (params, mask) {
    return ajaxPost(path.uploadWxJs, params, mask, 3)
  },
  getnailingconfig: function (params, mask) {
    return ajaxGet(path.getnailingconfig, params, mask)
  },
  nailingSave: function (params, mask) {
    return ajaxPost(path.nailingSave, params, mask)
  },
  nailingScanSave: function (params, mask) {
    return ajaxPost(path.nailingScanSave, params, mask)
  },
  nailingScanCodeLogin: function (params, mask) {
    return ajaxGet(path.nailingScanCodeLogin, params, mask)
  },
  nailingScanLoginInfo: function (params, mask) {
    return ajaxGet(path.nailingScanLoginInfo, params, mask)
  },
  nailingSsoConfig: function (params, mask) {
    return ajaxPost(path.nailingSsoConfig, params, mask)
  },
  qyscanLogin: function (params, mask) {
    return ajaxPost(path.qyscanLogin, params, mask)
  },
  qyscanLogin3rd: function (params, mask) {
    return ajaxPost(path.qyscanLogin3rd, params, mask)
  },
  wxscanLoginInit: function (params, mask) {
    return ajaxGet(path.wxscanLoginInit, params, mask)
  },
  savewxscan: function (params, mask) {
    return ajaxPost(path.savewxscan, params, mask)
  },
  getwxscan: function (params, mask) {
    return ajaxGet(path.getwxscan, params, mask)
  },
  syncOrganization: function (params, mask) {
    return ajaxGet(path.syncOrganization, params, mask)
  },
  getThirdPartyStatus: function (params, mask) {
    return ajaxGet(path.getThirdPartyStatus, params, mask)
  },
  thirdSynchronization: function (params, mask) {
    return ajaxGet(path.thirdSynchronization, params, mask)
  },
  thirdModifyPhonePass: function (params, mask) {
    return ajaxPost(path.thirdModifyPhonePass, params, mask)
  },
  queryQyUserList: function (params, mask) {
    return ajaxGet(path.queryQyUserList, params, mask)
  },
  bindQyUser: function (params, mask) {
    return ajaxPost(path.bindQyUser, params, mask)
  },
  qyUnbundling: function (params, mask) {
    return ajaxGet(path.qyUnbundling, params, mask)
  },
  scanLogin3rdOSS: function (params, mask) {
    return ajaxPost(path.scanLogin3rdOSS, params, mask)
  },
  /** 登录注册  END */
  /** ************************选成员组件************************************/
  findUsersByCompany: function (params, mask) {
    return ajaxPost(path.findUsersByCompany, params, mask)
  },
  findCompanyDepartment: function (params, mask) {
    return ajaxPost(path.findCompanyDepartment, params, mask)
  },
  queryRangeEmployeeList: function (params, mask) {
    return ajaxPost(path.queryRangeEmployeeList, params, mask)
  },
  queryRangeDepartmentList: function (params, mask) {
    return ajaxPost(path.queryRangeDepartmentList, params, mask)
  },
  findOrganizationalStructureByType: function (params, mask) {
    return ajaxPost(path.findOrganizationalStructureByType, params, mask)
  },
  getSharePersonalFields: function (params, mask) {
    return ajaxGet(path.getSharePersonalFields, params, mask)
  },
  savaDepartment: function (params, mask) {
    return ajaxPost(path.savaDepartment, params, mask)
  },
  queryEmployeeDepartment: function (params, mask) {
    return ajaxGet(path.queryEmployeeDepartment, params, mask)
  },
  editDepartment: function (params, mask) {
    return ajaxPost(path.editDepartment, params, mask)
  },
  delDepartment: function (params, mask) {
    return ajaxPost(path.delDepartment, params, mask)
  },
  savaEmployee: function (params, mask) {
    return ajaxPost(path.savaEmployee, params, mask)
  },
  getEmployeeDetail: function (params, mask) {
    return ajaxGet(path.getEmployeeDetail, params, mask)
  },
  queryEmployeeList: function (params, mask) {
    return ajaxGet(path.queryEmployeeList, params, mask)
  },
  editEmployee: function (params, mask) {
    return ajaxPost(path.editEmployee, params, mask)
  },
  editEmployeeLeader: function (params, mask) {
    return ajaxPost(path.editEmployeeLeader, params, mask)
  },
  betchEditDepartment: function (params, mask) {
    return ajaxPost(path.betchEditDepartment, params, mask)
  },
  employeeActivateRemind: function (params, mask) {
    return ajaxPost(path.employeeActivateRemind, params, mask)
  },
  employeeBetchEditEmployee: function (params, mask) {
    return ajaxPost(path.employeeBetchEditEmployee, params, mask)
  },
  employeeBetchEditRole: function (params, mask) {
    return ajaxPost(path.employeeBetchEditRole, params, mask)
  },
  employeeBetchAppendRole: function (params, mask) {
    return ajaxPost(path.employeeBetchAppendRole, params, mask)
  },
  betchDelEmployee: function (params, mask) {
    return ajaxPost(path.betchDelEmployee, params, mask)
  },
  queryEmployeePost: function (params, mask) {
    return ajaxGet(path.queryEmployeePost, params, mask)
  },
  savaEmployeePost: function (params, mask) {
    return ajaxPost(path.savaEmployeePost, params, mask)
  },
  editEmployeePost: function (params, mask) {
    return ajaxPost(path.editEmployeePost, params, mask)
  },
  delEmployeePost: function (params, mask) {
    return ajaxPost(path.delEmployeePost, params, mask)
  },
  sortDepartment: function (params, mask) {
    return ajaxGet(path.sortDepartment, params, mask)
  },
  saveNoviceGuide: function (params, mask) {
    return ajaxPost(path.saveNoviceGuide, params, mask)
  },
  saveReferenceModule: function (params, mask) {
    return ajaxPost(path.saveReferenceModule, params, mask)
  },
  getReferenceModule: function (params, mask) {
    return ajaxGet(path.getReferenceModule, params, mask)
  },
  delReferenceModule: function (params, mask) {
    return ajaxGet(path.delReferenceModule, params, mask)
  },
  /** **********选成员组件 END******************************************************/
  getApplicationList: function (params, mask) {
    return ajaxGet(path.getApplicationList, params, mask)
  },
  getAllModule: function (params, mask) {
    return ajaxGet(path.getAllModule, params, mask)
  },
  getFindModuleListByAuth: function (params, mask) {
    return ajaxGet(path.getFindModuleListByAuth, params, mask)
  },
  getModuleList: function (params, mask) {
    return ajaxGet(path.getModuleList, params, mask)
  },
  getAppAllModuleList: function (params, mask) {
    return ajaxGet(path.getAppAllModuleList, params, mask)
  },
  getAllFieldList: function (params, mask) {
    return ajaxGet(path.getAllFieldList, params, mask)
  },
  queryBeanField: function (params, mask) {
    return ajaxGet(path.queryBeanField, params, mask)
  },
  getModuleRelations: function (params, mask) {
    return ajaxGet(path.getModuleRelations, params, mask)
  },
  getModuleRefFields: function (params, mask) {
    return ajaxGet(path.getModuleRefFields, params, mask)
  },
  getFieldsBySubform: function (params, mask) {
    return ajaxGet(path.getFieldsBySubform, params, mask)
  },
  getFieldsByNotSubform: function (params, mask) {
    return ajaxGet(path.getFieldsByNotSubform, params, mask)
  },
  getFunAuthList: function (params, mask) {
    return ajaxGet(path.getFunAuthList, params, mask)
  },
  getInitCondition: function (params, mask) {
    return ajaxGet(path.getInitCondition, params, mask)
  },
  getDynmicList: function (params, mask) {
    return ajaxGet(path.getDynmicList, params, mask)
  },
  getPicklistField: function (params, mask) {
    return ajaxGet(path.getPicklistField, params, mask)
  },
  queryDepartmentLevel: function (params, mask) {
    return ajaxGet(path.queryDepartmentLevel, params, mask)
  },
  getProcessApproval: function (params, mask) {
    return ajaxGet(path.getProcessApproval, params, mask)
  },
  getWorkflowLayoutBack: function (params, mask) {
    return ajaxGet(path.getWorkflowLayoutBack, params, mask)
  },
  getFieldTransList: function (params, mask, message) {
    return ajaxGet(path.getFieldTransList, params, mask)
  },
  addFieldTransform: function (data, mask, message) {
    return ajaxPost(path.addFieldTransform, data, mask)
  },
  delFieldTransform: function (data, mask, message) {
    return ajaxPost(path.delFieldTransform, data, mask)
  },
  getFieldTransformation: function (params, mask, message) {
    return ajaxGet(path.getFieldTransformation, params, mask)
  },
  editFieldTransform: function (data, mask, message) {
    return ajaxPost(path.editFieldTransform, data, mask)
  },
  queryInitAllotDateil: function (data, mask, message) {
    return ajaxPost(path.queryInitAllotDateil, data, mask)
  },
  getAllotList: function (params, mask) {
    return ajaxGet(path.queryAllotList, params, mask)
  },
  saveAllotRule: function (data, mask) {
    return ajaxPost(path.saveAllotRule, data, mask)
  },
  editAllotRule: function (data, mask) {
    return ajaxPost(path.editAllotRule, data, mask)
  },
  getAutoColorList: function (data, mask) {
    return ajaxGet(path.queryColourList, data, mask)
  },
  saveAtutoColor: function (data, mask) {
    return ajaxPost(path.saveAtutoColor, data, mask)
  },
  editColourRule: function (data, mask) {
    return ajaxPost(path.editColourRule, data, mask)
  },
  getHighSeasList: function (data, mask) {
    return ajaxGet(path.getHighSeasList, data, mask)
  },
  addHighSeas: function (data, mask) {
    return ajaxPost(path.addHighSeas, data, mask)
  },
  editHighSeas: function (data, mask) {
    return ajaxPost(path.editHighSeas, data, mask)
  },
  deleteHighSeas: function (data, mask) {
    return ajaxPost(path.deleteHighSeas, data, mask)
  },
  getEditHighSeas: function (data, mask) {
    return ajaxGet(path.getTeapoolById, data, mask)
  },
  savePushSettings: function (data, mask) {
    return ajaxPost(path.savePushSettings, data, mask)
  },
  saveAppDataListFields: function (data, mask) {
    return ajaxPost(path.saveAppDataListFields, data, mask, 0)
  },
  delProcessApproval: function (data, mask) {
    return ajaxPost(path.delProcessApproval, data, mask, 0)
  },
  getMaplist: function (params, mask) {
    return ajaxGet(path.getMaplist, params, mask)
  },
  addRelationMap: function (data, mask) {
    return ajaxPost(path.addRelationMap, data, mask)
  },
  deleRelationMap: function (data, mask) {
    return ajaxPost(path.deleRelationMap, data, mask)
  },
  editRelationMap: function (data, mask) {
    return ajaxPost(path.editRelationMap, data, mask)
  },
  addRelationRely: function (data, mask) {
    return ajaxPost(path.addRelationRely, data, mask)
  },
  deleteRelationRely: function (data, mask) {
    return ajaxPost(path.deleteRelationRely, data, mask)
  },
  queryAllSchemeFixedItemList: function (data, mask) {
    return ajaxGet(path.queryAllSchemeFixedItemList, data, mask)
  },
  editRelationRely: function (data, mask) {
    return ajaxPost(path.editRelationRely, data, mask)
  },
  addOptionFieldDepd: function (data, mask) {
    return ajaxPost(path.addOptionFieldDepd, data, mask)
  },
  editOptionDepd: function (data, mask) {
    return ajaxPost(path.editOptionDepd, data, mask)
  },
  delOptionDepd: function (data, mask) {
    return ajaxPost(path.delOptionDepd, data, mask)
  },
  addOptionFieldCtrl: function (data, mask) {
    return ajaxPost(path.addOptionFieldCtrl, data, mask)
  },
  delOptionCtrl: function (data, mask) {
    return ajaxPost(path.delOptionCtrl, data, mask)
  },
  editOptionCtrl: function (data, mask) {
    return ajaxPost(path.editOptionCtrl, data, mask)
  },
  getDataListFields: function (data, mask) {
    return ajaxGet(path.getDataListFields, data, mask, 0)
  },
  uploadPrintFile: function (data, mask) {
    return ajaxPost(path.uploadPrintFile, data, mask)
  },
  downloadPrintFile: function (data, mask) {
    return ajaxPost(path.downloadPrintFile, data, mask)
  },
  createPrintTemplate: function (data, mask) {
    return ajaxPost(path.createPrintTemplate, data, mask)
  },
  updatePrintTemplate: function (data, mask) {
    return ajaxPost(path.updatePrintTemplate, data, mask)
  },
  delPrintTemplate: function (data, mask) {
    return ajaxPost(path.delPrintTemplate, data, mask)
  },
  getPrintTemplateList: function (params, mask) {
    return ajaxGet(path.getPrintTemplateList, params, mask)
  },
  getPreviewPDF: function (params, mask) {
    return ajaxPost(path.getPreviewPDF, params, mask)
  },
  getModuleFieldList: function (params, mask) {
    return ajaxGet(path.getModuleFieldList, params, mask)
  },
  submitLayout: function (data, mask) {
    return ajaxPost(path.submitLayout, data, mask, 0)
  },
  getEnableLayout: function (params, mask) {
    return ajaxGet(path.getEnableLayout, params, mask)
  },
  getEnableLayoutBack: function (params, mask) {
    return ajaxGet(path.getEnableLayoutBack, params, mask)
  },
  getDisableLayout: function (params, mask) {
    return ajaxGet(path.getDisableLayout, params, mask)
  },
  getDisableLayoutBack: function (params, mask) {
    return ajaxGet(path.getDisableLayoutBack, params, mask)
  },
  getRepeatCheckList: function (params, mask) {
    return ajaxGet(path.getRepeatCheckList, params, mask)
  },
  getReferenceList: function (data, mask, message) {
    return ajaxPost(path.getReferenceList, data, mask)
  },
  customSubmitData: function (data, mask, message) {
    return ajaxPost(path.customSubmitData, data, mask)
  },
  customEditData: function (data, mask) {
    return ajaxPost(path.customEditData, data, mask)
  },
  customEditDataNew: function (data, mask) {
    return ajaxPost(path.customEditDataNew, data, mask)
  },
  customDeleteData: function (data, mask) {
    return ajaxPost(path.customDeleteData, data, mask)
  },
  getCustomList: function (data, mask, customHeaders) {
    return ajaxPost(path.getCustomList, data, mask, undefined, customHeaders)
  },
  customDtlData: function (params, mask) {
    return ajaxGet(path.customDtlData, params, mask)
  },
  customDtlRelationData: function (params, mask) {
    return ajaxGet(path.customDtlRelationData, params, mask)
  },
  customRelationList: function (params, mask) {
    return ajaxGet(path.customRelationList, params, mask)
  },
  getCustomListShow: function (params, mask) {
    return ajaxGet(path.getCustomListShow, params, mask)
  },
  getFilterList: function (params, mask) {
    return ajaxGet(path.getFilterList, params, mask)
  },
  transferPrincipal: function (data, mask) {
    return ajaxPost(path.transferPrincipal, data, mask)
  },
  addDataShare: function (data, mask) {
    return ajaxPost(path.addDataShare, data, mask)
  },
  updataDataShare: function (data, mask) {
    return ajaxPost(path.updataDataShare, data, mask)
  },
  highSeasPoolMove: function (data, mask) {
    return ajaxPost(path.highSeasPoolMove, data, mask)
  },
  highSeasPoolDistribute: function (data, mask) {
    return ajaxPost(path.highSeasPoolDistribute, data, mask)
  },
  highSeasPoolGet: function (data, mask) {
    return ajaxPost(path.highSeasPoolGet, data, mask)
  },
  highSeasPoolBack: function (data, mask) {
    return ajaxPost(path.highSeasPoolBack, data, mask)
  },
  addSubMenu: function (data, mask) {
    return ajaxPost(path.addSubMenu, data, mask)
  },
  updateSubMenu: function (data, mask) {
    return ajaxPost(path.updateSubMenu, data, mask)
  },
  sortSubMenu: function (data, mask) {
    return ajaxPost(path.sortSubMenu, data, mask)
  },
  deleteSubMenu: function (data, mask) {
    return ajaxPost(path.deleteSubMenu, data, mask)
  },
  convertData: function (data, mask) {
    return ajaxPost(path.convertData, data, mask)
  },
  getShareSetList: function (params, mask) {
    return ajaxGet(path.getShareSetList, params, mask)
  },
  deleteShareData: function (data, mask) {
    return ajaxPost(path.deleteShareData, data, mask)
  },
  dataImport: function (data, mask) {
    return ajaxPost(path.dataImport, data, mask)
  },
  uploadImportFile: function (data, mask) {
    return ajaxPost(path.uploadImportFile, data, mask, 3)
  },
  saveDataListShow: function (data, mask) {
    return ajaxPost(path.saveDataListShow, data, mask)
  },
  saveLabelShow: function (data, mask) {
    return ajaxPost(path.saveLabelShow, data, mask)
  },
  deleteApp: function (data, mask) {
    return ajaxPost(path.deleteApp, data, mask)
  },
  createApp: function (data, mask) {
    return ajaxPost(path.createApp, data, mask)
  },
  updateApp: function (data, mask) {
    return ajaxPost(path.updateApp, data, mask)
  },
  sortApp: function (data, mask) {
    return ajaxPost(path.sortApp, data, mask)
  },
  sortModules: function (data, mask) {
    return ajaxPost(path.sortModules, data, mask)
  },
  deleteModule: function (data, mask) {
    return ajaxPost(path.deleteModule, data, mask)
  },
  getSubmenuList: function (params, mask) {
    return ajaxGet(path.getSubmenuList, params, mask)
  },
  getAccountEmailList: function (params, mask) {
    return ajaxGet(path.getAccountEmailList, params, mask)
  },
  getAddModuleList: function (params, mask) {
    return ajaxGet(path.getAddModuleList, params, mask)
  },
  queryApprovalCount: function (params, mask) {
    return ajaxGet(path.queryApprovalCount, params, mask)
  },
  querySearchMenu: function (params, mask) {
    return ajaxGet(path.querySearchMenu, params, mask)
  },
  queryApprovalList: function (data, mask) {
    return ajaxPost(path.queryApprovalList, data, mask)
  },
  queryApprovalData: function (data, mask) {
    return ajaxPost(path.queryApprovalData, data, mask)
  },
  approvalRead: function (data, mask) {
    return ajaxPost(path.approvalRead, data, mask)
  },
  ccTo: function (data, mask) {
    return ajaxPost(path.ccTo, data, mask)
  },
  urgeTo: function (data, mask) {
    return ajaxPost(path.urgeTo, data, mask)
  },
  revoke: function (data, mask) {
    return ajaxPost(path.revoke, data, mask)
  },
  removeProcessApproval: function (data, mask) {
    return ajaxPost(path.removeProcessApproval, data, mask)
  },
  getApprovalTypeList: function (params, mask) {
    return ajaxGet(path.getApprovalTypeList, params, mask)
  },
  getApprovalManageList: function (data, mask) {
    return ajaxPost(path.getApprovalManageList, data, mask)
  },
  delApprovalManageData: function (data, mask) {
    return ajaxPost(path.delApprovalManageData, data, mask)
  },
  getApprovalFlowList: function (params, mask) {
    return ajaxGet(path.getApprovalFlowList, params, mask)
  },
  /* *** 备忘录 START************************** */
  uploadForMemo: function (data, mask) {
    return ajaxPost(path.uploadForMemo, data, mask, 3)
  },
  saveMemo: function (data, mask) {
    return ajaxPost(path.saveMemo, data, mask)
  },
  findMemoList: function (params, mask) {
    return ajaxGet(path.findMemoList, params, mask)
  },
  findMemoListTask: function (params, mask) {
    return ajaxGet(path.findMemoListTask, params, mask)
  },
  findMemoDetail: function (params, mask) {
    return ajaxGet(path.findMemoDetail, params, mask)
  },
  memoEdit: function (data, mask) {
    return ajaxPost(path.memoEdit, data, mask)
  },
  memoDel: function (data, mask) {
    return ajaxPost(path.memoDel, data, mask)
  },
  memoFindRelationList: function (data, mask) {
    return ajaxGet(path.memoFindRelationList, data, mask)
  },
  memoUpdateRelationById: function (data, mask) {
    return ajaxPost(path.memoUpdateRelationById, data, mask)
  },
  getFirstFieldFromModule: function (params, mask) {
    return ajaxGet(path.getFirstFieldFromModule, params, mask)
  },
  getFuncAuthWithCommunal: function (params, mask) {
    return ajaxGet(path.getFuncAuthWithCommunal, params, mask)
  },
  /* *** 备忘录 END***************************** */
  /* *自定义图表********* */
  getSourceRelationModule: function (params, mask) {
    return ajaxGet(path.getSourceRelationModule, params, mask)
  },
  getSourceField: function (params, mask) {
    return ajaxGet(path.getSourceField, params, mask)
  },
  getDashList: function (params, mask) {
    return ajaxGet(path.getDashList, params, mask)
  },
  saveDashBoard: function (params, mask) {
    return ajaxPost(path.saveDashBoard, params, mask)
  },
  previewSinge: function (data, mask) {
    return ajaxPost(path.previewSinge, data, mask)
  },
  showSingleForReport: function (data, mask) {
    return ajaxPost(path.showSingleForReport, data, mask)
  },
  getDashLayout: function (data, mask) {
    return ajaxGet(path.getDashLayout, data, mask)
  },
  delDashLayout: function (data, mask) {
    return ajaxPost(path.delDashLayout, data, mask)
  },
  editDashLayout: function (data, mask) {
    return ajaxPost(path.editDashLayout, data, mask)
  },
  runSinge: function (data, mask) {
    return ajaxPost(path.runSinge, data, mask)
  },
  /* *end */
  /* *邮件 START */
  delMailContact: function (params, mask) {
    return ajaxPost(path.delMailContact, params, mask)
  },
  saveMailAccount: function (params, mask) {
    return ajaxPost(path.saveMailAccount, params, mask)
  },
  editMailAccount: function (params, mask) {
    return ajaxPost(path.editMailAccount, params, mask)
  },
  mailAccountQueryById: function (params, mask) {
    return ajaxGet(path.mailAccountQueryById, params, mask)
  },
  delMailAccount: function (params, mask) {
    return ajaxPost(path.delMailAccount, params, mask)
  },
  mailAccountQueryList: function (params, mask) {
    return ajaxGet(path.mailAccountQueryList, params, mask)
  },
  validateAccount: function (params, mask) {
    return ajaxPost(path.validateAccount, params, mask)
  },
  openOrCloseAccount: function (params, mask) {
    return ajaxPost(path.openOrCloseAccount, params, mask)
  },
  setDefaultAccount: function (params, mask) {
    return ajaxPost(path.setDefaultAccount, params, mask)
  },
  getReceiveSettingInfo: function (params, mask) {
    return ajaxGet(path.getReceiveSettingInfo, params, mask)
  },
  saveReceiveSetting: function (params, mask) {
    return ajaxPost(path.saveReceiveSetting, params, mask)
  },
  addMailSignature: function (params, mask) {
    return ajaxPost(path.addMailSignature, params, mask)
  },
  mailSignatureQueryById: function (params, mask) {
    return ajaxGet(path.mailSignatureQueryById, params, mask)
  },
  mailSignatureEdit: function (params, mask) {
    return ajaxPost(path.mailSignatureEdit, params, mask)
  },
  delMailSignature: function (params, mask) {
    return ajaxPost(path.delMailSignature, params, mask)
  },
  mailSignatureQueryList: function (params, mask) {
    return ajaxGet(path.mailSignatureQueryList, params, mask)
  },
  openOrSignature: function (params, mask) {
    return ajaxPost(path.openOrSignature, params, mask)
  },
  setDefaultSignature: function (params, mask) {
    return ajaxPost(path.setDefaultSignature, params, mask)
  },
  mailWhiteBlackQueryList: function (params, mask) {
    return ajaxGet(path.mailWhiteBlackQueryList, params, mask)
  },
  saveMailWhiteBlack: function (params, mask) {
    return ajaxPost(path.saveMailWhiteBlack, params, mask)
  },
  mailCatalogqueryList: function (params, mask) {
    return ajaxGet(path.mailCatalogqueryList, params, mask)
  },
  delMailWhiteBlack: function (params, mask) {
    return ajaxPost(path.delMailWhiteBlack, params, mask)
  },
  queryPersonnelAccount: function (params, mask) {
    return ajaxGet(path.queryPersonnelAccount, params, mask)
  },
  mailTagQueryList: function (params, mask) {
    return ajaxGet(path.mailTagQueryList, params, mask)
  },
  mailTagSave: function (params, mask) {
    return ajaxPost(path.mailTagSave, params, mask)
  },
  delMailTag: function (params, mask) {
    return ajaxPost(path.delMailTag, params, mask)
  },
  mailTagQueryById: function (params, mask) {
    return ajaxGet(path.mailTagQueryById, params, mask)
  },
  mailTagEdit: function (params, mask) {
    return ajaxPost(path.mailTagEdit, params, mask)
  },
  mailReceiveRegulationQueryList: function (params, mask) {
    return ajaxGet(path.mailReceiveRegulationQueryList, params, mask)
  },
  getInitailParameters: function (params, mask) {
    return ajaxGet(path.getInitailParameters, params, mask)
  },
  mailTagQueryTagList: function (params, mask) {
    return ajaxGet(path.mailTagQueryTagList, params, mask)
  },
  saveMailReceiveRegulation: function (params, mask) {
    return ajaxPost(path.saveMailReceiveRegulation, params, mask)
  },
  editMailReceiveRegulation: function (params, mask) {
    return ajaxPost(path.editMailReceiveRegulation, params, mask)
  },
  mailReceiveRegulationQueryById: function (params, mask) {
    return ajaxGet(path.mailReceiveRegulationQueryById, params, mask)
  },
  openOrCloseRegulation: function (params, mask) {
    return ajaxPost(path.openOrCloseRegulation, params, mask)
  },
  delmailReceiveRegulation: function (params, mask) {
    return ajaxPost(path.delmailReceiveRegulation, params, mask)
  },
  backOperationBlurMail: function (params, mask) {
    return ajaxGet(path.backOperationBlurMail, params, mask)
  },
  delBackOperation: function (params, mask) {
    return ajaxPost(path.delBackOperation, params, mask)
  },
  getEmailWhere: function (params, mask) {
    return ajaxGet(path.getEmailWhere, params, mask)
  },
  delMailCatalog: function (params, mask) {
    return ajaxPost(path.delMailCatalog, params, mask)
  },
  saveMailCatalog: function (params, mask) {
    return ajaxPost(path.saveMailCatalog, params, mask)
  },
  getProcessTypeForMail: function (params, mask) {
    return ajaxGet(path.getProcessTypeForMail, params, mask)
  },
  getMailTempManager: function (params, mask) {
    return ajaxGet(path.getMailTempManager, params, mask)
  },
  saveMailTempManager: function (params, mask) {
    return ajaxPost(path.saveMailTempManager, params, mask)
  },
  queryMailTempList: function (params, mask) {
    return ajaxGet(path.queryMailTempList, params, mask)
  },
  addMailTemp: function (params, mask) {
    return ajaxPost(path.addMailTemp, params, mask)
  },
  updateMailTemp: function (params, mask) {
    return ajaxPost(path.updateMailTemp, params, mask)
  },
  deleteMailTemp: function (params, mask) {
    return ajaxPost(path.deleteMailTemp, params, mask)
  },
  isMailTempAdmin: function (params, mask) {
    return ajaxGet(path.isMailTempAdmin, params, mask)
  },
  saveMailShare: function (params, mask) {
    return ajaxPost(path.saveMailShare, params, mask)
  },
  editMailShare: function (params, mask) {
    return ajaxPost(path.editMailShare, params, mask)
  },
  deleteMailShare: function (params, mask) {
    return ajaxPost(path.deleteMailShare, params, mask)
  },
  queryMailShareById: function (params, mask) {
    return ajaxGet(path.queryMailShareById, params, mask)
  },
  queryMailShareList: function (params, mask) {
    return ajaxGet(path.queryMailShareList, params, mask)
  },
  queryEmailShareEmployeeList: function (params, mask) {
    return ajaxGet(path.queryEmailShareEmployeeList, params, mask)
  },
  mailCommonsave: function (params, mask) {
    return ajaxPost(path.mailCommonsave, params, mask)
  },
  queryCommonAccountList: function (params, mask) {
    return ajaxGet(path.queryCommonAccountList, params, mask)
  },
  commonAccountDel: function (params, mask) {
    return ajaxPost(path.commonAccountDel, params, mask)
  },
  emailImageUpload: function (params, mask) {
    return ajaxPost(path.emailImageUpload, params, mask, 3)
  },
  saveReport: function (params, mask) {
    return ajaxPost(path.saveReport, params, mask)
  },
  getReportList: function (params, mask) {
    return ajaxGet(path.getReportList, params, mask)
  },
  removeReport: function (params, mask) {
    return ajaxPost(path.removeReport, params, mask)
  },
  getReportLayoutDetail: function (params, mask) {
    return ajaxGet(path.getReportLayoutDetail, params, mask)
  },
  getReportDataDetail: function (params, mask) {
    return ajaxPost(path.getReportDataDetail, params, mask)
  },
  getFilterFields: function (params, mask) {
    return ajaxGet(path.getFilterFields, params, mask)
  },
  getReportFilterFields: function (params, mask) {
    return ajaxGet(path.getReportFilterFields, params, mask)
  },
  getReportEditLayoutFilterFields: function (params, mask) {
    return ajaxGet(path.getReportEditLayoutFilterFields, params, mask)
  },
  checkReportNameExist: function (params, mask) {
    return ajaxGet(path.checkReportNameExist, params, mask)
  },
  getQueryCommentDetail: function (params, mask) {
    return ajaxGet(path.getQueryCommentDetail, params, mask)
  },
  postSavaCommonComment: function (params, mask) {
    return ajaxPost(path.postSavaCommonComment, params, mask)
  },
  postFileVersionUpload: function (params, mask) {
    return ajaxPost(path.postFileVersionUpload, params, mask, 3)
  },
  fileLibraryUpload: function (params, mask) {
    return ajaxPost(path.fileLibraryUpload, params, mask, 3)
  },
  queryfileCatalog: function (params, mask) {
    return ajaxGet(path.queryfileCatalog, params, mask)
  },
  postWhetherFabulous: function (params, mask) {
    return ajaxPost(path.postWhetherFabulous, params, mask)
  },
  getQueryEmployeeInfo: function (params, mask) {
    return ajaxGet(path.getQueryEmployeeInfo, params, mask)
  },
  postEditEmployeeDetail: function (params, mask) {
    return ajaxPost(path.postEditEmployeeDetail, params, mask)
  },
  getApplyList: function (params, mask) {
    return ajaxGet(path.getApplyList, params, mask)
  },
  modificationCompany: function (params, mask) {
    return ajaxPost(path.modificationCompany, params, mask)
  },
  queryCompanyBanner: function (params, mask) {
    return ajaxGet(path.queryCompanyBanner, params, mask)
  },
  transferEnterprise: function (params, mask) {
    return ajaxPost(path.transferEnterprise, params, mask)
  },
  editCompanyAddress: function (params, mask) {
    return ajaxPost(path.editCompanyAddress, params, mask)
  },
  getCompanyAddress: function (params, mask) {
    return ajaxGet(path.getCompanyAddress, params, mask)
  },
  imageUpload: function (params, mask) {
    return ajaxPost(path.imageUpload, params, mask, 3)
  },
  whiteListMember: function (params, mask) {
    return ajaxGet(path.whiteListMember, params, mask)
  },
  getRecentlyCompanyPasswordStrategy: function (params, mask) {
    return ajaxGet(path.getRecentlyCompanyPasswordStrategy, params, mask)
  },
  retentionPolicy: function (params, mask) {
    return ajaxPost(path.retentionPolicy, params, mask)
  },
  autoLogout: function (params, mask) {
    return ajaxPost(path.autoLogout, params, mask)
  },
  deleteMember: function (params, mask) {
    return ajaxPost(path.deleteMember, params, mask)
  },
  addIpConnector: function (params, mask) {
    return ajaxPost(path.addIpConnector, params, mask)
  },
  deleteIpConnector: function (params, mask) {
    return ajaxPost(path.deleteIpConnector, params, mask)
  },
  addWhiteListMember: function (params, mask) {
    return ajaxPost(path.addWhiteListMember, params, mask)
  },
  getWhiteListMember: function (params, mask) {
    return ajaxGet(path.getWhiteListMember, params, mask)
  },
  changePhoneNumber: function (params, mask) {
    return ajaxPost(path.changePhoneNumber, params, mask)
  },
  savePasswordSetting: function (params, mask) {
    return ajaxPost(path.savePasswordSetting, params, mask)
  },
  applyCommentRequest: function (params, mask) {
    return ajaxGet(path.applyCommentRequest, params, mask)
  },
  centralControlParticularsRequest: function (params, mask) {
    return ajaxGet(path.centralControlParticularsRequest, params, mask)
  },
  submitApplyAudit: function (params, mask) {
    return ajaxPost(path.submitApplyAudit, params, mask)
  },
  auditRequest: function (params, mask) {
    return ajaxPost(path.auditRequest, params, mask)
  },
  applyCompileSave: function (params, mask) {
    return ajaxPost(path.applyCompileSave, params, mask)
  },
  getInquireApplyList: function (params, mask) {
    return ajaxGet(path.getInquireApplyList, params, mask)
  },
  getMyUploadApply: function (params, mask) {
    return ajaxGet(path.getMyUploadApply, params, mask)
  },
  deleteMyUploadApply: function (params, mask) {
    return ajaxPost(path.deleteMyUploadApply, params, mask)
  },
  queryTemplateMoneyList: function (params, mask) {
    return ajaxGet(path.queryTemplateMoneyList, params, mask)
  },
  getApplicationCenterList: function (params, mask) {
    return ajaxGet(path.getApplicationCenterList, params, mask)
  },
  findAllApplyClassify: function (params, mask) {
    return ajaxGet(path.findAllApplyClassify, params, mask)
  },
  findApplicationTemplateInfo: function (params, mask) {
    return ajaxPost(path.findApplicationTemplateInfo, params, mask)
  },
  queryToken: function (params, mask) {
    return ajaxGet(path.queryToken, params, mask)
  },
  applyParticularsRequest: function (params, mask) {
    return ajaxGet(path.applyParticularsRequest, params, mask)
  },
  commentMoreParticularsRequest: function (params, mask) {
    return ajaxGet(path.commentMoreParticularsRequest, params, mask)
  },
  commentParticularsRequest: function (params, mask) {
    return ajaxPost(path.commentParticularsRequest, params, mask)
  },
  installApply: function (params, mask) {
    return ajaxPost(path.installApply, params, mask)
  },
  getEstablishModule: function (params, mask) {
    return ajaxGet(path.getEstablishModule, params, mask)
  },
  getRoleFunctionList: function (params, mask) {
    return ajaxGet(path.getRoleFunctionList, params, mask)
  },
  commonBackupList: function (params, mask) {
    return ajaxPost(path.commonBackupList, params, mask)
  },
  commonExportData: function (params, mask) {
    return ajaxPost(path.commonExportData, params, mask)
  },
  commonBackupData: function (params, mask) {
    return ajaxPost(path.commonBackupData, params, mask)
  },
  commonBackupMoveData: function (params, mask) {
    return ajaxPost(path.commonBackupMoveData, params, mask)
  },
  commonUploadBackFile: function (params, mask) {
    return ajaxPost(path.commonUploadBackFile, params, mask, 3)
  },
  downloadBackupFile: function (params, mask) {
    return ajaxGet(path.downloadBackupFile, params, mask)
  },
  dealYunCompanyData: function (params, mask) {
    return ajaxGet(path.dealYunCompanyData, params, mask)
  },

  queryWhetherInstall: function (params, mask) {
    return ajaxGet(path.queryWhetherInstall, params, mask)
  },
  applicationAuthInstall: function (params, mask) {
    return ajaxPost(path.applicationAuthInstall, params, mask)
  },
  applicationCreateOrder: function (params, mask) {
    return ajaxPost(path.applicationCreateOrder, params, mask)
  },
  applicationQueryOrderInfo: function (params, mask) {
    return ajaxGet(path.applicationQueryOrderInfo, params, mask)
  },
  applicationPurchased: function (params, mask) {
    return ajaxPost(path.applicationPurchased, params, mask)
  },
  checkAuthorizationCodeUserCount: function (params, mask) {
    return ajaxPost(path.checkAuthorizationCodeUserCount, params, mask)
  },
  getFindCompanyDepartment: function (params, mask) {
    return ajaxGet(path.getFindCompanyDepartment, params, mask)
  },
  getFindUsersByCompany: function (params, mask) {
    return ajaxGet(path.getFindUsersByCompany, params, mask)
  },
  getRoleGroupList: function (params, mask) {
    return ajaxGet(path.getRoleGroupList, params, mask)
  },
  getPersonalFields: function (params, mask) {
    return ajaxGet(path.getPersonalFields, params, mask)
  },
  getQueryEmployee: function (params, mask) {
    return ajaxGet(path.getQueryEmployee, params, mask)
  },
  shareSave: function (params, mask) {
    // 协作分享新增
    return ajaxPost(path.shareSave, params, mask)
  },
  shareEdit: function (params, mask) {
    // 协作分享修改
    return ajaxPost(path.shareEdit, params, mask)
  },
  shareDelete: function (params, mask) {
    // 协作分享删除
    return ajaxPost(path.shareDelete, params, mask)
  },
  shareEditRelevance: function (params, mask) {
    // 协作分享关联变更
    return ajaxPost(path.shareEditRelevance, params, mask)
  },
  shareStick: function (params, mask) {
    // 协作分享置顶
    return ajaxPost(path.shareStick, params, mask)
  },
  sharePraise: function (params, mask) {
    // 协作分享点赞
    return ajaxPost(path.sharePraise, params, mask)
  },
  shareQueryById: function (params, mask) {
    // 协作分享详情
    return ajaxGet(path.shareQueryById, params, mask)
  },
  shareQueryList: function (params, mask) {
    // 协作分享列表数据
    return ajaxGet(path.shareQueryList, params, mask)
  },
  getSavaBack: function (params, mask) {
    // 个人偏好保存
    return ajaxPost(path.getSavaBack, params, mask)
  },
  saveInformation: function (params, mask) {
    // 基本设置保存项目信息
    return ajaxPost(path.saveInformation, params, mask)
  },
  saveSetting: function (params, mask) {
    // 项目设置保存
    return ajaxPost(path.saveSetting, params, mask)
  },
  editStatus: function (params, mask) {
    // 状态设置保存
    return ajaxPost(path.editStatus, params, mask)
  },
  editTaskAuth: function (params, mask) {
    // 任务权限变更
    return ajaxPost(path.editTaskAuth, params, mask)
  },
  editLabels: function (params, mask) {
    // 任务标签变更
    return ajaxPost(path.editLabels, params, mask)
  },
  projectQueryById: function (params, mask) {
    // 根据ID查询基本设置详情
    return ajaxGet(path.projectQueryById, params, mask)
  },
  queryTaskAuthList: function (params, mask) {
    // 根据项目ID 获取任务权限
    return ajaxGet(path.queryTaskAuthList, params, mask)
  },
  queryLabelsList: function (params, mask) {
    // 根据项目ID 获取标签列表
    return ajaxGet(path.queryLabelsList, params, mask)
  },
  projectControllerSave: function (params, mask) {
    // 保存项目信息
    return ajaxPost(path.projectControllerSave, params, mask)
  },
  queryMainNode: function (params, mask) {
    // 获取项目主节点
    return ajaxGet(path.queryMainNode, params, mask)
  },
  querySubNode: function (params, mask) {
    // 获取项目子节点
    return ajaxGet(path.querySubNode, params, mask)
  },
  queryAllNode: function (params, mask) {
    // 获取项目所有节点
    return ajaxGet(path.queryAllNode, params, mask)
  },
  saveMainNode: function (params, mask) {
    // 保存项目主节点
    return ajaxPost(path.saveMainNode, params, mask)
  },
  editMainNode: function (params, mask) {
    // 主节点重命名
    return ajaxPost(path.editMainNode, params, mask)
  },
  deleteMainNode: function (params, mask) {
    // 删除主节点
    return ajaxPost(path.deleteMainNode, params, mask)
  },
  sortMainNode: function (params, mask) {
    // 主节点拖动排序
    return ajaxPost(path.sortMainNode, params, mask)
  },
  saveSubNode: function (params, mask) {
    // 保存子节点
    return ajaxPost(path.saveSubNode, params, mask)
  },
  editSubNode: function (params, mask) {
    // 子节点重命名
    return ajaxPost(path.editSubNode, params, mask)
  },
  deleteSubNode: function (params, mask) {
    // 删除项目子节点
    return ajaxPost(path.deleteSubNode, params, mask)
  },
  sortSubNode: function (params, mask) {
    // 子节点拖动排序
    return ajaxPost(path.sortSubNode, params, mask)
  },
  queryTaskList: function (params, mask) {
    // 获取子节点下任务列表
    return ajaxGet(path.queryTaskList, params, mask)
  },
  queryAllWebList: function (params, mask) {
    // 获取全部项目列表
    return ajaxGet(path.queryAllWebList, params, mask)
  },
  queryProjectList: function (params, mask) {
    // 获取项目列表
    return ajaxGet(path.queryProjectList, params, mask)
  },
  queryMyLeaderWebList: function (params, mask) {
    // 获取我负责的项目列表
    return ajaxGet(path.queryMyLeaderWebList, params, mask)
  },
  queryMyJoinWebList: function (params, mask) {
    // 获取我参加的项目列表
    return ajaxGet(path.queryMyJoinWebList, params, mask)
  },
  queryMyCreateWebList: function (params, mask) {
    // 获取我创建的项目列表
    return ajaxGet(path.queryMyCreateWebList, params, mask)
  },
  queryOngoingWebList: function (params, mask) {
    // 获取进行中的项目列表
    return ajaxGet(path.queryOngoingWebList, params, mask)
  },
  queryCompletedWebList: function (params, mask) {
    // 获取已完成的项目列表
    return ajaxGet(path.queryCompletedWebList, params, mask)
  },
  MemberQueryList: function (params, mask) {
    // 获取成员列表
    return ajaxGet(path.MemberQueryList, params, mask)
  },
  MemberQueryById: function (params, mask) {
    // 根据ID查询详情
    return ajaxGet(path.MemberQueryById, params, mask)
  },
  MemberSave: function (params, mask) {
    // 新增成员
    return ajaxPost(path.MemberSave, params, mask)
  },
  MemberUpdate: function (params, mask) {
    // 修改成员
    return ajaxPost(path.MemberUpdate, params, mask)
  },
  MemberDelete: function (params, mask) {
    // 删除成员
    return ajaxPost(path.MemberDelete, params, mask)
  },
  deleteTaskMember: function (params, mask) {
    // 删除协作人
    return ajaxPost(path.deleteTaskMember, params, mask)
  },
  queryTaskWebList: function (params, mask) {
    // 获取子节点下任务列表
    return ajaxGet(path.queryTaskWebList, params, mask)
  },
  saveTaskWeb: function (params, mask) {
    // 新增任务
    return ajaxPost(path.saveTaskWeb, params, mask)
  },
  quoteTaskWeb: function (params, mask) {
    // 引用任务
    return ajaxPost(path.quoteTaskWeb, params, mask)
  },
  batchTaskWeb: function (params, mask) {
    // 任务批量操作
    return ajaxPost(path.batchTaskWeb, params, mask)
  },
  queryByIdTaskWeb: function (params, mask) {
    // 根据任务id查详情
    return ajaxGet(path.queryByIdTaskWeb, params, mask)
  },
  updateTaskWeb: function (params, mask) {
    // 修改任务
    return ajaxPost(path.updateTaskWeb, params, mask)
  },
  deleteTaskWeb: function (params, mask) {
    // 删除任务
    return ajaxPost(path.deleteTaskWeb, params, mask)
  },
  sortTaskWeb: function (params, mask) {
    // 任务拖拽排序
    return ajaxPost(path.sortTaskWeb, params, mask)
  },
  saveSubTaskWeb: function (params, mask) {
    // 新增子任务
    return ajaxPost(path.saveSubTaskWeb, params, mask)
  },
  updateSubTaskWeb: function (params, mask) {
    // 修改子任务
    return ajaxPost(path.updateSubTaskWeb, params, mask)
  },
  deleteSubTaskWeb: function (params, mask) {
    // 删除子任务
    return ajaxPost(path.deleteSubTaskWeb, params, mask)
  },
  querySubByIdTaskWeb: function (params, mask) {
    // 根据子任务id查详情
    return ajaxGet(path.querySubByIdTaskWeb, params, mask)
  },
  querySubListTaskWeb: function (params, mask) {
    // 获取任务下子任务列表
    return ajaxGet(path.querySubListTaskWeb, params, mask)
  },
  queryRelationListTaskWeb: function (params, mask) {
    // 获取任务下关联列表
    return ajaxGet(path.queryRelationListTaskWeb, params, mask)
  },
  queryByRelationListTaskWeb: function (params, mask) {
    // 获取任务下被关联列表
    return ajaxGet(path.queryByRelationListTaskWeb, params, mask)
  },
  saveRelationTaskWeb: function (params, mask) {
    // 子任务新增关联
    return ajaxPost(path.saveRelationTaskWeb, params, mask)
  },
  quoteRelationTaskWeb: function (params, mask) {
    // 子任务引用关联
    return ajaxPost(path.quoteRelationTaskWeb, params, mask)
  },
  cancleRelationTaskWeb: function (params, mask) {
    // 取消子任务关联
    return ajaxPost(path.cancleRelationTaskWeb, params, mask)
  },
  updateTaskStatus: function (params, mask) {
    // 任务勾选完成状态复选框
    return ajaxPost(path.updateTaskStatus, params, mask)
  },
  updateSubTaskStatus: function (params, mask) {
    // 子任务勾选完成状态复选框
    return ajaxPost(path.updateSubTaskStatus, params, mask)
  },
  tasksharePraise: function (params, mask) {
    // 任务上的点赞与取消点赞
    return ajaxPost(path.tasksharePraise, params, mask)
  },
  updatePassedStatus: function (params, mask) {
    // 任务上的通过按钮
    return ajaxPost(path.updatePassedStatus, params, mask)
  },
  updateSubPassedStatus: function (params, mask) {
    // 子任务上的通过按钮
    return ajaxPost(path.updateSubPassedStatus, params, mask)
  },
  saveTaskMember: function (params, mask) {
    // 新增项目任务协作人
    return ajaxPost(path.saveTaskMember, params, mask)
  },
  getProjectEnableLayout: function (params, mask) {
    // 获取协作人列表
    return ajaxGet(path.getProjectEnableLayout, params, mask)
  },
  updateTaskDetail: function (params, mask) {
    // 修改任务
    return ajaxPost(path.updateTaskDetail, params, mask)
  },
  queryCollaboratorList: function (params, mask) {
    // 获取任务自定义使用字段布局
    return ajaxGet(path.queryCollaboratorList, params, mask)
  },
  saveProjectLayout: function (params, mask) {
    // 保存任务自定义业务数据
    return ajaxPost(path.saveProjectLayout, params, mask)
  },
  editProjectLayout: function (params, mask) {
    // 修改任务自定义数据
    return ajaxPost(path.editProjectLayout, params, mask)
  },
  queryProjectDataDetail: function (params, mask) {
    // 修改任务自定义数据
    return ajaxGet(path.queryProjectDataDetail, params, mask)
  },
  queryByHierarchy: function (params, mask) {
    // 任务层级关系接口
    return ajaxGet(path.queryByHierarchy, params, mask)
  },
  queryManagementRoleInfo: function (params, mask) {
    // 查询获取成员列表成员的权限
    return ajaxGet(path.queryManagementRoleInfo, params, mask)
  },
  findApprovalModuleList: function (params, mask) {
    // 获取审批模块列表 或  审批获取模块数据列表
    return ajaxGet(path.findApprovalModuleList, params, mask)
  },
  queryProjectApprovaList: function (params, mask) {
    // 获取审批模块列表 或  审批获取模块数据列表
    return ajaxPost(path.queryProjectApprovaList, params, mask)
  },
  queryProjectTaskConditions: function (params, mask) {
    // 获取任务筛选自定义条件接口
    return ajaxGet(path.queryProjectTaskConditions, params, mask)
  },
  queryProjectTaskListByCondition: function (params, mask) {
    // 项目任务筛选接口
    return ajaxPost(path.queryProjectTaskListByCondition, params, mask)
  },
  updateTaskSubNode: function (params, mask) {
    // 移动任务指定分列下面
    return ajaxPost(path.updateTaskSubNode, params, mask)
  },
  editProgress: function (params, mask) {
    // 更新项目项目进度
    return ajaxPost(path.editProgress, params, mask)
  },
  editTaskSort: function (params, mask) {
    // 项目任务设置，修改任务排序与任务设置
    return ajaxPost(path.editTaskSort, params, mask)
  },
  updateProjectAsterisk: function (params, mask) {
    // 更新项目星标
    return ajaxPost(path.updateProjectAsterisk, params, mask)
  },
  queryTaskListByCondition: function (params, mask) {
    // 获取任务列表(个人任务筛选)
    return ajaxPost(path.queryTaskListByCondition, params, mask)
  },
  findAllModuleListByAuth: function (params, mask) {
    // 获取所有自定义模块根据当前登陆人权限
    return ajaxGet(path.findAllModuleListByAuth, params, mask)
  },
  findDataListByModuleAuth: function (params, mask) {
    // 搜索模块数据
    return ajaxPost(path.findDataListByModuleAuth, params, mask)
  },
  personelTaskSave: function (params, mask) {
    // 新增个人任务数据
    return ajaxPost(path.personelTaskSave, params, mask)
  },
  deletePersonelData: function (params, mask) {
    // 删除个人任务数据
    return ajaxPost(path.deletePersonelData, params, mask)
  },
  queryProjectEmployee: function (params, mask) {
    // 人员卡片信息
    return ajaxGet(path.queryProjectEmployee, params, mask)
  },
  queryShareRelationList: function (params, mask) {
    // 协作分享获取关联内容
    return ajaxGet(path.queryShareRelationList, params, mask)
  },
  shareCancleRelation: function (params, mask) {
    // 协作分享取消关联内容
    return ajaxPost(path.shareCancleRelation, params, mask)
  },
  shareSaveRelation: function (params, mask) {
    // 协作分享新增关联内容
    return ajaxPost(path.shareSaveRelation, params, mask)
  },
  saveProjectToTemplate: function (params, mask) {
    // 保存项目模板
    return ajaxPost(path.saveProjectToTemplate, params, mask)
  },
  queryProjectTemplateList: function (params, mask) {
    // 获取项目模板
    return ajaxGet(path.queryProjectTemplateList, params, mask)
  },
  deleteProjectTemplate: function (params, mask) {
    // 删除项目模板
    return ajaxPost(path.deleteProjectTemplate, params, mask)
  },
  queryProjectTemplateAllNode: function (params, mask) {
    // 获取模板任务分组
    return ajaxGet(path.queryProjectTemplateAllNode, params, mask)
  },
  queryQuoteTask: function (params, mask) {
    // 获取关联任务
    return ajaxGet(path.queryQuoteTask, params, mask)
  },
  queryProjectLibraryList: function (params, mask) {
    return ajaxGet(path.queryProjectLibraryList, params, mask)
  },
  queryProjectFileLibraryList: function (params, mask) {
    return ajaxGet(path.queryProjectFileLibraryList, params, mask)
  },
  queryTaskLibraryList: function (params, mask) {
    return ajaxGet(path.queryTaskLibraryList, params, mask)
  },
  searchTaskLibraryList: function (params, mask) {
    return ajaxGet(path.searchTaskLibraryList, params, mask)
  },
  savaProjectFileLibrary: function (params, mask) {
    // 保存
    return ajaxPost(path.savaProjectFileLibrary, params, mask)
  },
  editProjectLibrary: function (params, mask) {
    // 修改文件夹
    return ajaxPost(path.editProjectLibrary, params, mask)
  },
  delProjectLibrary: function (params, mask) {
    // 删除文件、夹
    return ajaxPost(path.delProjectLibrary, params, mask)
  },
  sharProjectLibrary: function (params, mask) {
    // 共享文件
    return ajaxPost(path.sharProjectLibrary, params, mask)
  },
  projectDownload: function (params, mask) {
    // 下载文件
    return ajaxGet(path.projectDownload, params, mask)
  },
  projectDownloadList: function (params, mask) {
    // 下载文件列表
    return ajaxGet(path.projectDownloadList, params, mask)
  },
  batchDownloadProject: function (params, mask) {
    // 下载文件列表
    return ajaxGet(path.batchDownloadProject, params, mask)
  },
  projectPersonalUpload: function (params, mask) {
    // 上传文件
    return ajaxPost(path.projectPersonalUpload, params, mask, 3)
  },
  findPersonelTaskConditions: function (params, mask) {
    // 获取任务筛选条件
    return ajaxGet(path.findPersonelTaskConditions, params, mask)
  },
  queryQuoteList: function (params, mask) {
    // 获取引用任务列表
    return ajaxGet(path.queryQuoteList, params, mask)
  },
  queryTaskViewStatus: function (params, mask) {
    // 查看任务/子任务状态
    return ajaxGet(path.queryTaskViewStatus, params, mask)
  },
  copyTask: function (params, mask) {
    // 复制任务/子任务
    return ajaxPost(path.copyTask, params, mask)
  },
  getTaskRemind: function (params, mask) {
    // 获取设置任务提醒
    return ajaxGet(path.getTaskRemind, params, mask)
  },
  saveTaskRemind: function (params, mask) {
    // 保存设置任务提醒
    return ajaxPost(path.saveTaskRemind, params, mask)
  },
  getPersonelDataDetail: function (params, mask) {
    // 获取个人任务详情
    return ajaxGet(path.getPersonelDataDetail, params, mask)
  },
  updateForFinish: function (params, mask) {
    // 勾选个人任务完成
    return ajaxPost(path.updateForFinish, params, mask)
  },
  querySubTaskByTaskId: function (params, mask) {
    // 根据任务id所有子任务
    return ajaxGet(path.querySubTaskByTaskId, params, mask)
  },
  getPersonelSubDataDetail: function (params, mask) {
    // 获取个人子任务详情
    return ajaxGet(path.getPersonelSubDataDetail, params, mask)
  },
  savePersonelSubData: function (params, mask) {
    // 新增个人子任务数据
    return ajaxPost(path.savePersonelSubData, params, mask)
  },
  deletePersonelSubData: function (params, mask) {
    // 删除个人子任务数据
    return ajaxPost(path.deletePersonelSubData, params, mask)
  },
  updateSubForFinish: function (params, mask) {
    // 勾选个人子任务完成
    return ajaxPost(path.updateSubForFinish, params, mask)
  },
  saveAssociatesData: function (params, mask) {
    // 新增关联数据
    return ajaxPost(path.saveAssociatesData, params, mask)
  },
  deleteAssociatesData: function (params, mask) {
    // 删除关联数据
    return ajaxPost(path.deleteAssociatesData, params, mask)
  },
  queryTaskAssociatesByTaskIdAndType: function (params, mask) {
    // 根据任务id,任务类型获取任务关联
    return ajaxGet(path.queryTaskAssociatesByTaskIdAndType, params, mask)
  },
  queryBeTaskAssociatesByTaskIdAndType: function (params, mask) {
    // 根据任务id,任务名称获取被关联的（子任务不会被关联）
    return ajaxGet(path.queryBeTaskAssociatesByTaskIdAndType, params, mask)
  },
  savePersonelMemberData: function (params, mask) {
    // 添加任务协作人
    return ajaxPost(path.savePersonelMemberData, params, mask)
  },
  deletePersonelMemberData: function (params, mask) {
    // 删除任务协作人
    return ajaxPost(path.deletePersonelMemberData, params, mask)
  },
  queryMembersTaskId: function (params, mask) {
    // 获取任务协作人
    return ajaxGet(path.queryMembersTaskId, params, mask)
  },
  savePraiseRecordData: function (params, mask) {
    // 点赞/取消点赞
    return ajaxPost(path.savePraiseRecordData, params, mask)
  },
  getPraisePerson: function (params, mask) {
    // 获取点赞人
    return ajaxGet(path.getPraisePerson, params, mask)
  },
  saveTaskRemindData: function (params, mask) {
    // 新增任务设置数据
    return ajaxPost(path.saveTaskRemindData, params, mask)
  },
  deleteTaskRemindData: function (params, mask) {
    // 删除任务设置数据
    return ajaxPost(path.deleteTaskRemindData, params, mask)
  },
  findTaskListByProjectId: function (params, mask) {
    // 根据项目id获取项目任务列表
    return ajaxGet(path.findTaskListByProjectId, params, mask)
  },
  personelSubupdate: function (params, mask) {
    // 编辑个人 子 任务数据
    return ajaxPost(path.personelSubupdate, params, mask)
  },
  personelTaskupdate: function (params, mask) {
    // 编辑个人任务数据
    return ajaxPost(path.personelTaskupdate, params, mask)
  },
  praiseQueryList: function (params, mask) {
    // 任务上的点赞列表（子任务与任务）
    return ajaxGet(path.praiseQueryList, params, mask)
  },
  updateTaskPersonelMemberData: function (params, mask) {
    // 协作人可见不可见
    return ajaxPost(path.updateTaskPersonelMemberData, params, mask)
  },
  projectFileUpload: function (params, mask) {
    // 任务上的上传接口
    return ajaxPost(path.projectFileUpload, params, mask)
  },
  queryAllTagList: function (params, mask) {
    // 获取所有标签带结构
    return ajaxGet(path.queryAllTagList, params, mask)
  },
  queryPersonelTaskViewStatus: function (params, mask) {
    // 获取个人任务的状态
    return ajaxGet(path.queryPersonelTaskViewStatus, params, mask)
  },
  queryNodesNameById: function (params, mask) {
    // 获取工作流及其节点信息
    return ajaxGet(path.queryNodesNameById, params, mask)
  },
  querProjectyWorkflowList: function (params, mask) {
    // 查询项目企业工作流列表
    return ajaxGet(path.querProjectyWorkflowList, params, mask)
  },
  getPersonQueryTaskList: function (params, mask) {
    // 获取个人任务业务数据列表
    return ajaxGet(path.getPersonQueryTaskList, params, mask)
  },
  getPersonQueryCommonTaskList: function (params, mask) {
    // 获取项目任务个人任务业务数据列表
    return ajaxGet(path.getPersonQueryCommonTaskList, params, mask)
  },
  queryModuleList: function (params, mask) {
    // 获取自动化流程，所有模块
    return ajaxGet(path.queryModuleList, params, mask)
  },
  projectQueryAutomationById: function (params, mask) {
    // 获取协作自动化设置信息
    return ajaxGet(path.projectQueryAutomationById, params, mask)
  },
  projectEditAutomation: function (params, mask) {
    // 协作自动化设置修改
    return ajaxPost(path.projectEditAutomation, params, mask)
  },
  projectSaveAutomationRule: function (params, mask) {
    // 自动化设置添加
    return ajaxPost(path.projectSaveAutomationRule, params, mask)
  },
  projectQueryAutomationList: function (params, mask) {
    // 自动化设置列表
    return ajaxGet(path.projectQueryAutomationList, params, mask)
  },
  projectDeleteAutomation: function (params, mask) {
    // 协作自动化删除
    return ajaxPost(path.projectDeleteAutomation, params, mask)
  },
  projectQueryAutomationBean: function (params, mask) {
    // 获取模块及关联模块下拉数据
    return ajaxGet(path.projectQueryAutomationBean, params, mask)
  },
  projectQueryBeanField: function (params, mask) {
    // 获取模块下字段下拉数据
    return ajaxGet(path.projectQueryBeanField, params, mask)
  },
  queryProjectWorkbenchWebList: function (params, mask) {
    // 获取项目工作台数据
    return ajaxGet(path.queryProjectWorkbenchWebList, params, mask)
  },
  ProjectyquerWorkflowList: function (params, mask) {
    // 任务匹配初始化查询
    return ajaxGet(path.ProjectyquerWorkflowList, params, mask)
  },
  findTaskListForPageByProjectId: function (params, mask) {
    // 获取项目任务业务数据列表
    return ajaxGet(path.findTaskListForPageByProjectId, params, mask)
  },
  queryTaskEmployee: function (params, mask) {
    // 项目工作流获取人员，编辑任务反选
    return ajaxPost(path.queryTaskEmployee, params, mask)
  },
  getTaskRemindList: function (params, mask) {
    // 获取个人任务的提醒数据
    return ajaxGet(path.getTaskRemindList, params, mask)
  },
  personelTaskupdateData: function (params, mask) {
    // 修改个人任务设置
    return ajaxPost(path.personelTaskupdateData, params, mask)
  },
  personelTaskRepeatSaveData: function (params, mask) {
    // 新增任务重复设置
    return ajaxPost(path.personelTaskRepeatSaveData, params, mask)
  },
  updateTaskRepeatData: function (params, mask) {
    // 编辑任务重复设置
    return ajaxPost(path.updateTaskRepeatData, params, mask)
  },
  getTaskRepeatList: function (params, mask) {
    // 获取任务重复设置列表
    return ajaxGet(path.getTaskRepeatList, params, mask)
  },
  projectDataImport: function (params, mask) {
    // 模板数据处理
    return ajaxPost(path.projectDataImport, params, mask)
  },
  getTaskRoleFromPersonelTask: function (params, mask) {
    // 获取个人在个人任务中的角色
    return ajaxGet(path.getTaskRoleFromPersonelTask, params, mask)
  },
  queryTaskAnalysisByProjectId: function (params, mask) {
    // 查看任务进度
    return ajaxGet(path.queryTaskAnalysisByProjectId, params, mask)
  },
  updateRemind: function (params, mask) {
    // 项目任务-编辑任务设置提醒数据
    return ajaxPost(path.updateRemind, params, mask)
  },
  queryKanbanTaskNodeList: function (params, mask) {
    // 通过分组获取列表以及任务
    return ajaxGet(path.queryKanbanTaskNodeList, params, mask)
  },
  queryAllTaskList: function (params, mask) {
    // 获取项目下所有任务
    return ajaxGet(path.queryAllTaskList, params, mask)
  },
  queryTaskModuleList: function (params, mask) {
    // 获取项目下面的所有模块
    return ajaxGet(path.queryTaskModuleList, params, mask)
  },
  queryTaskListByModuleId: function (params, mask) {
    // 通过模块获取模块下面的任务
    return ajaxPost(path.queryTaskListByModuleId, params, mask)
  },
  projectTasksaveData: function (params, mask) {
    // 项目任务设置重复任务
    return ajaxPost(path.projectTasksaveData, params, mask)
  },
  projectTasksupdateData: function (params, mask) {
    // 项目任务编辑重复任务
    return ajaxPost(path.projectTasksupdateData, params, mask)
  },
  projectTaskgetTaskRepeatList: function (params, mask) {
    // 获取项目任务重复任务设置
    return ajaxGet(path.projectTaskgetTaskRepeatList, params, mask)
  },
  updateSubNodeDataType: function (params, mask) {
    // 修改任务列表数类型
    return ajaxPost(path.updateSubNodeDataType, params, mask)
  },
  queryRelationModuleList: function (params, mask) {
    // 获取工作台关联模块列表
    return ajaxGet(path.queryRelationModuleList, params, mask)
  },
  getRelationModuleInfo: function (params, mask) {
    // 获取工作台关联模块信息
    return ajaxGet(path.getRelationModuleInfo, params, mask)
  },
  workbenchRelationSave: function (params, mask) {
    // 保存工作台关联模板
    return ajaxPost(path.workbenchRelationSave, params, mask)
  },
  workbenchRelationUpdate: function (params, mask) {
    // 工作台修改关联模板
    return ajaxPost(path.workbenchRelationUpdate, params, mask)
  },
  workbenchRelationDel: function (params, mask) {
    // 删除关联模块
    return ajaxPost(path.workbenchRelationDel, params, mask)
  },
  projectWorkbenchEmployeeList: function (params, mask) {
    // 获取工作台可查看人员列表
    return ajaxGet(path.projectWorkbenchEmployeeList, params, mask)
  },
  changeEmployeePrivilege: function (params, mask) {
    // 任务工作台是否有权限切换用户
    return ajaxGet(path.changeEmployeePrivilege, params, mask)
  },
  queryTaskWorkbenchList: function (params, mask) {
    // 任务工作台是否有权限切换用户
    return ajaxGet(path.queryTaskWorkbenchList, params, mask)
  },
  backendAddRolePermissions: function (params, mask) {
    return ajaxPost(path.backendAddRolePermissions, params, mask)
  },
  backendEditorRolePermissions: function (params, mask) {
    return ajaxPost(path.backendEditorRolePermissions, params, mask)
  },
  saveProcessApproval: function (params, mask) {
    return ajaxPost(path.saveProcessApproval, params, mask)
  },
  getAllPermissions: function (params, mask) {
    return ajaxGet(path.getAllPermissions, params, mask)
  },
  getRoleMembersList: function (params, mask) {
    return ajaxGet(path.getRoleMembersList, params, mask)
  },
  deleteRole: function (params, mask) {
    return ajaxPost(path.deleteRole, params, mask)
  },
  getAuthByRole: function (params, mask) {
    return ajaxGet(path.getAuthByRole, params, mask)
  },
  dataAuthGetRoleGroupList: function (params, mask) {
    return ajaxGet(path.dataAuthGetRoleGroupList, params, mask)
  },
  dataAuthGetAuthName: function (params, mask) {
    return ajaxGet(path.dataAuthGetAuthName, params, mask)
  },
  modifyAuthByRole: function (params, mask) {
    return ajaxPost(path.modifyAuthByRole, params, mask)
  },
  getfieldListWithoutReference: function (params, mask) {
    return ajaxGet(path.getfieldListWithoutReference, params, mask)
  },
  getfieldListSelectField: function (params, mask) {
    return ajaxGet(path.getfieldListSelectField, params, mask)
  },
  getInitialParameter: function (params, mask) {
    return ajaxGet(path.getInitialParameter, params, mask)
  },
  deletePushSettings: function (params, mask) {
    return ajaxPost(path.deletePushSettings, params, mask)
  },
  editPushSettings: function (params, mask) {
    return ajaxPost(path.editPushSettings, params, mask)
  },
  forbidPushSettings: function (params, mask) {
    return ajaxPost(path.forbidPushSettings, params, mask)
  },
  getPushList: function (params, mask) {
    return ajaxGet(path.getPushList, params, mask)
  },
  getInitColourDateil: function (params, mask) {
    return ajaxGet(path.getInitColourDateil, params, mask)
  },
  deleteAutoColor: function (params, mask) {
    return ajaxPost(path.deleteAutoColor, params, mask)
  },
  getAppDetail: function (params, mask) {
    return ajaxGet(path.getAppDetail, params, mask)
  },
  findPcAllModuleList: function (params, mask) {
    return ajaxGet(path.findPcAllModuleList, params, mask)
  },
  getTemplateModuleByTemplateId: function (params, mask) {
    return ajaxGet(path.getTemplateModuleByTemplateId, params, mask)
  },
  saveApplicationModuleUsed: function (params, mask) {
    return ajaxPost(path.saveApplicationModuleUsed, params, mask)
  },
  queryModuleStatistics: function (params, mask) {
    return ajaxGet(path.queryModuleStatistics, params, mask)
  },
  getCooperationParentLabel: function (params, mask) {
    return ajaxGet(path.getCooperationParentLabel, params, mask)
  },
  newlyAddedSubclassification: function (params, mask) {
    return ajaxPost(path.newlyAddedSubclassification, params, mask)
  },
  SearchLabelContent: function (params, mask) {
    return ajaxGet(path.SearchLabelContent, params, mask)
  },
  deleteLabel: function (params, mask) {
    return ajaxPost(path.deleteLabel, params, mask)
  },
  editLabel: function (params, mask) {
    return ajaxPost(path.editLabel, params, mask)
  },
  getModuleShareById: function (params, mask) {
    // 新增数据点击编辑
    return ajaxGet(path.getModuleShareById, params, mask)
  },
  getShareSave: function (params, mask) {
    // 新增数据点击保存
    return ajaxPost(path.getShareSave, params, mask)
  },
  getShareDel: function (params, mask) {
    // 新增数据点击保存
    return ajaxPost(path.getShareDel, params, mask)
  },
  getShareupdate: function (params, mask) {
    // 编辑数据共享
    return ajaxPost(path.getShareupdate, params, mask)
  },
  getModuleDataShares: function (params, mask) {
    // 获取字段共享列表
    return ajaxGet(path.getModuleDataShares, params, mask)
  },
  getPicklistControlList: function (params, mask) {
    return ajaxGet(path.getPicklistControlList, params, mask)
  },
  getMoudleIdByBean: function (params, mask) {
    return ajaxGet(path.getMoudleIdByBean, params, mask)
  },
  getChildLayout: function (params, mask) {
    return ajaxGet(path.getChildLayout, params, mask)
  },
  // 新增工作流自动化设置
  saveWorkFlowAutoSettings: function (data, mask) {
    return ajaxPost(path.saveWorkFlowAutoSettings, data, mask)
  },
  // 获取工作流自动化设置列表
  getWorkFlowAutoSettingsList: function (params, mask) {
    return ajaxGet(path.getWorkFlowAutoSettingsList, params, mask)
  },
  // 获取工作流自动化设置详情
  getWorkFlowAutoSettingsDtl: function (params, mask) {
    return ajaxGet(path.getWorkFlowAutoSettingsDtl, params, mask)
  },
  // 修改工作流自动化设置
  updateWorkFlowAutoSettings: function (data, mask) {
    return ajaxPost(path.updateWorkFlowAutoSettings, data, mask)
  },
  // 删除工作流自动化设置
  deleteWorkFlowAutoSettings: function (data, mask) {
    return ajaxPost(path.deleteWorkFlowAutoSettings, data, mask)
  },
  getModuleAndRelModule: function (params, mask) {
    return ajaxGet(path.getModuleAndRelModule, params, mask)
  },
  // 获取模块下字段
  getModuleAndRelModuleField: function (params, mask) {
    return ajaxGet(path.getModuleAndRelModuleField, params, mask)
  },
  changeOrder: function (data, mask) {
    return ajaxPost(path.changeOrder, data, mask)
  },
  EmailTitleCount: function (data, mask) {
    return ajaxGet(path.EmailTitleCount, data, mask)
  },
  getEmailLabelTitle: function (data, mask) {
    return ajaxGet(path.getEmailLabelTitle, data, mask)
  },
  getEmailListContent: function (data, mask) {
    return ajaxGet(path.getEmailListContent, data, mask)
  },
  EMailAllMarkRead: function (data, mask) {
    return ajaxPost(path.EMailAllMarkRead, data, mask)
  },
  EmailMarkRead: function (data, mask) {
    return ajaxPost(path.EmailMarkRead, data, mask)
  },
  EmailMoveLabel: function (data, mask) {
    return ajaxPost(path.EmailMoveLabel, data, mask)
  },
  getEmailListParticulars: function (data, mask) {
    return ajaxGet(path.getEmailListParticulars, data, mask)
  },
  getEmailAndRecordsList: function (data, mask) {
    return ajaxGet(path.getEmailAndRecordsList, data, mask)
  },
  EmailRejection: function (data, mask) {
    return ajaxPost(path.EmailRejection, data, mask)
  },
  getAuthByBean: function (data, mask) {
    return ajaxGet(path.getAuthByBean, data, mask)
  },
  fileEditMember: function (data, mask) {
    return ajaxPost(path.fileEditMember, data, mask)
  }, //  修改文件夹管理员
  queryFileList: function (data, mask) {
    return ajaxGet(path.queryFileList, data, mask)
  }, //  获取公司文件根目录列表
  queryFilePartList: function (data, mask) {
    return ajaxGet(path.queryFilePartList, data, mask)
  }, //  公司子级目录
  queryAppFileList: function (data, mask) {
    return ajaxGet(path.queryAppFileList, data, mask)
  }, //  应用--应用文件夹
  queryModuleFileList: function (data, mask) {
    return ajaxGet(path.queryModuleFileList, data, mask)
  }, //  应用--模块文件夹
  queryModulePartFileList: function (data, mask) {
    return ajaxGet(path.queryModulePartFileList, data, mask, '', 400)
  }, //  应用--模块文件
  fileQuitShare: function (data, mask) {
    return ajaxPost(path.fileQuitShare, data, mask)
  }, //  退出共享
  fileCancelShare: function (data, mask) {
    return ajaxPost(path.fileCancelShare, data, mask)
  }, //  取消共享
  delFileLibrary: function (data, mask) {
    return ajaxPost(path.delFileLibrary, data, mask)
  }, //  删除文件
  copyFileLibrary: function (data, mask) {
    return ajaxPost(path.copyFileLibrary, data, mask)
  }, //  复制文件至...
  fileEditRename: function (data, mask) {
    return ajaxPost(path.fileEditRename, data, mask)
  }, //  文件重命名
  shiftFileLibrary: function (data, mask) {
    return ajaxPost(path.shiftFileLibrary, data, mask)
  }, //  移动文件夹
  shareFileLibaray: function (data, mask) {
    return ajaxPost(path.shareFileLibaray, data, mask)
  }, //  文件共享
  editFolder: function (data, mask) {
    return ajaxPost(path.editFolder, data, mask)
  }, //  编辑文件夹提交
  fileEditManageStaff: function (data, mask) {
    return ajaxPost(path.fileEditManageStaff, data, mask)
  }, //  保存管理员
  queryFolderInitDetail: function (data, mask) {
    return ajaxGet(path.queryFolderInitDetail, data, mask)
  }, //  文件夹详情
  fileUpdateSetting: function (data, mask) {
    return ajaxPost(path.fileUpdateSetting, data, mask)
  }, //  保存成员权限
  getBlurResultParentInfo: function (data, mask) {
    return ajaxGet(path.getBlurResultParentInfo, data, mask)
  }, //  获取文件夹路劲
  whetherFabulous: function (data, mask) {
    return ajaxPost(path.whetherFabulous, data, mask)
  }, //  文件点赞
  queryVersionList: function (data, mask) {
    return ajaxGet(path.queryVersionList, data, mask)
  }, //  查询文件版本记录
  queryDownLoadList: function (data, mask) {
    return ajaxGet(path.queryDownLoadList, data, mask)
  }, //  查询文件下载记录
  fileBlurSearchFile: function (data, mask) {
    return ajaxGet(path.fileBlurSearchFile, data, mask)
  }, //  搜索文件夹
  savaFileLibrary: function (data, mask) {
    return ajaxPost(path.savaFileLibrary, data, mask)
  }, //  新建文件夹
  queryAidePower: function (data, mask) {
    return ajaxGet(path.queryAidePower, data, mask)
  }, //  小助手进入文件库权限
  queryFileLibarayDetail: function (data, mask) {
    return ajaxGet(path.queryFileLibarayDetail, data, mask)
  },
  queryFileLibraryUrl: function (data, mask) {
    return ajaxGet(path.queryFileLibraryUrl, data, mask)
  },
  openUrlSava: function (data, mask) {
    return ajaxPost(path.openUrlSava, data, mask)
  },
  queryOpenUrlEmail: function (data, mask) {
    return ajaxGet(path.queryOpenUrlEmail, data, mask)
  },
  onlinePreview: function (data, mask) {
    return ajaxPost(path.onlinePreview, data, mask)
  },
  queryCompanyFileList: function (data, mask) {
    return ajaxGet(path.queryCompanyFileList, data, mask)
  },
  queryPersonalStatus: function (data, mask) {
    return ajaxGet(path.queryPersonalStatus, data, mask)
  },
  updateIsOpen: function (data, mask) {
    return ajaxPost(path.updateIsOpen, data, mask)
  },
  saveFilelibraryAdministrator: function (data, mask) {
    return ajaxPost(path.saveFilelibraryAdministrator, data, mask)
  },
  getFilelibraryAdministrators: function (data, mask) {
    return ajaxGet(path.getFilelibraryAdministrators, data, mask)
  },
  isFilelibraryAdministrator: function (data, mask) {
    return ajaxGet(path.isFilelibraryAdministrator, data, mask)
  },
  getDeletedFileList: function (data, mask) {
    return ajaxPost(path.getDeletedFileList, data, mask)
  },
  deleteCompletelyFile: function (data, mask) {
    return ajaxPost(path.deleteCompletelyFile, data, mask)
  },
  getApplicationModuleFiles: function (data, mask) {
    return ajaxPost(path.getApplicationModuleFiles, data, mask)
  },
  viewFolder: function (data, mask) {
    return ajaxPost(path.viewFolder, data, mask)
  },
  // 企信
  addSingleChat: function (data, mask) {
    return ajaxGet(path.addSingleChat, data, mask)
  },
  getListInfo: function (data, mask) {
    return ajaxGet(path.getListInfo, data, mask)
  },
  hideSession: function (data, mask) {
    return ajaxPost(path.hideSession, data, mask)
  },
  changeGroupMember: function (data, mask) {
    return ajaxPost(path.changeGroupMember, data, mask)
  },
  modifyGroupInfo: function (data, mask) {
    return ajaxPost(path.modifyGroupInfo, data, mask)
  },
  quitGroup: function (data, mask) {
    return ajaxGet(path.quitGroup, data, mask)
  },
  releaseGroup: function (data, mask) {
    return ajaxGet(path.releaseGroup, data, mask)
  },
  imsetTop: function (data, mask) {
    return ajaxPost(path.imsetTop, data, mask)
  },
  getGroupInfo: function (data, mask) {
    return ajaxGet(path.getGroupInfo, data, mask)
  },
  addGroupChat: function (data, mask) {
    return ajaxPost(path.addGroupChat, data, mask)
  },
  getAllGroupsInfo: function (data, mask) {
    return ajaxGet(path.getAllGroupsInfo, data, mask)
  },
  IMreadMessage: function (data, mask) {
    return ajaxGet(path.IMreadMessage, data, mask)
  },
  getAssisstantInfo: function (data, mask) {
    return ajaxGet(path.getAssisstantInfo, data, mask)
  },
  markReadOption: function (data, mask) {
    return ajaxGet(path.markReadOption, data, mask)
  },
  markAllRead: function (data, mask) {
    return ajaxGet(path.markAllRead, data, mask)
  },
  IMfindModuleList: function (data, mask) {
    return ajaxGet(path.IMfindModuleList, data, mask)
  },
  getAssistantMessage: function (data, mask) {
    return ajaxGet(path.getAssistantMessage, data, mask)
  },
  hideSessionWithStatus: function (data, mask) {
    return ajaxPost(path.hideSessionWithStatus, data, mask)
  },
  transferGroup: function (data, mask) {
    return ajaxPost(path.transferGroup, data, mask)
  },
  getUnreadAssistantMessage: function (data, mask) {
    return ajaxGet(path.getUnreadAssistantMessage, data, mask)
  },
  markAllAssistantRead: function (data, mask) {
    return ajaxPost(path.markAllAssistantRead, data, mask)
  },
  EmailDeleteCancel: function (data, mask) {
    return ajaxPost(path.EmailDeleteCancel, data, mask)
  },
  EmailCompletelyCancel: function (data, mask) {
    return ajaxPost(path.EmailCompletelyCancel, data, mask)
  },
  getEmailLabelList: function (data, mask) {
    return ajaxGet(path.getEmailLabelList, data, mask)
  },
  getEmailReceiving: function (data, mask) {
    return ajaxGet(path.getEmailReceiving, data, mask)
  },
  EmailisJunkMail: function (data, mask) {
    return ajaxPost(path.EmailisJunkMail, data, mask)
  },
  EmailDustbinTransfer: function (data, mask) {
    return ajaxPost(path.EmailDustbinTransfer, data, mask)
  },
  getEmailContactsList: function (data, mask) {
    return ajaxGet(path.getEmailContactsList, data, mask)
  },
  SelectContactFromModule: function (data, mask) {
    return ajaxGet(path.SelectContactFromModule, data, mask)
  },
  CommonRequestMethodSubmenusModuleClassification: function (data, mask) {
    return ajaxGet(path.CommonRequestMethodSubmenusModuleClassification, data, mask)
  },
  selectModuleGetEmailContact: function (data, mask) {
    return ajaxGet(path.selectModuleGetEmailContact, data, mask)
  },
  EmailSaveDraft: function (data, mask) {
    return ajaxPost(path.EmailSaveDraft, data, mask)
  },
  saveAllLayout: function (data, mask) {
    return ajaxPost(path.saveAllLayout, data, mask, 0)
  },
  getAllLayout: function (data, mask) {
    return ajaxGet(path.getAllLayout, data, mask, 0)
  },
  getAllLayoutBack: function (data, mask) {
    return ajaxGet(path.getAllLayoutBack, data, mask, 0)
  },
  compileSaveDraft: function (data, mask) {
    return ajaxPost(path.compileSaveDraft, data, mask)
  },
  EmailSendTransmission: function (data, mask) {
    return ajaxPost(path.EmailSendTransmission, data, mask)
  },
  EmailInterfaceSend: function (data, mask) {
    return ajaxPost(path.EmailInterfaceSend, data, mask)
  },
  EmailForwardingSend: function (data, mask) {
    return ajaxPost(path.EmailForwardingSend, data, mask)
  },
  EmailDraftManualSend: function (data, mask) {
    return ajaxPost(path.EmailDraftManualSend, data, mask)
  },
  removeMailTag: function (data, mask) {
    return ajaxPost(path.removeMailTag, data, mask)
  },
  receiptMail: function (data, mask) {
    return ajaxPost(path.receiptMail, data, mask)
  },
  queryEmailFileAuth: function (data, mask) {
    return ajaxGet(path.queryEmailFileAuth, data, mask)
  },
  queryworkbenchList: function (data, mask) {
    return ajaxGet(path.queryworkbenchList, data, mask)
  },
  delWorkbench: function (data, mask) {
    return ajaxPost(path.delWorkbench, data, mask)
  },
  addWorkbench: function (data, mask) {
    return ajaxPost(path.addWorkbench, data, mask)
  },
  editWorkbench: function (data, mask) {
    return ajaxPost(path.editWorkbench, data, mask)
  },
  sortWorkbench: function (data, mask) {
    return ajaxPost(path.sortWorkbench, data, mask)
  },
  getWorkbenchDetail: function (data, mask) {
    return ajaxGet(path.editWorkbenchDetail, data, mask)
  },
  validationIpInterface: function (data, mask) {
    return ajaxPost(path.validationIpInterface, data, mask)
  },
  queryOperationLogList: function (data, mask) {
    return ajaxPost(path.queryOperationLogList, data, mask)
  },
  queryLoginLogList: function (data, mask) {
    return ajaxPost(path.queryLoginLogList, data, mask)
  },
  loginLogExport: function (data, mask) {
    return ajaxPost(path.loginLogExport, data, mask)
  },
  operationLogExport: function (data, mask) {
    return ajaxPost(path.operationLogExport, data, mask)
  },
  getRecyclebinFields: function (data, mask) {
    return ajaxGet(path.getRecyclebinFields, data, mask)
  },
  recyclebinPhysics: function (data, mask) {
    return ajaxPost(path.recyclebinPhysics, data, mask)
  },
  dealRecyclebinData: function (data, mask) {
    return ajaxPost(path.dealRecyclebinData, data, mask)
  },
  saveWorkbench: function (data, mask) {
    return ajaxPost(path.saveWorkbench, data, mask)
  },
  getWorkbenchList: function (data, mask) {
    return ajaxGet(path.getWorkbenchList, data, mask)
  },
  getWorkbenchById: function (data, mask) {
    return ajaxGet(path.getWorkbenchById, data, mask)
  },
  getWorkbenchByName: function (data, mask) {
    return ajaxGet(path.getWorkbenchByName, data, mask)
  },
  orderByWorkbench: function (data, mask) {
    return ajaxPost(path.orderByWorkbench, data, mask)
  },
  getWorkbenchLayoutList: function (data, mask) {
    return ajaxGet(path.getWorkbenchLayoutList, data, mask)
  },
  getWorkbenchLayout: function (data, mask) {
    return ajaxGet(path.getWorkbenchLayout, data, mask)
  },
  getWorkbenchDataDetail: function (data, mask) {
    return ajaxPost(path.getWorkbenchDataDetail, data, mask)
  },
  getWorkbenchDataSingle: function (data, mask) {
    return ajaxPost(path.getWorkbenchDataSingle, data, mask)
  },
  getPersonalAndProjectTasks: function (data, mask) {
    return ajaxGet(path.getPersonalAndProjectTasks, data, mask)
  },

  // 企信 END
  addRoleGroup: function (data, mask) {
    return ajaxPost(path.addRoleGroup, data, mask)
  },
  renameRoleGroup: function (data, mask) {
    return ajaxPost(path.renameRoleGroup, data, mask)
  },
  deleteRoleGroup: function (data, mask) {
    return ajaxPost(path.deleteRoleGroup, data, mask)
  },
  addAuthRole: function (data, mask) {
    return ajaxPost(path.addAuthRole, data, mask)
  },
  modifyAuthRole: function (data, mask) {
    return ajaxPost(path.modifyAuthRole, data, mask)
  },
  copyRole: function (data, mask) {
    return ajaxPost(path.copyRole, data, mask)
  },
  deleteAuthRole: function (data, mask) {
    return ajaxPost(path.deleteAuthRole, data, mask)
  },
  modifyUserByRole: function (data, mask) {
    return ajaxPost(path.modifyUserByRole, data, mask)
  },
  getUserByRole: function (data, mask) {
    return ajaxGet(path.getUserByRole, data, mask)
  },
  sortRole: function (data, mask) {
    return ajaxGet(path.sortRole, data, mask)
  },
  getBackAuthByRole: function (data, mask) {
    return ajaxGet(path.getBackAuthByRole, data, mask)
  },
  saveBackAuth: function (data, mask) {
    return ajaxPost(path.saveBackAuth, data, mask)
  },
  saveSchedule: function (data, mask) {
    return ajaxPost(path.saveSchedule, data, mask)
  },
  getScheduleDetail: function (data, mask) {
    return ajaxPost(path.getScheduleDetail, data, mask)
  },
  getScheduleDetailNew: function (data, mask) {
    return ajaxPost(path.getScheduleDetailNew, data, mask)
  },
  getScheduleDataDetail: function (data, mask) {
    return ajaxGet(path.getScheduleDataDetail, data, mask)
  },
  updateScheduleContent: function (data, mask) {
    return ajaxPost(path.updateScheduleContent, data, mask)
  },
  delSchedule: function (data, mask) {
    return ajaxPost(path.delSchedule, data, mask)
  },
  workbenchfindRelationList: function (data, mask) {
    return ajaxGet(path.workbenchfindRelationList, data, mask)
  },
  getOnLineWorkDetail: function (data, mask) {
    return ajaxPost(path.getOnLineWorkDetail, data, mask)
  },
  saveWorkbenchCalendarShare: function (data, mask) {
    return ajaxPost(path.saveWorkbenchCalendarShare, data, mask)
  },
  getWorkbenchCalendarShareList: function (data, mask) {
    return ajaxPost(path.getWorkbenchCalendarShareList, data, mask)
  },
  delWorkbenchCalendarShare: function (data, mask) {
    return ajaxPost(path.delWorkbenchCalendarShare, data, mask)
  },
  getWorkbenchCalendarShareFromUsers: function (data, mask) {
    return ajaxGet(path.getWorkbenchCalendarShareFromUsers, data, mask)
  },

  /** 中央控制台 */
  savaFormalUser: function (data, mask) {
    return ajaxPost(path.savaFormalUser, data, mask)
  },
  queryRegisterUserById: function (data, mask) {
    return ajaxGet(path.queryRegisterUserById, data, mask)
  },
  editFormalCompanyUser: function (data, mask) {
    return ajaxPost(path.editFormalCompanyUser, data, mask)
  },
  queryFormalUserList: function (data, mask) {
    return ajaxGet(path.queryFormalUserList, data, mask)
  },
  queryCenterUserList: function (data, mask) {
    return ajaxGet(path.queryCenterUserList, data, mask)
  },
  disableFormalCompanyUser: function (data, mask) {
    return ajaxPost(path.disableFormalCompanyUser, data, mask)
  },
  enableFormalCompanyUser: function (data, mask) {
    return ajaxPost(path.enableFormalCompanyUser, data, mask)
  },
  delFormalCompanyUser: function (data, mask) {
    return ajaxPost(path.delFormalCompanyUser, data, mask)
  },
  queryRegisterUserList: function (data, mask) {
    return ajaxGet(path.queryRegisterUserList, data, mask)
  },
  centerAdoptAccount: function (data, mask) {
    return ajaxPost(path.centerAdoptAccount, data, mask)
  },
  centerPullBlacklist: function (data, mask) {
    return ajaxPost(path.centerPullBlacklist, data, mask)
  },
  centerDelCompanyUser: function (data, mask) {
    return ajaxPost(path.centerDelCompanyUser, data, mask)
  },
  centerDelInviteCode: function (data, mask) {
    return ajaxPost(path.centerDelInviteCode, data, mask)
  },
  centerSavaInvite: function (data, mask) {
    return ajaxPost(path.centerSavaInvite, data, mask)
  },
  centerQueryInviteList: function (data, mask) {
    return ajaxGet(path.centerQueryInviteList, data, mask)
  },
  centerQueryFchBtnAuth: function (data, mask) {
    return ajaxGet(path.centerQueryFchBtnAuth, data, mask)
  },
  /**   企业工作流 */
  queryWorkFlowList: function (data, mask) {
    return ajaxGet(path.queryWorkFlowList, data, mask)
  },
  queryWorkFlow: function (data, mask) {
    return ajaxGet(path.queryWorkFlow, data, mask)
  },
  saveWorkFlow: function (data, mask) {
    return ajaxPost(path.saveWorkFlow, data, mask)
  },
  editWorkFlow: function (data, mask) {
    return ajaxPost(path.editWorkFlow, data, mask)
  },
  /** 项目统计分析 */
  queryProjectStatistical: function (params, mask) {
    return ajaxGet(path.queryProjectStatistical, params, mask)
  },
  queryProjectsForStatistical: function (params, mask) {
    return ajaxGet(path.queryProjectsForStatistical, params, mask)
  },
  queryProjectsDetailForStatistical: function (data, mask) {
    return ajaxPost(path.queryProjectsDetailForStatistical, data, mask)
  },
  queryTaskAnalysis: function (data, mask) {
    return ajaxPost(path.queryTaskAnalysis, data, mask)
  },
  getModulePageList: function (params, mask) {
    return ajaxGet(path.getModulePageList, params, mask)
  },
  modifyModulePageAuth: function (params, mask) {
    return ajaxPost(path.modifyModulePageAuth, params, mask)
  },
  findSubpageist: function (params, mask) {
    return ajaxGet(path.findSubpageist, params, mask)
  },
  getChartListByModule: function (params, mask) {
    return ajaxGet(path.getChartListByModule, params, mask)
  },
  getChartLayoutByModuleId: function (params, mask) {
    return ajaxGet(path.getChartLayoutByModuleId, params, mask)
  },
  getWebformLayout: function (params, mask) {
    return ajaxGet(path.getWebformLayout, params, mask)
  },
  saveWebformLayout: function (data, mask) {
    return ajaxPost(path.saveWebformLayout, data, mask)
  },
  getWebformList: function (params, mask) {
    return ajaxGet(path.getWebformList, params, mask)
  },
  deleteWebformLayout: function (data, mask) {
    return ajaxPost(path.deleteWebformLayout, data, mask)
  },
  openWebformLayout: function (data, mask) {
    return ajaxPost(path.openWebformLayout, data, mask)
  },
  closeWebformLayout: function (data, mask) {
    return ajaxPost(path.closeWebformLayout, data, mask)
  },
  getWebFromTitleCount: function (params, mask) {
    return ajaxGet(path.getWebFromTitleCount, params, mask)
  },
  getAllMenuOfApp: function (params, mask) {
    return ajaxGet(path.getAllMenuOfApp, params, mask)
  },
  getMaplistUrl: function (params, mask) {
    return ajaxGet(path.getMaplistUrl, params, mask)
  },
  getRelyList: function (params, mask) {
    return ajaxGet(path.getRelyList, params, mask)
  },
  getOptionDepd: function (params, mask) {
    return ajaxGet(path.getOptionDepd, params, mask)
  },
  getOptionctrl: function (params, mask) {
    return ajaxGet(path.getOptionctrl, params, mask)
  },
  deleteWrokFlow: function (data, mask) {
    return ajaxPost(path.deleteWrokFlow, data, mask)
  },
  getFieldsOfWorkflow: function (params, mask) {
    return ajaxGet(path.getFieldsOfWorkflow, params, mask)
  },
  saveOutLinksSettings: function (data, mask) {
    return ajaxPost(path.saveOutLinksSettings, data, mask)
  },
  getOutLinksSettings: function (params, mask) {
    return ajaxGet(path.getOutLinksSettings, params, mask)
  },
  getDataLinksInfo: function (params, mask) {
    return ajaxGet(path.getDataLinksInfo, params, mask)
  },
  getRandomBarcode: function (params, mask) {
    return ajaxGet(path.getRandomBarcode, params, mask)
  },
  getBarcodeImg: function (params, mask) {
    return ajaxGet(path.getBarcodeImg, params, mask)
  },
  getRecordLockingList: function (params, mask) {
    return ajaxGet(path.getRecordLockingList, params, mask)
  },
  getRecordLockingDetail: function (params, mask) {
    return ajaxGet(path.getRecordLockingDetail, params, mask)
  },
  saveRecordLocking: function (data, mask) {
    return ajaxPost(path.saveRecordLocking, data, mask)
  },
  delRecordLocking: function (data, mask) {
    return ajaxPost(path.delRecordLocking, data, mask)
  },
  getReferenceModuleAuth: function (params, mask) {
    return ajaxGet(path.getReferenceModuleAuth, params, mask)
  },
  getSubSourceModules: function (params, mask) {
    return ajaxGet(path.getSubSourceModules, params, mask)
  },
  getSubSourceFields: function (params, mask) {
    return ajaxGet(path.getSubSourceFields, params, mask)
  },
  findDetailByName: function (data, mask) {
    return ajaxGet(path.findDetailByName, data, mask)
  },
  getDataAnalysisDetail: function (data, mask) {
    return ajaxGet(path.getDataAnalysisDetail, data, mask)
  },
  daGetModuleList: function (params, mask) {
    return ajaxGet(path.daGetModuleList, params, mask)
  },
  getSourceModules: function (params, mask) {
    return ajaxGet(path.getSourceModules, params, mask)
  },
  getSourceFields: function (params, mask) {
    return ajaxGet(path.getSourceFields, params, mask)
  },
  saveDataAnalysisLayout: function (data, mask) {
    return ajaxPost(path.saveDataAnalysisLayout, data, mask)
  },
  daGetDataAnalysisDetail: function (params, mask) {
    return ajaxGet(path.daGetDataAnalysisDetail, params, mask)
  },
  delDataAnalysis: function (data, mask) {
    return ajaxPost(path.delDataAnalysis, data, mask)
  },
  getDataAnalysisLayout: function (params, mask) {
    return ajaxGet(path.getDataAnalysisLayout, params, mask)
  },
  getDataAnalysisFilterFields: function (params, mask) {
    return ajaxGet(path.getDataAnalysisFilterFields, params, mask)
  },
  getDataAnalysisLeftMenuList: function (params, mask) {
    return ajaxGet(path.getDataAnalysisLeftMenuList, params, mask)
  },
  cacheDataAnalysisChart: function (data, mask) {
    return ajaxPost(path.cacheDataAnalysisChart, data, mask)
  },
  delDataAnalysisChartCache: function (data, mask) {
    return ajaxPost(path.delDataAnalysisChartCache, data, mask)
  },
  getDataAnalysisChartList: function (data, mask) {
    return ajaxGet(path.getDataAnalysisChartList, data, mask)
  },
  getDataAnalysisChartModuleList: function (data, mask) {
    return ajaxPost(path.getDataAnalysisChartModuleList, data, mask)
  },
  getDataAnalysisFilterFieldsOverall: function (data, mask) {
    return ajaxGet(path.getDataAnalysisFilterFieldsOverall, data, mask)
  },
  getDataAnalysisDetailSingle: function (data, mask) {
    return ajaxPost(path.getDataAnalysisDetailSingle, data, mask)
  },
  getDataAnalysisDetailFilter: function (data, mask) {
    return ajaxPost(path.getDataAnalysisDetailFilter, data, mask)
  },
  getChartLinkageFields: function (params, mask) {
    return ajaxGet(path.getChartLinkageFields, params, mask)
  },
  saveDataAnalysisLayoutSingle: function (params, mask) {
    return ajaxPost(path.saveDataAnalysisLayoutSingle, params, mask)
  },
  findSystemModuleList: function (data, mask) {
    return ajaxGet(path.findSystemModuleList, data, mask)
  },
  updateSystemData: function (data, mask) {
    return ajaxPost(path.updateSystemData, data, mask)
  },
  findBusinessConfigurationBackupList: function (data, mask) {
    return ajaxPost(path.findBusinessConfigurationBackupList, data, mask)
  },
  getBusinessConfigurationBackupDetail: function (data, mask) {
    return ajaxGet(path.getBusinessConfigurationBackupDetail, data, mask)
  },
  saveBusinessConfigurationBackup: function (data, mask) {
    return ajaxPost(path.saveBusinessConfigurationBackup, data, mask)
  },
  updateBusinessConfigurationBackup: function (data, mask) {
    return ajaxPost(path.updateBusinessConfigurationBackup, data, mask)
  },
  delBusinessConfigurationBackup: function (data, mask) {
    return ajaxPost(path.delBusinessConfigurationBackup, data, mask)
  },
  findIndividuationDetail: function (data, mask) {
    return ajaxGet(path.findIndividuationDetail, data, mask)
  },
  findIndividuationList: function (data, mask) {
    return ajaxGet(path.findIndividuationList, data, mask)
  },
  saveIndividuation: function (data, mask) {
    return ajaxPost(path.saveIndividuation, data, mask)
  },
  updateIndividuation: function (data, mask) {
    return ajaxPost(path.updateIndividuation, data, mask)
  },
  automatchFindAllModule: function (data, mask) {
    return ajaxGet(path.automatchFindAllModule, data, mask)
  },
  findAutoByBean: function (data, mask) {
    return ajaxGet(path.findAutoByBean, data, mask)
  },
  editRemind: function (data, mask) {
    return ajaxPost(path.editRemind, data, mask)
  },
  replacer: function (data, mask) {
    return ajaxGet(path.replacer, data, mask)
  },
  projectMemberDelete: function (data, mask) {
    return ajaxPost(path.projectMemberDelete, data, mask)
  },
  leftMenuSort: function (data, mask) {
    return ajaxPost(path.leftMenuSort, data, mask)
  },
  exportPdf: function (data, mask) {
    return ajaxPost(path.exportPdf, data, mask)
  },
  getDataAnalysisDataList: function (data, mask) {
    return ajaxPost(path.getDataAnalysisDataList, data, mask)
  },
  getDataAnalysisDataListFields: function (params, mask) {
    return ajaxGet(path.getDataAnalysisDataListFields, params, mask)
  },
  gettModuleListMerge: function (params, mask) {
    return ajaxGet(path.getDataAnalysisChartModuleListMerge, params, mask)
  },
  cancleQuote: function (data, mask) {
    return ajaxPost(path.cancleQuote, data, mask)
  },
  cancleShareRelation: function (data, mask) {
    return ajaxPost(path.cancleShareRelation, data, mask)
  },
  findTabList: function (data, mask) {
    return ajaxGet(path.findTabList, data, mask)
  },
  findListById: function (data, mask) {
    // return ajaxGet(path.findListById, data, mask)
    return ajaxPost(path.findListById, data, mask)
  },
  findExportList: function (data, mask) {
    return ajaxPost(path.findExportList, data, mask)
  },
  daFindAllModule: function (params, mask) {
    return ajaxGet(path.daFindAllModule, params, mask)
  },
  findFilterFieldsNew: function (params, mask) {
    return ajaxGet(path.findFilterFieldsNew, params, mask)
  },
  getReportPageDataList: function (params, mask) {
    return ajaxPost(path.getReportPageDataList, params, mask)
  },
  getPageInfo: function (params, mask) {
    return ajaxGet(path.getPageInfo, params, mask)
  },
  savePageInfo: function (params, mask) {
    return ajaxPost(path.savePageInfo, params, mask)
  },
  getDataAnalysisLayoutSingle: function (params, mask) {
    return ajaxGet(path.getDataAnalysisLayoutSingle, params, mask)
  },
  templateFindList: function (params, mask) {
    return ajaxGet(path.templateFindList, params, mask)
  },
  templateFindListFindList: function (params, mask) {
    return ajaxGet(path.templateFindListFindList, params, mask)
  },
  layoutFieldSave: function (params, mask) {
    return ajaxPost(path.layoutFieldSave, params, mask)
  },
  layoutFieldUpdateAll: function (params, mask) {
    return ajaxPost(path.layoutFieldUpdateAll, params, mask)
  },
  layoutTemplateSave: function (params, mask) {
    return ajaxPost(path.layoutTemplateSave, params, mask)
  },
  layoutTemplateFindDetail: function (params, mask) {
    return ajaxGet(path.layoutTemplateFindDetail, params, mask)
  },
  saveModulenew: function (params, mask) {
    return ajaxPost(path.saveModulenew, params, mask)
  },
  findReferenceMapping: function (params, mask) {
    return ajaxPost(path.findReferenceMapping, params, mask)
  },
  findOptionFieldRelyDetails: function (params, mask) {
    return ajaxGet(path.findOptionFieldRelyDetails, params, mask)
  },
  getWebformListForAdd: function (params, mask) {
    return ajaxGet(path.getWebformListForAdd, params, mask)
  },
  moduleMove: function (params, mask) {
    return ajaxPost(path.moduleMove, params, mask)
  },
  getCustomFunctionList: function (params, mask) {
    return ajaxGet(path.getCustomFunctionList, params, mask)
  },
  getCinternalFunctionList: function (params, mask) {
    return ajaxGet(path.getCinternalFunctionList, params, mask)
  },
  getOverallFilterType: function (params, mask) {
    return ajaxPost(path.getOverallFilterType, params, mask)
  },
  importEmployees: function (params, mask) {
    return ajaxPost(path.importEmployees, params, mask)
  },
  editPassWords: function (params, mask) {
    return ajaxPost(path.editPassWords, params, mask)
  },
  dataExportExcel: function (params, mask) {
    return ajaxGet(path.dataExportExcel, params, mask)
  },
  getPrivaryFields: function (params, mask) {
    return ajaxGet(path.getPrivaryFields, params, mask)
  },
  findRuleList: function (params, mask) {
    return ajaxGet(path.findRuleList, params, mask)
  },
  findRuleById: function (params, mask) {
    return ajaxGet(path.findRuleById, params, mask)
  },
  delRule: function (params, mask) {
    return ajaxPost(path.delRule, params, mask)
  },
  saveRule: function (params, mask) {
    return ajaxPost(path.saveRule, params, mask)
  },
  submitFindList: function (params, mask) {
    return ajaxGet(path.submitFindList, params, mask)
  },
  submitFindFieldsList: function (params, mask) {
    return ajaxGet(path.submitFindFieldsList, params, mask)
  },
  submitfindDetail: function (params, mask) {
    return ajaxGet(path.submitfindDetail, params, mask)
  },
  submitsave: function (params, mask) {
    return ajaxPost(path.submitsave, params, mask)
  },
  submitdel: function (params, mask) {
    return ajaxPost(path.submitdel, params, mask)
  },
  getWebformDataDetail: function (params, mask) {
    return ajaxGet(path.getWebformDataDetail, params, mask)
  },
  getWebformEnableLayout: function (params, mask) {
    return ajaxGet(path.getWebformEnableLayout, params, mask)
  },
  findRelationById: function (params, mask) {
    return ajaxGet(path.findRelationById, params, mask)
  },
  searchModules: function (params, mask) {
    return ajaxGet(path.searchModules, params, mask)
  },
  /**
   * 知识库
   */
  queryRepositoryClassificationList: function (params, mask) {
    return ajaxGet(path.queryRepositoryClassificationList, params, mask)
  },
  repositorySave: function (params, mask) {
    return ajaxPost(path.repositorySave, params, mask)
  },
  repositoryUpdate: function (params, mask) {
    return ajaxPost(path.repositoryUpdate, params, mask)
  },
  repositoryDel: function (params, mask) {
    return ajaxPost(path.repositoryDel, params, mask)
  },
  repositorySequencing: function (params, mask) {
    return ajaxPost(path.repositorySequencing, params, mask)
  },
  getRepositoryClassificationList: function (params, mask) {
    return ajaxGet(path.getRepositoryClassificationList, params, mask)
  },
  getClassLeftTreeList: function (params, mask) {
    return ajaxGet(path.getClassLeftTreeList, params, mask)
  },
  queryRepositoryLabelList: function (params, mask) {
    return ajaxGet(path.queryRepositoryLabelList, params, mask)
  },
  repositoryLabelSave: function (params, mask) {
    return ajaxPost(path.repositoryLabelSave, params, mask)
  },
  repositoryLabelUpdate: function (params, mask) {
    return ajaxPost(path.repositoryLabelUpdate, params, mask)
  },
  repositoryLabelSequencing: function (params, mask) {
    return ajaxPost(path.repositoryLabelSequencing, params, mask)
  },
  repositoryLabelDel: function (params, mask) {
    return ajaxPost(path.repositoryLabelDel, params, mask)
  },
  getRepositoryLabelList: function (params, mask) {
    return ajaxGet(path.getRepositoryLabelList, params, mask)
  },
  getDataAnalysisList: function (params, mask) {
    return ajaxGet(path.getDataAnalysisList, params, mask)
  },
  checkDataAnalysisAuth: function (params, mask) {
    return ajaxPost(path.checkDataAnalysisAuth, params, mask)
  },
  queryRepositoryLibrariess: function (params, mask) {
    return ajaxPost(path.queryRepositoryLibrariess, params, mask)
  },
  repositoryLibrariesSave: function (params, mask) {
    return ajaxPost(path.repositoryLibrariesSave, params, mask)
  },
  queryRepositoryLibrariesList: function (params, mask) {
    return ajaxPost(path.queryRepositoryLibrariesList, params, mask)
  },
  getRepositoryLibrariesDetail: function (params, mask) {
    return ajaxGet(path.getRepositoryLibrariesDetail, params, mask)
  },
  repositoryLibrariesUpdate: function (params, mask) {
    return ajaxPost(path.repositoryLibrariesUpdate, params, mask)
  },
  repositoryLibrariesDel: function (params, mask) {
    return ajaxPost(path.repositoryLibrariesDel, params, mask)
  },
  repositoryLibrariesLearning: function (params, mask) {
    return ajaxPost(path.repositoryLibrariesLearning, params, mask)
  },
  getReadLearningPersons: function (params, mask) {
    return ajaxGet(path.getReadLearningPersons, params, mask)
  },
  repositoryLibrariesPraise: function (params, mask) {
    return ajaxPost(path.repositoryLibrariesPraise, params, mask)
  },
  getPraisePersons: function (params, mask) {
    return ajaxGet(path.getPraisePersons, params, mask)
  },
  repositoryLibrariesCollection: function (params, mask) {
    return ajaxPost(path.repositoryLibrariesCollection, params, mask)
  },
  getCollectionPersons: function (params, mask) {
    return ajaxGet(path.getCollectionPersons, params, mask)
  },
  getRepositoryVersions: function (params, mask) {
    return ajaxGet(path.getRepositoryVersions, params, mask)
  },
  repositoryLibrariesMove: function (params, mask) {
    return ajaxPost(path.repositoryLibrariesMove, params, mask)
  },
  repositoryLibrariesTop: function (params, mask) {
    return ajaxPost(path.repositoryLibrariesTop, params, mask)
  },
  getDataDetailByVersionId: function (params, mask) {
    return ajaxGet(path.getDataDetailByVersionId, params, mask)
  },
  updateInvitePersonsToAnswer: function (params, mask) {
    return ajaxPost(path.updateInvitePersonsToAnswer, params, mask)
  },
  queryAssociatesByRepositoryId: function (params, mask) {
    return ajaxGet(path.queryAssociatesByRepositoryId, params, mask)
  },
  repositoryAnswerSave: function (params, mask) {
    return ajaxPost(path.repositoryAnswerSave, params, mask)
  },
  repositoryAnswerUpdate: function (params, mask) {
    return ajaxPost(path.repositoryAnswerUpdate, params, mask)
  },
  repositoryAnswerDel: function (params, mask) {
    return ajaxPost(path.repositoryAnswerDel, params, mask)
  },
  getRepositoryAnswerList: function (params, mask) {
    return ajaxGet(path.getRepositoryAnswerList, params, mask)
  },
  updatePlacedAtTheTop: function (params, mask) {
    return ajaxPost(path.updatePlacedAtTheTop, params, mask)
  },
  queryAssociatesByAnswerId: function (params, mask) {
    return ajaxGet(path.queryAssociatesByAnswerId, params, mask)
  },
  /** 知识库  END */
  sortTab: function (params, mask) {
    return ajaxPost(path.sortTab, params, mask)
  },
  getTeamfaceFlag: function (params, mask) {
    return ajaxGet(path.getTeamfaceFlag, params, mask)
  },
  findFieldsList: function (params, mask) {
    return ajaxGet(path.findFieldsList, params, mask)
  },
  getSubform: function (params, mask) {
    return ajaxGet(path.getSubform, params, mask)
  },
  findBatchUpdateFields: function (params, mask) {
    return ajaxGet(path.findBatchUpdateFields, params, mask)
  },
  batchUpdate: function (params, mask) {
    return ajaxPost(path.batchUpdate, params, mask)
  },
  getRefCorrespondingFields: function (params, mask) {
    return ajaxGet(path.getRefCorrespondingFields, params, mask)
  },
  getRefMappingFields: function (params, mask) {
    return ajaxGet(path.getRefMappingFields, params, mask)
  },
  getFieldSearching: function (params, mask) {
    return ajaxGet(path.getFieldSearching, params, mask)
  },
  getLinkageData: function (params, mask) {
    return ajaxGet(path.getLinkageData, params, mask)
  },
  copyModule: function (params, mask) {
    return ajaxPost(path.copyModule, params, mask)
  },
  findSubformMappingFieldsList: function (params, mask) {
    return ajaxGet(path.findSubformMappingFieldsList, params, mask)
  },
  findSubformMappingList: function (params, mask) {
    return ajaxGet(path.findSubformMappingList, params, mask)
  },
  delSubformMapping: function (params, mask) {
    return ajaxPost(path.delSubformMapping, params, mask)
  },
  saveSubformMapping: function (params, mask) {
    return ajaxPost(path.saveSubformMapping, params, mask)
  },
  findSubRelationDataList: function (params, mask) {
    return ajaxPost(path.findSubRelationDataList, params, mask)
  },
  findReferenceFormulaFields: function (params, mask) {
    return ajaxGet(path.findReferenceFormulaFields, params, mask)
  },
  queryTaskInfoByIds: function (params, mask) {
    return ajaxGet(path.queryTaskInfoByIds, params, mask)
  },
  resetAssignee: function (params, mask) {
    return ajaxPost(path.resetAssignee, params, mask)
  },
  saveNode: function (params, mask) {
    return ajaxPost(path.saveNode, params, mask)
  },
  updateNode: function (params, mask) {
    return ajaxPost(path.updateNode, params, mask)
  },
  deleteNode: function (params, mask) {
    return ajaxPost(path.deleteNode, params, mask)
  },
  copyNode: function (params, mask) {
    return ajaxPost(path.copyNode, params, mask)
  },
  moveNode: function (params, mask) {
    return ajaxPost(path.moveNode, params, mask)
  },
  enableOrDisableMileage: function (params, mask) {
    return ajaxPost(path.enableOrDisableMileage, params, mask)
  },
  saveTask: function (params, mask) {
    return ajaxPost(path.saveTask, params, mask)
  },
  updateTaskNew: function (params, mask) {
    return ajaxPost(path.updateTaskNew, params, mask)
  },
  getFieldTypeList: function (params, mask) {
    return ajaxGet(path.getFieldTypeList, params, mask)
  },
  sortNode: function (params, mask) {
    return ajaxPost(path.sortNode, params, mask)
  },
  batchSaveNode: function (params, mask) {
    return ajaxPost(path.batchSaveNode, params, mask)
  },
  moveTaskNew: function (params, mask) {
    return ajaxPost(path.moveTaskNew, params, mask)
  },
  queryTaskByParentNodeCode: function (params, mask) {
    return ajaxGet(path.queryTaskByParentNodeCode, params, mask)
  },
  saveFieldWidth: function (params, mask) {
    return ajaxPost(path.saveFieldWidth, params, mask)
  },
  findModulesList: function (params, mask) {
    return ajaxGet(path.findModulesList, params, mask)
  },
  previewApplication: function (params, mask) {
    return ajaxGet(path.previewApplication, params, mask)
  },
  queryTaskDynamicList: function (params, mask) {
    return ajaxGet(path.queryTaskDynamicList, params, mask)
  },
  getApprovalModules: function (params, mask) {
    return ajaxGet(path.getApprovalModules, params, mask)
  },
  transferCreator: function (params, mask) {
    return ajaxPost(path.transferCreator, params, mask)
  },
  queryProjectTaskList: function (params, mask) {
    return ajaxPost(path.queryProjectTaskList, params, mask)
  },
  queryPersonelTaskList: function (params, mask) {
    return ajaxPost(path.queryPersonelTaskList, params, mask)
  },
  saveGroup: function (params, mask) {
    return ajaxPost(path.saveGroup, params, mask)
  },
  deleteGroup: function (params, mask) {
    return ajaxPost(path.deleteGroup, params, mask)
  },
  queryProjectGroupList: function (params, mask) {
    return ajaxGet(path.queryProjectGroupList, params, mask)
  },
  saveProjectFields: function (params, mask) {
    return ajaxPost(path.saveProjectFields, params, mask)
  },
  getProjectFields: function (params, mask) {
    return ajaxGet(path.getProjectFields, params, mask)
  },
  removeLabels: function (params, mask) {
    return ajaxPost(path.removeLabels, params, mask)
  },
  updateTableColumn: function (params, mask) {
    return ajaxPost(path.updateTableColumn, params, mask)
  },
  resume_field: function (params, mask) {
    return ajaxGet(path.resume_field, params, mask)
  },
  batch_upload: function (params, mask) {
    return ajaxPost(path.batch_upload, params, mask, 3)
  },
  batch_pasre: function (params, mask) {
    return ajaxPost(path.batch_pasre, params, mask)
  },
  single_resume_upload: function (params, mask) {
    return ajaxPost(path.single_resume_upload, params, mask, 3)
  },
  checkAttendanceRelevanceTime: function (params, mask) {
    return ajaxPost(path.checkAttendanceRelevanceTime, params, mask)
  },
  queryEmailFieldData: function (params, mask) {
    return ajaxGet(path.queryEmailFieldData, params, mask)
  },
  shortMessageFindAllList: function (params, mask) {
    return ajaxPost(path.shortMessageFindAllList, params, mask)
  },
  shortMessageDetail: function (params, mask) {
    return ajaxPost(path.shortMessageDetail, params, mask)
  },
  shortMessageSave: function (params, mask) {
    return ajaxPost(path.shortMessageSave, params, mask)
  },
  shortMessageDelete: function (params, mask) {
    return ajaxPost(path.shortMessageDelete, params, mask)
  },
  autographFindAllList: function (params, mask) {
    return ajaxPost(path.autographFindAllList, params, mask)
  },
  autographSave: function (params, mask) {
    return ajaxPost(path.autographSave, params, mask)
  },
  autographDelete: function (params, mask) {
    return ajaxPost(path.autographDelete, params, mask)
  },
  autographList: function (params, mask) {
    return ajaxPost(path.autographList, params, mask)
  },
  messageRecordList: function (params, mask) {
    return ajaxPost(path.messageRecordList, params, mask)
  },
  messageRecordExport: function (params, mask) {
    return ajaxPost(path.messageRecordExport, params, mask)
  },
  messageTemplateList: function (params, mask) {
    return ajaxPost(path.messageTemplateList, params, mask)
  },
  getShortMessageSetting: function (params, mask) {
    return ajaxPost(path.getShortMessageSetting, params, mask)
  },
  shortMessageSettingSave: function (params, mask) {
    return ajaxPost(path.shortMessageSettingSave, params, mask)
  },
  getLinkageBatchData: function (params, mask) {
    return ajaxPost(path.getLinkageBatchData, params, mask)
  },
  getRelationFieldsForCustom: function (params, mask) {
    return ajaxGet(path.getRelationFieldsForCustom, params, mask)
  },
  getPersonInfo: function (params, mask) {
    return ajaxGet(path.getPersonInfo, params, mask)
  },
  queryPayrollList: function (params, mask) {
    return ajaxGet(path.queryPayrollList, params, mask)
  },
  getPayrollDetail: function (params, mask) {
    return ajaxPost(path.getPayrollDetail, params, mask)
  },
  querySalaryAccountingList: function (params, mask) {
    return ajaxPost(path.querySalaryAccountingList, params, mask)
  },
  queryPersonalTaxSpecialAdditionList: function (params, mask) {
    return ajaxGet(path.queryPersonalTaxSpecialAdditionList, params, mask)
  },
  queryAccountingPersonelList: function (params, mask) {
    return ajaxGet(path.queryAccountingPersonelList, params, mask)
  },
  saveSalaryAccounting: function (params, mask) {
    return ajaxPost(path.saveSalaryAccounting, params, mask)
  },
  updateSalaryAccountingStatus: function (params, mask) {
    return ajaxGet(path.updateSalaryAccountingStatus, params, mask)
  },
  delSalaryAccounting: function (params, mask) {
    return ajaxGet(path.delSalaryAccounting, params, mask)
  },
  updateAccountingPersonel: function (params, mask) {
    return ajaxPost(path.updateAccountingPersonel, params, mask)
  },
  deleteSalaryPer: function (params, mask) {
    return ajaxPost(path.deleteSalaryPer, params, mask)
  },
  findALLDeleteList: function (params, mask) {
    return ajaxGet(path.findALLDeleteList, params, mask)
  },
  addPerson: function (params, mask) {
    return ajaxPost(path.addPerson, params, mask)
  },
  savePersonalTaxSpecialAddition: function (params, mask) {
    return ajaxPost(path.savePersonalTaxSpecialAddition, params, mask)
  },
  delPersonalTaxSpecialAddition: function (params, mask) {
    return ajaxPost(path.delPersonalTaxSpecialAddition, params, mask)
  },
  querySchemeList: function (params, mask) {
    return ajaxGet(path.querySchemeList, params, mask)
  },
  querySalarySocialInsuranceList: function (params, mask) {
    return ajaxGet(path.querySalarySocialInsuranceList, params, mask)
  },
  getSocialInsuranceSetting: function (params, mask) {
    return ajaxGet(path.getSocialInsuranceSetting, params, mask)
  },
  updateSocialInsuranceSchemeSchemeUsers: function (params, mask) {
    return ajaxPost(path.updateSocialInsuranceSchemeSchemeUsers, params, mask)
  },
  checkSalaryAccountingDate: function (params, mask) {
    return ajaxPost(path.checkSalaryAccountingDate, params, mask)
  },
  synchronization: function (params, mask) {
    return ajaxPost(path.synchronization, params, mask)
  },
  individualTaxAccumulationImport: function (params, mask) {
    return ajaxGet(path.individualTaxAccumulationImport, params, mask)
  },
  publishSalaryAccounting: function (params, mask) {
    return ajaxPost(path.publishSalaryAccounting, params, mask)
  },
  deleteRemindProject: function (params, mask) {
    return ajaxPost(path.deleteRemindProject, params, mask)
  },
  deleteRepeatProject: function (params, mask) {
    return ajaxPost(path.deleteRepeatProject, params, mask)
  },
  deleteRemindPersonel: function (params, mask) {
    return ajaxPost(path.deleteRemindPersonel, params, mask)
  },
  deleteRepeatPersonel: function (params, mask) {
    return ajaxPost(path.deleteRepeatPersonel, params, mask)
  },
  saveButton: function (params, mask) {
    return ajaxPost(path.saveButton, params, mask)
  },
  findListButton: function (params, mask) {
    return ajaxGet(path.findListButton, params, mask)
  },
  findButton4ListPage: function (params, mask) {
    return ajaxGet(path.findButton4ListPage, params, mask)
  },
  findButton4DetailPage: function (params, mask) {
    return ajaxGet(path.findButton4DetailPage, params, mask)
  },
  findAllModuleByBean: function (params, mask) {
    return ajaxGet(path.findAllModuleByBean, params, mask)
  },
  saveCustomButton: function (params, mask) {
    return ajaxPost(path.saveCustomButton, params, mask)
  },
  getUserTicketToken: function (params, mask) {
    return ajaxPost(path.getUserTicketToken, params, mask)
  },

  // 薪酬后台
  queryRelationList: function (params, mask) {
    return ajaxGet(path.queryRelationList, params, mask)
  },
  saveRelation: function (params, mask) {
    return ajaxPost(path.saveRelation, params, mask)
  },
  deleteRelation: function (params, mask) {
    return ajaxPost(path.deleteRelation, params, mask)
  },
  saveScheme: function (params, mask) {
    return ajaxPost(path.saveScheme, params, mask)
  },
  deleteScheme: function (params, mask) {
    return ajaxPost(path.deleteScheme, params, mask)
  },
  updateSchemeAdmin: function (params, mask) {
    return ajaxPost(path.updateSchemeAdmin, params, mask)
  },
  querySchemeDetail: function (params, mask) {
    return ajaxGet(path.querySchemeDetail, params, mask)
  },
  updateSchemeRule: function (params, mask) {
    return ajaxPost(path.updateSchemeRule, params, mask)
  },
  queryAttendanceList: function (params, mask) {
    return ajaxGet(path.queryAttendanceList, params, mask)
  },
  saveAllowance: function (params, mask) {
    return ajaxPost(path.saveAllowance, params, mask)
  },
  delAllowance: function (params, mask) {
    return ajaxPost(path.delAllowance, params, mask)
  },
  queryAllowanceList: function (params, mask) {
    return ajaxGet(path.queryAllowanceList, params, mask)
  },
  saveAttendance: function (params, mask) {
    return ajaxPost(path.saveAttendance, params, mask)
  },
  delAttendnace: function (params, mask) {
    return ajaxPost(path.delAttendnace, params, mask)
  },
  saveSocialInsurance: function (params, mask) {
    return ajaxPost(path.saveSocialInsurance, params, mask)
  },
  saveSocialInsuranceScheme: function (params, mask) {
    return ajaxPost(path.saveSocialInsuranceScheme, params, mask)
  },
  delSocialInsuranceScheme: function (params, mask) {
    return ajaxPost(path.delSocialInsuranceScheme, params, mask)
  },
  querySocialInsuranceTemplateList: function (params, mask) {
    return ajaxGet(path.querySocialInsuranceTemplateList, params, mask)
  },
  querySalarySocialInsuranceDetail: function (params, mask) {
    return ajaxGet(path.querySalarySocialInsuranceDetail, params, mask)
  },
  getAttendanceItem: function (params, mask) {
    return ajaxGet(path.getAttendanceItem, params, mask)
  },
  findRlationsByBean: function (params, mask) {
    return ajaxGet(path.findRlationsByBean, params, mask)
  },
  saveBizflow: function (params, mask) {
    return ajaxPost(path.saveBizflow, params, mask)
  },
  getBizflow: function (params, mask) {
    return ajaxGet(path.getBizflow, params, mask)
  },
  getCurrentSections: function (params, mask) {
    return ajaxGet(path.getCurrentSections, params, mask)
  },
  updatePrincipal: function (params, mask) {
    return ajaxPost(path.updatePrincipal, params, mask)
  },
  dealRelation: function (params, mask) {
    return ajaxPost(path.dealRelation, params, mask)
  },
  dealApproval: function (params, mask) {
    return ajaxPost(path.dealApproval, params, mask)
  },
  stopBizflow: function (params, mask) {
    return ajaxGet(path.stopBizflow, params, mask)
  },
  restartBizflow: function (params, mask) {
    return ajaxGet(path.restartBizflow, params, mask)
  },
  resetBizflow: function (params, mask) {
    return ajaxPost(path.resetBizflow, params, mask)
  },
  getTaskData: function (params, mask) {
    return ajaxGet(path.getTaskData, params, mask)
  },
  getAprovalTasks: function (params, mask) {
    return ajaxGet(path.getAprovalTasks, params, mask)
  },
  updatePersonnelExec: function (params, mask) {
    return ajaxPost(path.updatePersonnelExec, params, mask)
  },
  getBeanFieldFilter: function (params, mask) {
    return ajaxGet(path.getBeanFieldFilter, params, mask)
  },
  findUserAttendanceGroup: function (params, mask) {
    return ajaxGet(path.findUserAttendanceGroup, params, mask)
  },
  setAdmin: function (params, mask) {
    return ajaxPost(path.setAdmin, params, mask)
  },
  getDataAnalysisListByApplicaion: function (params, mask) {
    return ajaxGet(path.getDataAnalysisListByApplicaion, params, mask)
  },
  getHomepage: function (params, mask) {
    return ajaxGet(path.getHomepage, params, mask)
  },
  delHomepage: function (params, mask) {
    return ajaxPost(path.delHomepage, params, mask)
  },
  saveHomepage: function (params, mask) {
    return ajaxPost(path.saveHomepage, params, mask)
  },
  getDataAnalysisListByModule: function (params, mask) {
    return ajaxGet(path.getDataAnalysisListByModule, params, mask)
  },
  refDataAnalysis: function (params, mask) {
    return ajaxPost(path.refDataAnalysis, params, mask)
  },
  delRefDataAnalysis: function (params, mask) {
    return ajaxPost(path.delRefDataAnalysis, params, mask)
  },
  getBackFields: function (params, mask) {
    return ajaxGet(path.getBackFields, params, mask)
  },
  dealGraphicRegn: function (params, mask) {
    return ajaxPost(path.dealGraphicRegn, params, mask)
  },
  dealPlugField: function (params, mask) {
    return ajaxPost(path.dealPlugField, params, mask)
  },
  queryRiskInfo: function (params, mask) {
    return ajaxGet(path.queryRiskInfo, params, mask)
  },
  delBizflow: function (params, mask) {
    return ajaxGet(path.delBizflow, params, mask)
  },
  getAllResetBizflow: function (params, mask) {
    return ajaxGet(path.getAllResetBizflow, params, mask)
  },
  getResetBizflow: function (params, mask) {
    return ajaxGet(path.getResetBizflow, params, mask)
  },
  getTaskData4Reset: function (params, mask) {
    return ajaxGet(path.getTaskData4Reset, params, mask)
  },
  getCurrentStatus: function (params, mask) {
    return ajaxGet(path.getCurrentStatus, params, mask)
  },
  findAllRefModule: function (params, mask) {
    return ajaxGet(path.findAllRefModule, params, mask)
  },

  getContractList: function (params, mask) {
    return ajaxGet(path.getContractList, params, mask)
  },
  editContract: function (params, mask) {
    return ajaxPost(path.editContract, params, mask)
  },
  getRenewList: function (params, mask) {
    return ajaxGet(path.getRenewList, params, mask)
  },
  getVersionList: function (params, mask) {
    return ajaxGet(path.getVersionList, params, mask)
  },
  calcpriceContract: function (params, mask) {
    return ajaxPost(path.calcpriceContract, params, mask)
  },
  createContractOrder: function (params, mask) {
    return ajaxPost(path.createContractOrder, params, mask)
  },
  getAllOrganizeSplit: function (params, mask) {
    return ajaxGet(path.getAllOrganizeSplit, params, mask)
  },
  saveOrganizeSplit: function (params, mask) {
    return ajaxPost(path.saveOrganizeSplit, params, mask)
  },
  delOrganizeSplit: function (params, mask) {
    return ajaxPost(path.delOrganizeSplit, params, mask)
  },
  getOrganizeSplitIndividual: function (params, mask) {
    return ajaxGet(path.getOrganizeSplitIndividual, params, mask)
  },
  saveOrUpdateOrganizeSplitIndividual: function (params, mask) {
    return ajaxPost(path.saveOrUpdateOrganizeSplitIndividual, params, mask)
  },
  saveAppInfoRemark: function (params, mask) {
    return ajaxPost(path.saveAppInfoRemark, params, mask)
  },
  saveRepetCheck: function (params, mask) {
    return ajaxPost(path.saveRepetCheck, params, mask)
  },
  checRepeatkDel: function (params, mask) {
    return ajaxPost(path.checRepeatkDel, params, mask)
  },
  findRepetCheckList: function (params, mask) {
    return ajaxGet(path.findRepetCheckList, params, mask)
  },
  findRepetCheckDetail: function (params, mask) {
    return ajaxGet(path.findRepetCheckDetail, params, mask)
  },
  getDataAnalysisListByCustomSetting: function (params, mask) {
    return ajaxGet(path.getDataAnalysisListByCustomSetting, params, mask)
  },
  getDataAnalysisListByCustomData: function (params, mask) {
    return ajaxGet(path.getDataAnalysisListByCustomData, params, mask)
  },
  saveCustomListSetting: function (params, mask) {
    return ajaxPost(path.saveCustomListSetting, params, mask)
  },
  getCustomListSetting: function (params, mask) {
    return ajaxGet(path.getCustomListSetting, params, mask)
  },
  reportSaveOperationRecord: function (params, mask) {
    return ajaxPost(path.reportSaveOperationRecord, params, mask)
  },
  approvalSaveOperationRecord: function (params, mask) {
    return ajaxPost(path.approvalSaveOperationRecord, params, mask)
  },
  printjournal: function (params, mask) {
    return ajaxPost(path.printjournal, params, mask)
  },
  importModuleTempate: function (params, mask) {
    return ajaxPost(path.importModuleTempate, params, mask)
  },
  saveDetailLayout: function (params, mask) {
    return ajaxPost(path.saveDetailLayout, params, mask)
  },
  getDetailLayoutBack: function (params, mask) {
    return ajaxGet(path.getDetailLayoutBack, params, mask)
  },
  layoutTemplateDel: function (params, mask) {
    return ajaxPost(path.layoutTemplateDel, params, mask)
  },
  dataembeddingpointSave: function (params, mask) {
    return ajaxPost(path.dataembeddingpointSave, params, mask)
  },
  findSubDataList: function (params, mask) {
    return ajaxPost(path.findSubDataList, params, mask)
  },
  getStartEndTime: function (params, mask) {
    return ajaxGet(path.getStartEndTime, params, mask)
  },
  getStartToEndLongTime: function (params, mask) {
    return ajaxPost(path.getStartToEndLongTime, params, mask)
  },
  savePay: function (params, mask) {
    return ajaxPost(path.savePay, params, mask, 2)
  },
  queryPay: function (params, mask) {
    return ajaxPost(path.queryPay, params, mask, 2)
  },
  getPayInfo: function (params, mask) {
    return ajaxGet(path.getPayInfo, params, mask)
  },
  createCustomerOrder: function (params, mask) {
    return ajaxPost(path.createCustomerOrder, params, mask, 2)
  },
  getDealFormula: function (params, mask) {
    return ajaxPost(path.getDealFormula, params, mask)
  },
  getCheckField: function (params, mask) {
    return ajaxPost(path.getCheckField, params, mask)
  },
  operateByCustom: function (params, mask) {
    return ajaxPost(path.operateByCustom, params, mask)
  },
  ownerOrAdmin: function (params, mask) {
    return ajaxGet(path.ownerOrAdmin, params, mask)
  },
  savePlugFields: function (params, mask) {
    return ajaxPost(path.savePlugFields, params, mask)
  },
  getPlugFields: function (params, mask) {
    return ajaxGet(path.getPlugFields, params, mask)
  },
  getCustomCompanyAiReport: function (params, mask) {
    return ajaxPost(path.getCustomCompanyAiReport, params, mask)
  },
  getCustomPersonelAiReport: function (params, mask) {
    return ajaxPost(path.getCustomPersonelAiReport, params, mask)
  },
  getCustomerAccessUserAi: function (params, mask) {
    return ajaxPost(path.getCustomerAccessUserAi, params, mask)
  },
  getCustomerAccessUser: function (params, mask) {
    return ajaxPost(path.getCustomerAccessUser, params, mask)
  },
  approvalPass: function (params, mask) {
    return ajaxPost(path.approvalPass, params, mask)
  },
  batchDownload: function (params, mask) {
    return ajaxPost(path.batchDownload, params, mask)
  },
  okrSaveData: function (params, mask) {
    return ajaxPost(path.okrSaveData, params, mask)
  },
  okrSaveKRData: function (params, mask) {
    return ajaxPost(path.okrSaveKRData, params, mask)
  },
  okrSaveReplay: function (params, mask) {
    return ajaxPost(path.okrSaveReplay, params, mask)
  },
  okrFindODataList: function (params, mask) {
    return ajaxPost(path.okrFindODataList, params, mask)
  },
  okrFindOSDataList: function (params, mask) {
    return ajaxPost(path.okrFindOSDataList, params, mask)
  },
  okrSelectObjectList: function (params, mask) {
    return ajaxPost(path.okrSelectObjectList, params, mask)
  },
  okrGetODataDetail: function (params, mask) {
    return ajaxGet(path.okrGetODataDetail, params, mask)
  },
  okrSaveTopObject: function (params, mask) {
    return ajaxPost(path.okrSaveTopObject, params, mask)
  },
  okrFindDemoList: function (params, mask) {
    return ajaxPost(path.okrFindDemoList, params, mask)
  },
  okrGetKRDataDetail: function (params, mask) {
    return ajaxGet(path.okrGetKRDataDetail, params, mask)
  },
  okrDelete: function (params, mask) {
    return ajaxPost(path.okrDelete, params, mask)
  },
  okrFindKRProgressList: function (params, mask) {
    return ajaxPost(path.okrFindKRProgressList, params, mask)
  },
  okrFindORDataList: function (params, mask) {
    return ajaxPost(path.okrFindORDataList, params, mask)
  },
  okrFindOProgressList: function (params, mask) {
    return ajaxPost(path.okrFindOProgressList, params, mask)
  },
  okrFindReplyList: function (params, mask) {
    return ajaxPost(path.okrFindReplyList, params, mask)
  },
  updateKeyResults: function (params, mask) {
    return ajaxPost(path.updateKeyResults, params, mask)
  },
  okrSaveObjectProgress: function (params, mask) {
    return ajaxPost(path.okrSaveObjectProgress, params, mask)
  },
  okrSaveKeyResultProgress: function (params, mask) {
    return ajaxPost(path.okrSaveKeyResultProgress, params, mask)
  },
  okrSaveKRProgressRecord: function (params, mask) {
    return ajaxPost(path.okrSaveKRProgressRecord, params, mask)
  },
  okrGetEmployeeNames: function (params, mask) {
    return ajaxGet(path.okrGetEmployeeNames, params, mask)
  },
  okrFindOP4Reply: function (params, mask) {
    return ajaxGet(path.okrFindOP4Reply, params, mask)
  },
  getReplyDetail: function (params, mask) {
    return ajaxGet(path.getReplyDetail, params, mask)
  },
  okrSaveAttachment: function (params, mask) {
    return ajaxPost(path.okrSaveAttachment, params, mask)
  },
  okrFindAttachmentList: function (params, mask) {
    return ajaxPost(path.okrFindAttachmentList, params, mask)
  },
  okrAddTask: function (params, mask) {
    return ajaxPost(path.okrAddTask, params, mask)
  },
  okrProjectExecutionList: function (params, mask) {
    return ajaxPost(path.okrProjectExecutionList, params, mask)
  },
  okrGetTaskDetail: function (params, mask) {
    return ajaxGet(path.okrGetTaskDetail, params, mask)
  },
  okrDeleteTask: function (params, mask) {
    return ajaxPost(path.okrDeleteTask, params, mask)
  },
  okrSaveRelation: function (params, mask) {
    return ajaxPost(path.okrSaveRelation, params, mask)
  },
  okrDeleteRelationn: function (params, mask) {
    return ajaxPost(path.okrDeleteRelationn, params, mask)
  },
  okrQueryRelationListyByTaskId: function (params, mask) {
    return ajaxGet(path.okrQueryRelationListyByTaskId, params, mask)
  },
  okrQueryTaskInfoByIds: function (params, mask) {
    return ajaxGet(path.okrQueryTaskInfoByIds, params, mask)
  },
  okrSaveRepeatTask: function (params, mask) {
    return ajaxPost(path.okrSaveRepeatTask, params, mask)
  },
  okrUpdateRepeatTask: function (params, mask) {
    return ajaxPost(path.okrUpdateRepeatTask, params, mask)
  },
  okrGetTaskRepeatList: function (params, mask) {
    return ajaxGet(path.okrGetTaskRepeatList, params, mask)
  },
  okrDeleteRepeat: function (params, mask) {
    return ajaxPost(path.okrDeleteRepeat, params, mask)
  },
  okrUpdateTaskPicklistStatus: function (params, mask) {
    return ajaxPost(path.okrUpdateTaskPicklistStatus, params, mask)
  },
  okrUpdateTaskCollaborator: function (params, mask) {
    return ajaxPost(path.okrUpdateTaskCollaborator, params, mask)
  },
  okrGetAllLayout: function (params, mask) {
    return ajaxGet(path.okrGetAllLayout, params, mask)
  },
  okrUpdateTask: function (params, mask) {
    return ajaxPost(path.okrUpdateTask, params, mask)
  },
  okrTaskAddPraise: function (params, mask) {
    return ajaxPost(path.okrTaskAddPraise, params, mask)
  },
  okrTaskCancelPraise: function (params, mask) {
    return ajaxPost(path.okrTaskCancelPraise, params, mask)
  },
  okrTaskQueryQuoteTask: function (params, mask) {
    return ajaxGet(path.okrTaskQueryQuoteTask, params, mask)
  },
  okrQueryCollaboratorList: function (params, mask) {
    return ajaxGet(path.okrQueryCollaboratorList, params, mask)
  },
  okrQueryBeRelationListyByTaskId: function (params, mask) {
    return ajaxGet(path.okrQueryBeRelationListyByTaskId, params, mask)
  },
  okrGetPraisePerson: function (params, mask) {
    return ajaxGet(path.okrGetPraisePerson, params, mask)
  },
  okrQuerySubTaskList: function (params, mask) {
    return ajaxGet(path.okrQuerySubTaskList, params, mask)
  },
  okrAddTaskRemind: function (params, mask) {
    return ajaxPost(path.okrAddTaskRemind, params, mask)
  },
  okrUpdateTaskRemind: function (params, mask) {
    return ajaxPost(path.okrUpdateTaskRemind, params, mask)
  },
  okrGetTaskRemind: function (params, mask) {
    return ajaxGet(path.okrGetTaskRemind, params, mask)
  },
  okrQueryTaskDynamicList: function (params, mask) {
    return ajaxPost(path.okrQueryTaskDynamicList, params, mask)
  },
  okrDeleteRemind: function (params, mask) {
    return ajaxPost(path.okrDeleteRemind, params, mask)
  },
  okrGetAllLayoutBack: function (params, mask) {
    return ajaxGet(path.okrGetAllLayoutBack, params, mask)
  },
  okrTaskCheckTask: function (params, mask) {
    return ajaxPost(path.okrTaskCheckTask, params, mask)
  },
  okrSaveAllLayout: function (params, mask) {
    return ajaxPost(path.okrSaveAllLayout, params, mask)
  },
  okrQueryAllStandaloneTask: function (params, mask) {
    return ajaxPost(path.okrQueryAllStandaloneTask, params, mask)
  },
  okrGetOKRCount: function (params, mask) {
    return ajaxPost(path.okrGetOKRCount, params, mask)
  },
  okrGetOKRRate: function (params, mask) {
    return ajaxPost(path.okrGetOKRRate, params, mask)
  },
  okrGetOKRDistribute: function (params, mask) {
    return ajaxPost(path.okrGetOKRDistribute, params, mask)
  },
  okrGetKRDistribute: function (params, mask) {
    return ajaxPost(path.okrGetKRDistribute, params, mask)
  },
  okrGetOKRRelateList: function (params, mask) {
    return ajaxPost(path.okrGetOKRRelateList, params, mask)
  },
  okrGetKRJobList: function (params, mask) {
    return ajaxPost(path.okrGetKRJobList, params, mask)
  },
  okrGetOKRNoprogress4Week: function (params, mask) {
    return ajaxPost(path.okrGetOKRNoprogress4Week, params, mask)
  },
  okrGetKRNoprogress4Week: function (params, mask) {
    return ajaxPost(path.okrGetKRNoprogress4Week, params, mask)
  },
  okrFindOKRDetailList: function (params, mask) {
    return ajaxPost(path.okrFindOKRDetailList, params, mask)
  },
  okrGetOKRNumber: function (params, mask) {
    return ajaxPost(path.okrGetOKRNumber, params, mask)
  },
  okrGetOKRAVGProgress: function (params, mask) {
    return ajaxPost(path.okrGetOKRAVGProgress, params, mask)
  },
  okrGetKRScoreDistribute: function (params, mask) {
    return ajaxPost(path.okrGetKRScoreDistribute, params, mask)
  },
  okrGetTaskPrivilege: function (params, mask) {
    return ajaxGet(path.okrGetTaskPrivilege, params, mask)
  },
  okrRemindMessager: function (params, mask) {
    return ajaxPost(path.okrRemindMessager, params, mask)
  },
  okrFindKRDataList: function (params, mask) {
    return ajaxPost(path.okrFindKRDataList, params, mask)
  },
  queryStandaloneTaskList: function (params, mask) {
    return ajaxPost(path.queryStandaloneTaskList, params, mask)
  },
  okrFindKRScoreList: function (params, mask) {
    return ajaxPost(path.okrFindKRScoreList, params, mask)
  },
  selectNoUpdateProgressNumberList: function (params, mask) {
    return ajaxPost(path.selectNoUpdateProgressNumberList, params, mask)
  },
  selectTaskReport: function (params, mask) {
    return ajaxPost(path.selectTaskReport, params, mask)
  },
  selectTaskReportList: function (params, mask) {
    return ajaxPost(path.selectTaskReportList, params, mask)
  },
  okrQueryQuoteTask: function (params, mask) {
    return ajaxGet(path.okrQueryQuoteTask, params, mask)
  },
  okrFindRelatedList: function (params, mask) {
    return ajaxPost(path.okrFindRelatedList, params, mask)
  },
  okrNoUpdateRemind: function (params, mask) {
    return ajaxPost(path.okrNoUpdateRemind, params, mask)
  },
  achievementTemplateList: function (params, mask) {
    return ajaxPost(path.achievementTemplateList, params, mask)
  },
  achievementTemplateDetail: function (params, mask) {
    return ajaxGet(path.achievementTemplateDetail, params, mask)
  },
  achievementTemplateSave: function (params, mask) {
    return ajaxPost(path.achievementTemplateSave, params, mask)
  },
  achievementTemplateUpdate: function (params, mask) {
    return ajaxPost(path.achievementTemplateUpdate, params, mask)
  },
  achievementTemplateDelete: function (params, mask) {
    return ajaxPost(path.achievementTemplateDelete, params, mask)
  },
  achievementTemplateState: function (params, mask) {
    return ajaxPost(path.achievementTemplateState, params, mask)
  },
  achievementTemplateLaunch: function (params, mask) {
    return ajaxPost(path.achievementTemplateLaunch, params, mask)
  },
  achievementRefTemplateSaveType: function (params, mask) {
    return ajaxPost(path.achievementRefTemplateSaveType, params, mask)
  },
  achievementRefTemplateTypeList: function (params, mask) {
    return ajaxGet(path.achievementRefTemplateTypeList, params, mask)
  },
  achievementRefTemplateSave: function (params, mask) {
    return ajaxPost(path.achievementRefTemplateSave, params, mask)
  },
  achievementRefTemplateDel: function (params, mask) {
    return ajaxPost(path.achievementRefTemplateDel, params, mask)
  },
  achievementRefTemplateList: function (params, mask) {
    return ajaxGet(path.achievementRefTemplateList, params, mask)
  },
  achievementRefTemplateDetail: function (params, mask) {
    return ajaxGet(path.achievementRefTemplateDetail, params, mask)
  },
  achievementManageList: function (params, mask) {
    return ajaxPost(path.achievementManageList, params, mask)
  },
  achievementSaveTagretType: function (params, mask) {
    return ajaxPost(path.achievementSaveTagretType, params, mask)
  },
  achievementSaveTagretLib: function (params, mask) {
    return ajaxPost(path.achievementSaveTagretLib, params, mask)
  },
  achievementTargetTypes: function (params, mask) {
    return ajaxGet(path.achievementTargetTypes, params, mask)
  },
  achievementTagretLib: function (params, mask) {
    return ajaxPost(path.achievementTagretLib, params, mask)
  },
  achievementSaveIndustry: function (params, mask) {
    return ajaxPost(path.achievementSaveIndustry, params, mask)
  },
  achievementSaveStation: function (params, mask) {
    return ajaxPost(path.achievementSaveStation, params, mask)
  },
  achievementSaveTargetTemplate: function (params, mask) {
    return ajaxPost(path.achievementSaveTargetTemplate, params, mask)
  },
  achievementSortIndustry: function (params, mask) {
    return ajaxPost(path.achievementSortIndustry, params, mask)
  },
  achievementSortStation: function (params, mask) {
    return ajaxPost(path.achievementSortStation, params, mask)
  },
  achievementSortTargetTemplate: function (params, mask) {
    return ajaxPost(path.achievementSortTargetTemplate, params, mask)
  },
  achievementIndustry: function (params, mask) {
    return ajaxGet(path.achievementIndustry, params, mask)
  },
  achievementStation: function (params, mask) {
    return ajaxGet(path.achievementStation, params, mask)
  },
  achievementTargetTemplate: function (params, mask) {
    return ajaxPost(path.achievementTargetTemplate, params, mask)
  },
  saveAchievsysTemplateType: function (params, mask) {
    return ajaxPost(path.saveAchievsysTemplateType, params, mask)
  },
  getAchievsysTemplateTypes: function (params, mask) {
    return ajaxGet(path.getAchievsysTemplateTypes, params, mask)
  },
  sortAchievsysTemplateType: function (params, mask) {
    return ajaxPost(path.sortAchievsysTemplateType, params, mask)
  },
  saveAchievsysTemplate: function (params, mask) {
    return ajaxPost(path.saveAchievsysTemplate, params, mask)
  },
  sortAchievsysTemplate: function (params, mask) {
    return ajaxPost(path.sortAchievsysTemplate, params, mask)
  },
  findAchievsysTemplate: function (params, mask) {
    return ajaxPost(path.findAchievsysTemplate, params, mask)
  },
  achievementManageLaunch: function (params, mask) {
    return ajaxPost(path.achievementManageLaunch, params, mask)
  },
  achievementManageDetail: function (params, mask) {
    return ajaxGet(path.achievementManageDetail, params, mask)
  },
  achievementManageDelete: function (params, mask) {
    return ajaxPost(path.achievementManageDelete, params, mask)
  },
  achievementManageRevoke: function (params, mask) {
    return ajaxPost(path.achievementManageRevoke, params, mask)
  },
  achievementManagePublish: function (params, mask) {
    return ajaxPost(path.achievementManagePublish, params, mask)
  },
  achievementManageAssessment: function (params, mask) {
    return ajaxPost(path.achievementManageAssessment, params, mask)
  },
  reLaunchAssessment: function (params, mask) {
    return ajaxPost(path.reLaunchAssessment, params, mask)
  },
  achievementManageUrging: function (params, mask) {
    return ajaxPost(path.achievementManageUrging, params, mask)
  },
  achievementRestartOutTime: function (params, mask) {
    return ajaxPost(path.achievementRestartOutTime, params, mask)
  },
  achievementUpdateVersionTemplate: function (params, mask) {
    return ajaxPost(path.achievementUpdateVersionTemplate, params, mask)
  },
  assessmentInfoList: function (params, mask) {
    return ajaxPost(path.assessmentInfoList, params, mask)
  },
  assessmentInfoExport: function (params, mask) {
    return ajaxPost(path.assessmentInfoExport, params, mask)
  },
  assessmentInfoDetail: function (params, mask) {
    return ajaxGet(path.assessmentInfoDetail, params, mask)
  },
  assessmentInfoUrging: function (params, mask) {
    return ajaxPost(path.assessmentInfoUrging, params, mask)
  },
  assessmentInfoAppeal: function (params, mask) {
    return ajaxPost(path.assessmentInfoAppeal, params, mask)
  },
  assessmentInfoPass: function (params, mask) {
    return ajaxPost(path.assessmentInfoPass, params, mask)
  },
  assessmentInfoReject: function (params, mask) {
    return ajaxPost(path.assessmentInfoReject, params, mask)
  },
  assessmentEvaluateList: function (params, mask) {
    return ajaxPost(path.assessmentEvaluateList, params, mask)
  },
  assessmentEvaluateUpdate: function (params, mask) {
    return ajaxPost(path.assessmentEvaluateUpdate, params, mask)
  },
  assessmentEvaluateNodeId: function (params, mask) {
    return ajaxGet(path.assessmentEvaluateNodeId, params, mask)
  },
  assessmentResetEvaluator: function (params, mask) {
    return ajaxPost(path.assessmentResetEvaluator, params, mask)
  },
  assessmentGoalsData: function (params, mask) {
    return ajaxPost(path.assessmentGoalsData, params, mask)
  },
  assessmentCompleteData: function (params, mask) {
    return ajaxPost(path.assessmentCompleteData, params, mask)
  },
  assessmentEvaluateRemind: function (params, mask) {
    return ajaxPost(path.assessmentEvaluateRemind, params, mask)
  },
  assessmentEvaluateScoreVal: function (params, mask) {
    return ajaxPost(path.assessmentEvaluateScoreVal, params, mask)
  },
  assessmentEvaluateAdjustNode: function (params, mask) {
    return ajaxPost(path.assessmentEvaluateAdjustNode, params, mask)
  },
  getAssessmentGradeList: function (params, mask) {
    return ajaxPost(path.getAssessmentGradeList, params, mask)
  },
  assessmentGradeSave: function (params, mask) {
    return ajaxPost(path.assessmentGradeSave, params, mask)
  },
  assessmentGradeUpdate: function (params, mask) {
    return ajaxPost(path.assessmentGradeUpdate, params, mask)
  },
  assessmentGradeDel: function (params, mask) {
    return ajaxPost(path.assessmentGradeDel, params, mask)
  },
  getAssessmentInfoList: function (params, mask) {
    return ajaxPost(path.getAssessmentInfoList, params, mask)
  },
  getAppraiseeNumberGroupByGrade: function (params, mask) {
    return ajaxPost(path.getAppraiseeNumberGroupByGrade, params, mask)
  },
  getAppraiseeNumberGroupByMonth: function (params, mask) {
    return ajaxPost(path.getAppraiseeNumberGroupByMonth, params, mask)
  },
  getAppraiseeNumberGroupByDepartment: function (params, mask) {
    return ajaxPost(path.getAppraiseeNumberGroupByDepartment, params, mask)
  },
  getAssessmentInfoTop: function (params, mask) {
    return ajaxPost(path.getAssessmentInfoTop, params, mask)
  },
  getAssessmentOKRList: function (params, mask) {
    return ajaxPost(path.getAssessmentOKRList, params, mask)
  },
  assessmentReportExport: function (params, mask) {
    return ajaxPost(path.assessmentReportExport, params, mask)
  },
  assessmentImproveList: function (params, mask) {
    return ajaxPost(path.assessmentImproveList, params, mask)
  },
  assessmentImproveInfo: function (params, mask) {
    return ajaxGet(path.assessmentImproveInfo, params, mask)
  },
  assessmentImproveSave: function (params, mask) {
    return ajaxPost(path.assessmentImproveSave, params, mask)
  },
  assessmentImproveUpdate: function (params, mask) {
    return ajaxPost(path.assessmentImproveUpdate, params, mask)
  },
  assessmentImproveDel: function (params, mask) {
    return ajaxPost(path.assessmentImproveDel, params, mask)
  },
  assessmentImprovePrivilege: function (params, mask) {
    return ajaxPost(path.assessmentImprovePrivilege, params, mask)
  },
  saveAchievementAdminSetting: function (params, mask) {
    return ajaxPost(path.saveAchievementAdminSetting, params, mask)
  },
  getAchievementAdminSetting: function (params, mask) {
    return ajaxGet(path.getAchievementAdminSetting, params, mask)
  },
  getAchievementAppealList: function (params, mask) {
    return ajaxPost(path.getAchievementAppealList, params, mask)
  },
  targetSaveKR: function (params, mask) {
    return ajaxPost(path.targetSaveKR, params, mask)
  },
  targetSaveRF: function (params, mask) {
    return ajaxPost(path.targetSaveRF, params, mask)
  },
  targetAdmin: function (params, mask) {
    return ajaxGet(path.targetAdmin, params, mask)
  },
  targetGetAdmin: function (params, mask) {
    return ajaxGet(path.targetGetAdmin, params, mask)
  },
  targetSaveLayout: function (params, mask) {
    return ajaxPost(path.targetSaveLayout, params, mask)
  },
  targetSave: function (params, mask) {
    return ajaxPost(path.targetSave, params, mask)
  },
  targetGetLayout: function (params, mask) {
    return ajaxGet(path.targetGetLayout, params, mask)
  },
  targetFindReferLS: function (params, mask) {
    return ajaxGet(path.targetFindReferLS, params, mask)
  },
  targetDelete: function (params, mask) {
    return ajaxPost(path.targetDelete, params, mask)
  },
  targetMerge: function (params, mask) {
    return ajaxPost(path.targetMerge, params, mask)
  },
  targetFindOList4Dep: function (params, mask) {
    return ajaxPost(path.targetFindOList4Dep, params, mask)
  },
  targetFindObjectiveLS: function (params, mask) {
    return ajaxPost(path.targetFindObjectiveLS, params, mask)
  },
  targetFindSolutionLS: function (params, mask) {
    return ajaxPost(path.targetFindSolutionLS, params, mask)
  },
  targetSaveSolution: function (params, mask) {
    return ajaxPost(path.targetSaveSolution, params, mask)
  },
  targetGetSolutionDetail: function (params, mask) {
    return ajaxGet(path.targetGetSolutionDetail, params, mask)
  },
  targetFindPerformanceLS: function (params, mask) {
    return ajaxPost(path.targetFindPerformanceLS, params, mask)
  },
  targetSavePerformance: function (params, mask) {
    return ajaxPost(path.targetSavePerformance, params, mask)
  },
  targetFindObjective4Role: function (params, mask) {
    return ajaxPost(path.targetFindObjective4Role, params, mask)
  },
  targetGetPerformance: function (params, mask) {
    return ajaxGet(path.targetGetPerformance, params, mask)
  },
  targetFindMyPerformanceLS: function (params, mask) {
    return ajaxPost(path.targetFindMyPerformanceLS, params, mask)
  },
  targetGetObjectiveKR: function (params, mask) {
    return ajaxGet(path.targetGetObjectiveKR, params, mask)
  },
  targetSortObjective: function (params, mask) {
    return ajaxGet(path.targetSortObjective, params, mask)
  },
  targetSelectObjectiveLS: function (params, mask) {
    return ajaxPost(path.targetSelectObjectiveLS, params, mask)
  },
  targetFindRecordLS: function (params, mask) {
    return ajaxPost(path.targetFindRecordLS, params, mask)
  },
  targetGetPerformanceCount: function (params, mask) {
    return ajaxPost(path.targetGetPerformanceCount, params, mask)
  },
  targetFindKRPerformanceLS: function (params, mask) {
    return ajaxPost(path.targetFindKRPerformanceLS, params, mask)
  },
  targetSaveMyPerformancet: function (params, mask) {
    return ajaxPost(path.targetSaveMyPerformancet, params, mask)
  },
  targetGetPerformancImprLS: function (params, mask) {
    return ajaxPost(path.targetGetPerformancImprLS, params, mask)
  },
  targetGetPerformanceTypeLS: function (params, mask) {
    return ajaxGet(path.targetGetPerformanceTypeLS, params, mask)
  },
  targetGetPerformanceImpl: function (params, mask) {
    return ajaxGet(path.targetGetPerformanceImpl, params, mask)
  },
  targetSavePerformanceType: function (params, mask) {
    return ajaxPost(path.targetSavePerformanceType, params, mask)
  },
  targetSavePerformanceImpr: function (params, mask) {
    return ajaxPost(path.targetSavePerformanceImpr, params, mask)
  },
  targetGetLeader: function (params, mask) {
    return ajaxGet(path.targetGetLeader, params, mask)
  },
  targetGetLayout4S: function (params, mask) {
    return ajaxGet(path.targetGetLayout4S, params, mask)
  },
  targetFindOLS4S: function (params, mask) {
    return ajaxPost(path.targetFindOLS4S, params, mask)
  },
  targetFindObjecitves4me: function (params, mask) {
    return ajaxPost(path.targetFindObjecitves4me, params, mask)
  },
  targetFindRoles: function (params, mask) {
    return ajaxGet(path.targetFindRoles, params, mask)
  },
  targetGetLeader4Role: function (params, mask) {
    return ajaxGet(path.targetGetLeader4Role, params, mask)
  },
  targetExportPerformance: function (params, mask) {
    return ajaxPost(path.targetExportPerformance, params, mask)
  },
  shareDataAnalysis: function (params, mask) {
    return ajaxPost(path.shareDataAnalysis, params, mask)
  },
  getDataDetailMeta: function (params, mask) {
    return ajaxPost(path.getDataDetailMeta, params, mask)
  },
  saveMapSetting: function (params, mask) {
    return ajaxPost(path.saveMapSetting, params, mask)
  },
  getMapSetting: function (params, mask) {
    return ajaxGet(path.getMapSetting, params, mask)
  },
  signupSaveData: function (params, mask) {
    return ajaxPost(path.signupSaveData, params, mask)
  },
  signupDeleteData: function (params, mask) {
    return ajaxPost(path.signupDeleteData, params, mask)
  },
  signupGetData: function (params, mask) {
    return ajaxGet(path.signupGetData, params, mask)
  },
  signupGetLinkList: function (params, mask) {
    return ajaxPost(path.signupGetLinkList, params, mask)
  },
  signupSaveLinkData: function (params, mask) {
    return ajaxPost(path.signupSaveLinkData, params, mask)
  },
  signupDeleteLinkData: function (params, mask) {
    return ajaxPost(path.signupDeleteLinkData, params, mask)
  },
  signupDisableOrEnable: function (params, mask) {
    return ajaxPost(path.signupDisableOrEnable, params, mask)
  },
  getSignupWebFromList: function (params, mask) {
    return ajaxPost(path.getSignupWebFromList, params, mask)
  },
  saveSignupCheckData: function (params, mask) {
    return ajaxPost(path.saveSignupCheckData, params, mask)
  },
  delSignupCheckData: function (params, mask) {
    return ajaxPost(path.delSignupCheckData, params, mask)
  },
  getSignupCheckData: function (params, mask) {
    return ajaxGet(path.getSignupCheckData, params, mask)
  },
  delSignupAllkData: function (params, mask) {
    return ajaxPost(path.delSignupAllkData, params, mask)
  },
  saveYxuntongData: function (params, mask) {
    return ajaxPost(path.saveYxuntongData, params, mask)
  },
  getYxuntongData: function (params, mask) {
    return ajaxGet(path.getYxuntongData, params, mask)
  },
  saveReplysettingData: function (params, mask) {
    return ajaxPost(path.saveReplysettingData, params, mask)
  },
  queryReplySettingList: function (params, mask) {
    return ajaxPost(path.queryReplySettingList, params, mask)
  },
  deleteReplySettingData: function (params, mask) {
    return ajaxPost(path.deleteReplySettingData, params, mask)
  },
  queryMassRecordList: function (params, mask) {
    return ajaxPost(path.queryMassRecordList, params, mask)
  },
  saveMassData: function (params, mask) {
    return ajaxPost(path.saveMassData, params, mask)
  },
  queryMassRecordDetailList: function (params, mask) {
    return ajaxPost(path.queryMassRecordDetailList, params, mask)
  },
  saveShortSendMessage: function (params, mask) {
    return ajaxPost(path.saveShortSendMessage, params, mask)
  },
  querySendMessageList: function (params, mask) {
    return ajaxGet(path.querySendMessageList, params, mask)
  },
  deleteSendMessage: function (params, mask) {
    return ajaxPost(path.deleteSendMessage, params, mask)
  },
  tokrSaveObject: function (params, mask) {
    return ajaxPost(path.tokrSaveObject, params, mask)
  },
  tokrSaveKR: function (params, mask) {
    return ajaxPost(path.tokrSaveKR, params, mask)
  },
  tokrGetObjectDetail: function (params, mask) {
    return ajaxGet(path.tokrGetObjectDetail, params, mask)
  },
  tokrGetKRDetail: function (params, mask) {
    return ajaxGet(path.tokrGetKRDetail, params, mask)
  },
  tokrDelete: function (params, mask) {
    return ajaxPost(path.tokrDelete, params, mask)
  },
  tokrFindODataList: function (params, mask) {
    return ajaxPost(path.tokrFindODataList, params, mask)
  },
  tokrFindRecordList: function (params, mask) {
    return ajaxPost(path.tokrFindRecordList, params, mask)
  },
  tokrFindProgressList: function (params, mask) {
    return ajaxPost(path.tokrFindProgressList, params, mask)
  },
  tokrUpdateProgress: function (params, mask) {
    return ajaxPost(path.tokrUpdateProgress, params, mask)
  },
  tokrGetEmployeeNames: function (params, mask) {
    return ajaxGet(path.tokrGetEmployeeNames, params, mask)
  },
  tokrSetting: function (params, mask) {
    return ajaxPost(path.tokrSetting, params, mask)
  },
  tokrGetSetting: function (params, mask) {
    return ajaxGet(path.tokrGetSetting, params, mask)
  },
  tokrUpdateKRs: function (params, mask) {
    return ajaxPost(path.tokrUpdateKRs, params, mask)
  },
  tokrUpdateOKRTopnum: function (params, mask) {
    return ajaxPost(path.tokrUpdateOKRTopnum, params, mask)
  },
  updateRealWorkingHours: function (params, mask) {
    return ajaxPost(path.updateRealWorkingHours, params, mask)
  },
  tokrFindShareOKRList: function (params, mask) {
    return ajaxPost(path.tokrFindShareOKRList, params, mask)
  },
  tokrSaveReplay: function (params, mask) {
    return ajaxPost(path.tokrSaveReplay, params, mask)
  },
  tokrGetReplyDetail: function (params, mask) {
    return ajaxGet(path.tokrGetReplyDetail, params, mask)
  },
  queryTaskDimensionDataByKrId: function (params, mask) {
    return ajaxGet(path.queryTaskDimensionDataByKrId, params, mask)
  },
  queryTaskRealWorkHoursByKrId: function (params, mask) {
    return ajaxGet(path.queryTaskRealWorkHoursByKrId, params, mask)
  },
  tokrFindReplyList: function (params, mask) {
    return ajaxPost(path.tokrFindReplyList, params, mask)
  },
  queryTaskRealWorkHoursByTaskId: function (params, mask) {
    return ajaxGet(path.queryTaskRealWorkHoursByTaskId, params, mask)
  },
  getBizDatas: function (params, mask) {
    return ajaxGet(path.getBizDatas, params, mask)
  },
  customSwimlaneChartStatusWaitDealFieldList: function (params, mask) {
    return ajaxPost(path.customSwimlaneChartStatusWaitDealFieldList, params, mask)
  },
  customSwimlaneChartStatusWaitDealFindDataList: function (params, mask) {
    return ajaxPost(path.customSwimlaneChartStatusWaitDealFindDataList, params, mask)
  },
  customSwimlaneChartStatusBeanList: function (params, mask) {
    return ajaxPost(path.customSwimlaneChartStatusBeanList, params, mask)
  },
  queryWaitDealList: function (params, mask) {
    return ajaxPost(path.queryWaitDealList, params, mask)
  },
  queryWaitDealTaskList: function (params, mask) {
    return ajaxPost(path.queryWaitDealTaskList, params, mask)
  },
  queryWaitDealAttendanceList: function (params, mask) {
    return ajaxPost(path.queryWaitDealAttendanceList, params, mask)
  },
  queryWaitDealBizflowList: function (params, mask) {
    return ajaxPost(path.queryWaitDealBizflowList, params, mask)
  },
  queryWaitDealApprovalList: function (params, mask) {
    return ajaxPost(path.queryWaitDealApprovalList, params, mask)
  },
  queryCustomSwimlaneChartStatusWaitDealForBack: function (params, mask) {
    return ajaxPost(path.queryCustomSwimlaneChartStatusWaitDealForBack, params, mask)
  },
  deleteCustomSwimlaneChartStatusWaitDealForBack: function (params, mask) {
    return ajaxPost(path.deleteCustomSwimlaneChartStatusWaitDealForBack, params, mask)
  },
  querySendMessageByBean: function (params, mask) {
    return ajaxGet(path.querySendMessageByBean, params, mask)
  },
  orgGetDisable: function (params, mask) {
    return ajaxGet(path.orgGetDisable, params, mask)
  },
  orgUpdateStatus: function (params, mask) {
    return ajaxPost(path.orgUpdateStatus, params, mask)
  },
  orgMergeMove: function (params, mask) {
    return ajaxPost(path.orgMergeMove, params, mask)
  },
  orgSaveSnapshot: function (params, mask) {
    return ajaxPost(path.orgSaveSnapshot, params, mask)
  },
  orgDelSnapshot: function (params, mask) {
    return ajaxPost(path.orgDelSnapshot, params, mask)
  },
  orgGetSnapshot: function (params, mask) {
    return ajaxGet(path.orgGetSnapshot, params, mask)
  },
  orgQueryAllSnapshot: function (params, mask) {
    return ajaxPost(path.orgQueryAllSnapshot, params, mask)
  },
  orgSaveSetting: function (params, mask) {
    return ajaxPost(path.orgSaveSetting, params, mask)
  },
  orgGetSetting: function (params, mask) {
    return ajaxGet(path.orgGetSetting, params, mask)
  },
  orgImport: function (params, mask) {
    return ajaxPost(path.orgImport, params, mask)
  },
  orgExportDepartment: function (params, mask) {
    return ajaxGet(path.orgExportDepartment, params, mask)
  },
  orgSaveDepartments: function (params, mask) {
    return ajaxPost(path.orgSaveDepartments, params, mask)
  },

  saveDutiesType: function (params, mask) {
    return ajaxPost(path.saveDutiesType, params, mask)
  },
  delDutiesType: function (params, mask) {
    return ajaxPost(path.delDutiesType, params, mask)
  },
  findDutiesType: function (params, mask) {
    return ajaxPost(path.findDutiesType, params, mask)
  },
  importDutiesType: function (params, mask) {
    return ajaxPost(path.importDutiesType, params, mask)
  },
  exportDutiesType: function (params, mask) {
    return ajaxGet(path.exportDutiesType, params, mask)
  },
  sortDutiesType: function (params, mask) {
    return ajaxPost(path.sortDutiesType, params, mask)
  },
  saveDuties: function (params, mask) {
    return ajaxPost(path.saveDuties, params, mask)
  },
  delDuties: function (params, mask) {
    return ajaxPost(path.delDuties, params, mask)
  },
  findDuties: function (params, mask) {
    return ajaxPost(path.findDuties, params, mask)
  },
  importDuties: function (params, mask) {
    return ajaxPost(path.importDuties, params, mask)
  },
  exportDuties: function (params, mask) {
    return ajaxGet(path.exportDuties, params, mask)
  },
  sortDuties: function (params, mask) {
    return ajaxPost(path.sortDuties, params, mask)
  },
  orgSaveEntity: function (params, mask) {
    return ajaxPost(path.orgSaveEntity, params, mask)
  },
  orgFindEntitys: function (params, mask) {
    return ajaxPost(path.orgFindEntitys, params, mask)
  },
  orgDelEntity: function (params, mask) {
    return ajaxGet(path.orgDelEntity, params, mask)
  },
  orgDownloadFile: function (params, mask) {
    return ajaxGet(path.orgDownloadFile, params, mask)
  },
  importPost: function (params, mask) {
    return ajaxPost(path.importPost, params, mask)
  },
  exportPost: function (params, mask) {
    return ajaxGet(path.exportPost, params, mask)
  },
  savePost: function (params, mask) {
    return ajaxPost(path.savePost, params, mask)
  },
  delPost: function (params, mask) {
    return ajaxPost(path.delPost, params, mask)
  },
  findPost: function (params, mask) {
    return ajaxPost(path.findPost, params, mask)
  },
  updatePostStatus: function (params, mask) {
    return ajaxPost(path.updatePostStatus, params, mask)
  },
  mergePost: function (params, mask) {
    return ajaxPost(path.mergePost, params, mask)
  },
  saveSequence: function (params, mask) {
    return ajaxPost(path.saveSequence, params, mask)
  },
  delSequence: function (params, mask) {
    return ajaxPost(path.delSequence, params, mask)
  },
  updateSequenceStatus: function (params, mask) {
    return ajaxPost(path.updateSequenceStatus, params, mask)
  },
  sortSequence: function (params, mask) {
    return ajaxPost(path.sortSequence, params, mask)
  },
  findSequence: function (params, mask) {
    return ajaxPost(path.findSequence, params, mask)
  },
  savePostLevel: function (params, mask) {
    return ajaxPost(path.savePostLevel, params, mask)
  },
  delPostLevel: function (params, mask) {
    return ajaxPost(path.delPostLevel, params, mask)
  },
  sortPostLevel: function (params, mask) {
    return ajaxPost(path.sortPostLevel, params, mask)
  },
  exportPostLevel: function (params, mask) {
    return ajaxGet(path.exportPostLevel, params, mask)
  },
  importPostLevel: function (params, mask) {
    return ajaxPost(path.importPostLevel, params, mask)
  },
  findPostLevel: function (params, mask) {
    return ajaxPost(path.findPostLevel, params, mask)
  },
  savePostGrade: function (params, mask) {
    return ajaxPost(path.savePostGrade, params, mask)
  },
  delPostGrade: function (params, mask) {
    return ajaxPost(path.delPostGrade, params, mask)
  },
  updatePostGradeStatus: function (params, mask) {
    return ajaxPost(path.updatePostGradeStatus, params, mask)
  },
  sortPostGrade: function (params, mask) {
    return ajaxPost(path.sortPostGrade, params, mask)
  },
  findPostGrade: function (params, mask) {
    return ajaxPost(path.findPostGrade, params, mask)
  },
  savePostSystem: function (params, mask) {
    return ajaxPost(path.savePostSystem, params, mask)
  },
  updatePostSystemStatus: function (params, mask) {
    return ajaxPost(path.updatePostSystemStatus, params, mask)
  },
  findPostSystem: function (params, mask) {
    return ajaxPost(path.findPostSystem, params, mask)
  },
  exportPostSystem: function (params, mask) {
    return ajaxGet(path.exportPostSystem, params, mask)
  },
  saveSalaryGrade: function (params, mask) {
    return ajaxPost(path.saveSalaryGrade, params, mask)
  },
  findSalaryGrade: function (params, mask) {
    return ajaxPost(path.findSalaryGrade, params, mask)
  },
  exportSalaryGrade: function (params, mask) {
    return ajaxGet(path.exportSalaryGrade, params, mask)
  },
  test01: function (params, mask) {
    return ajaxPost(path.test01, params, mask)
  },
  orgUpdateDepartmentShow: function (params, mask) {
    return ajaxPost(path.orgUpdateDepartmentShow, params, mask)
  },
  orgExportSnapshot: function (params, mask) {
    return ajaxPost(path.orgExportSnapshot, params, mask)
  },
  importIndividualIncomeTax: function (params, mask) {
    return ajaxPost(path.importIndividualIncomeTax, params, mask)
  },
  getAdAccountList: function (params, mask) {
    return ajaxPost(path.getAdAccountList, params, mask)
  },
  unbindAdAccount: function (params, mask) {
    return ajaxPost(path.unbindAdAccount, params, mask)
  },
  bindAdAccount: function (params, mask) {
    return ajaxPost(path.bindAdAccount, params, mask)
  },
  msal4jsample: function (params, mask) {
    return ajaxGet(path.msal4jsample, params, mask)
  },
  saveAllCustomButton: function (params, mask) {
    return ajaxPost(path.saveAllCustomButton, params, mask)
  },
  writelog: function (params, mask) {
    return ajaxPost(path.writelog, params, mask)
  },
  queryTreeFileList: function (params, mask) {
    return ajaxGet(path.queryTreeFileList, params, mask)
  },
  queryTreeFilePartList: function (params, mask) {
    return ajaxGet(path.queryTreeFilePartList, params, mask, '', 400)
  },
  queryTreeFolderInitDetail: function (params, mask) {
    return ajaxGet(path.queryTreeFolderInitDetail, params, mask)
  },
  editTreeFolder: function (params, mask) {
    return ajaxPost(path.editTreeFolder, params, mask)
  },
  savaTreeFileLibrary: function (params, mask) {
    return ajaxPost(path.savaTreeFileLibrary, params, mask)
  },
  delBtchFileLibrary: function (params, mask) {
    return ajaxPost(path.delBtchFileLibrary, params, mask)
  },
  shiftBatchFileLibrary: function (params, mask) {
    return ajaxPost(path.shiftBatchFileLibrary, params, mask)
  },
  queryAppTreeFileList: function (params, mask) {
    return ajaxGet(path.queryAppTreeFileList, params, mask)
  },
  viewTreeFolder: function (params, mask) {
    return ajaxPost(path.viewTreeFolder, params, mask)
  },
  saveDownLoadRole: function (params, mask) {
    return ajaxPost(path.saveDownLoadRole, params, mask)
  },
  delDownLoadRole: function (params, mask) {
    return ajaxPost(path.delDownLoadRole, params, mask)
  },
  getDownLoadRole: function (params, mask) {
    return ajaxGet(path.getDownLoadRole, params, mask)
  },
  getDownLoadRoleById: function (params, mask) {
    return ajaxGet(path.getDownLoadRoleById, params, mask)
  },
  getDownLoadRoleList: function (params, mask) {
    return ajaxGet(path.getDownLoadRoleList, params, mask)
  },
  queryWatermark: function (params, mask) {
    return ajaxGet(path.queryWatermark, params, mask)
  },
  updateIsWatermark: function (params, mask) {
    return ajaxPost(path.updateIsWatermark, params, mask)
  },
  getUserByRoleAndDepartment: function (params, mask) {
    return ajaxGet(path.getUserByRoleAndDepartment, params, mask)
  },
  blurCompanySearchFile: function (params, mask) {
    return ajaxGet(path.blurCompanySearchFile, params, mask)
  },
  ssoGetToken: function (params, mask) {
    return ajaxGet(path.ssoGetToken, params, mask)
  },
  queryCommonSignature: function (params, mask) {
    return ajaxGet(path.queryCommonSignature, params, mask)
  },
  saveNodeSignature: function (params, mask) {
    return ajaxPost(path.saveNodeSignature, params, mask)
  },
  isTaskDoingCustom: function (params, mask) {
    return ajaxGet(path.isTaskDoingCustom, params, mask)
  },
  logoutClearToken: function (params, mask) {
    return ajaxGet(path.logoutClearToken, params, mask)
  },
  manualUpdateShortUrl: function (params, mask) {
    // 批量手动生成短链
    return ajaxPost(path.manualUpdateShortUrl, params, mask)
  },
  autoApproveAnnualUser: function (params, mask) {
    // 当前年度参加【组团报名审批】且年度已审批通过的买家，则在当前年度参加【组团报名】时系统自动审批通过，无需在生成到【组团报名审批】
    return ajaxPost('signup/link/autoApproveAnnualUser', params, mask)
  },
  queryGroupSignUpData: function (params, mask) {
    // 华巨臣，通过批次号查询数据
    return ajaxPost('signup/link/queryGroupSignUpData', params, mask)
  },
  batchSaveGroupSignUpData: function (params, mask) {
    // 华巨臣，批量审批
    return ajaxPost('signup/link/batchSaveGroupSignUpData', params, mask)
  },
  modifyAccountEmail: function (params, mask) {
    // 账号邮箱变动接口
    return ajaxPost('user/modifyEmail', params, mask)
  },
  updateAutoflowModifyFields: function (params, mask) {
    // 保存布局后，如果下拉和复选的值有变化，需要触发
    return ajaxPost('layout/modifyFields', params, mask)
  },
  getProcessTaskStatus: function (params, mask) {
    return ajaxGet('workflow/getProcessTaskStatus', params, mask)
  },
  isDelTalentRateManager: function (params, mask) {
    // 判断人才发展，评估管理 被删除
    return ajaxPost('talentRateManager/isDelTalentRateManager', params, mask)
  },
  staffEmployeeGetCheckRateList: function (params, mask) {
    // 获取花名册员工详情中，人才发展-人才盘点
    return ajaxPost('employee/getCheckRateList', params, mask)
  },
  staffGetJobPromote: function (params, mask) {
    // 岗位晋升接口
    return ajaxPost('employee/getJobPromote', params, mask)
  },
  queryReportListByEID: function (params, mask) {
    // 获取人员的360评估和人才盘点列表
    return ajaxPost('employee/queryReportListByEID', params, mask)
  },
  /* *** 人员矩阵 START************************** */
  // 分页查询矩阵列表
  getMatrixList: function (params, mask) {
    return ajaxPost(path.getMatrixList, params, mask)
  },
  // 启用、停用矩阵
  changeMatrixStatus: function (params, mask) {
    return ajaxGet(path.changeMatrixStatus, params, mask)
  },
  // 矩阵引用查询
  queryMatrixReference: function (params, mask) {
    return ajaxGet(path.queryMatrixReference, params, mask)
  },
  // 删除矩阵
  delMatrix: function (params, mask) {
    return ajaxPost(`${path.delMatrix}/${params.id}`, params, mask)
  },
  // 获取新矩阵编码
  getNextCode: function (params, mask) {
    return ajaxGet(path.getNextCode, params, mask)
  },
  // 新增矩阵
  addMatrix: function (params, mask) {
    return ajaxPost(path.addMatrix, params, mask)
  },
  // 查询岗位列表
  getJobMaintenance: function (params, mask) {
    return ajaxPost(path.getJobMaintenance, params, mask)
  },
  // 获取新岗位编码
  getPostNextCode: function (params, mask) {
    return ajaxGet(path.getPostNextCode, params, mask)
  },
  // 新增岗位
  addMatrixPost: function (params, mask) {
    return ajaxPost(path.addMatrixPost, params, mask)
  },
  // 修改岗位
  updateMatrixPost: function (params, mask) {
    return ajaxPost(path.updateMatrixPost, params, mask)
  },
  // 删除岗位
  delMatrixPost: function (params, mask) {
    return ajaxPost(path.delMatrixPost, params, mask)
  },
  // 导出岗位列表
  exportMatrixPost: function (params, mask) {
    return ajaxPost(path.exportMatrixPost, params, mask)
  },
  // 获取岗位下拉列表
  getMatrixPostDropDownList: function (params, mask) {
    return ajaxGet(path.getMatrixPostDropDownList, params, mask)
  },
  // 获取映射关系列表
  getMatrixMappingList: function (params, mask) {
    return ajaxPost(path.getMatrixMappingList, params, mask)
  },
  // 导入映射关系
  uploadMatrixMappingTemplate: function (params, mask) {
    return ajaxPost(path.uploadMatrixMappingTemplate, params, mask)
  },
  // 导出映射关系
  exportMatrixMapping: function (params, mask) {
    return ajaxPost(path.exportMatrixMapping, params, mask)
  },
  // 同步替换下级
  syncSubordinat: function (params, mask) {
    return ajaxPost(path.syncSubordinat, params, mask)
  },
  // 保存单格岗位映射人员
  saveMappingCell: function (params, mask) {
    return ajaxPost(path.saveMappingCell, params, mask)
  },
  // 删除单格映射关系
  delMatrixMapping: function (params, mask) {
    return ajaxGet(path.delMatrixMapping, params, mask)
  },
  // 获取矩阵下拉列表
  getMatrixDropDownList: function (params, mask) {
    return ajaxGet(path.getMatrixDropDownList, params, mask)
  },
  /* *** 人员矩阵 END  ************************** */
  ...attenQuery,
  ...statisticAnalysis // 数据分析
}
export {
  HTTPServer,
  baseURL,
  wsURL,
  ajaxGetRequest,
  ajaxPostRequest,
  cloudURL,
  fileURL,
  downLoadRequest,
  integrationUrl,
  ajaxPost,
  ajaxGet
}
